<script src="<%= BASE_URL %>plugins/jquery/jquery-3.6.0.min.js"></script>
<script src="<%= BASE_URL %>css/OCDocPendiente.css"></script>
<template>
  <div>
    <DxLoadPanel
      :visible="loadingVisible"
      :show-indicator="showIndicator"
      :show-pane="showPane"
      :shading="shading"
      :close-on-outside-click="closeOnOutsideClick"
      :on-shown="onShown"
      :on-hidden="onHidden"
      shading-color="rgba(0,0,0,0.4)"
    />
    <div v-if="showUploadProgress" class="cc-progress-overlay">
      <div class="cc-progress-card">
        <p class="cc-progress-label">Subiendo archivo... <strong>{{ uploadProgress }}%</strong></p>
        <div class="cc-progress-track">
          <div class="cc-progress-fill" :style="{ width: uploadProgress + '%' }"></div>
        </div>
      </div>
    </div>
    <section class="content-header custom-header">
			<h1>{{LangSelected.Interno.OCDocPendiente.Titulo}}<span @click="modoDebug" style="display:none;"></span> <button type="button"  class="btn btn-warning" style="float: right; font-size: 0.5em !important;  margin-right: 10px; text-decoration: underline; color: rgb(255, 255, 255);padding: 0px 10px 3px 10px;" v-b-modal.modal-6>{{LangSelected.Interno.OCDocPendiente.ComoCargo}}</button></h1>
		</section>
    <section class="content container-fluid">
      <div class="box">
        <div class="form-horizontal">
          <div class="box-body">
            <form>
            <DxButton text="Click me" v-if="0" @click="sayHelloWorld" style="margin-bottom:10px;"/>
            <DxDataGrid
              id="gridOrdenesCompra"
              :data-source="OrdenesCompra"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :column-auto-width="true"
              :show-borders="true"
              key-expr="Id_OrdenCompra"
            >
              <DxColumnChooser :enabled="false"/>
              <DxColumnFixing :enabled="true"/>
              <DxFilterRow :visible="true"/>
              <DxPaging :page-size="13"/>
              <DxEditing
                :allow-updating="true"
                mode="cell"
              />
              <DxPager
                :show-page-size-selector="true"
                :allowed-page-sizes="[]"
              />
              <DxColumn
                :caption="LangSelected.Interno.OCDocPendiente.OC"
                data-field="OC"
                alignment="left"
                :allow-editing="false"
              />
              <DxColumn
                :caption="LangSelected.Interno.OCDocPendiente.Contrato"
                data-field="Contrato"
                alignment="left"
                :allow-editing="false"
              />
              <DxColumn
                :caption="LangSelected.Interno.OCDocPendiente.FechaOC"
                data-field="FechaOC"
                alignment="center"
                :allow-editing="false"
              />
              <DxColumn :caption="LangSelected.Interno.OCDocPendiente.PorEnviar" alignment="center">
                <DxColumn
                  :caption="LangSelected.Interno.OCDocPendiente.Certificados"
                  data-field="CertificadosPorEnviar"
                  alignment="center"
                  :allow-editing="false"
                />
                <DxColumn
                  :caption="LangSelected.Interno.OCDocPendiente.Soportes"
                  data-field="SoportesPorEnviar"
                  alignment="center"
                  :allow-editing="false"
                />
                <DxColumn
                  :caption="LangSelected.Interno.OCDocPendiente.Facturas"
                  data-field="FacturasPorEnviar"
                  alignment="center"
                  :allow-editing="false"
                />
              </DxColumn>
              <DxColumn
                class="accion"
                :caption="LangSelected.Interno.OCDocPendiente.Accion"
                data-field="DropDown"
                alignment="center"
                :width="125"
                :allow-filtering="false"
                :allow-editing="false"
                cell-template="cellTemplate"
              />
              <DxColumn
                :calculate-cell-value="calculateCellValue"
                caption="Employee"
                :visible="false"
                :allow-editing="false"
              />
              <template #cellTemplate={data}>
                <DxSelectBox
                  :id="'accion_id_'+data.data.Id_OrdenCompra"
                  class="selector_action"
                  :data-source="Acciones"
                  value-expr="Id_ClasificacionTipoDocumentacion"
                  display-expr="ClasificacionTipoDocumentacion"
                  :value="0"
                  @value-changed="onChange(data,$event)"
                />
              </template>
            </DxDataGrid>
            </form>
            <button type="button" class="btn btn-warning" style="font-size: 0.9em !important;  margin-right: 10px; text-decoration: underline; color: rgb(255, 255, 255);padding: 0px 10px 3px 10px;" v-b-modal.modal-7>{{LangSelected.Interno.OCDocPendiente.BuscarOC}}</button>
          </div>
        </div>
      </div>
    </section>
    <b-modal id="modal-1" ref="modal-1" :title=HeaderFacturasModal size="lg" button-size="sm" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <div class="row">
							<div class="form-group col-sm-12 col-md-8 col-xs-12 col-lg-8" style="margin-bottom: 0px;">
								<span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.RFCRecept}}</span>
								<div class="col-sm-7">
                  <div class="value">
                    <DxTextBox
                      v-model="RFCS"
                      :max-length="40"
                      value-change-event="keyup"
                      :disabled="true"
                    />
                  </div>
								</div>
							</div>
							<div class="form-group col-sm-12 col-md-4 col-xs-12 col-lg-4" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.Moneda}}</span>
								<div class="col-sm-8">
                  <DxTextBox
                    class="align-right"
                    v-model="txtId_Moneda"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
							</div>
						</div>
						<div class="row">
							<div class="form-group col-sm-12 col-md-8 col-xs-12 col-lg-8" style="margin-bottom: 0px;">
								<span class="col-sm-3 span-label" style="padding-top: 0px; padding-right: 0px !important;" :title="LangSelected.Interno.OCDocPendiente.FechaReqSitio">{{LangSelected.Interno.OCDocPendiente.FechaReqSitio}}</span>
								<div class="col-sm-7">
									<DxTextBox
                    v-model="txtFechaReqEnSitio"
                    :max-length="40"
                    title="Fecha Requerida en Sitio"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
							</div>
							<div class="form-group col-sm-12 col-md-4 col-xs-12 col-lg-4" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.Subtotal}}</span>
								<div class="col-sm-8">
									<DxTextBox
                    class="align-right"
                    v-model="txtSubtotal"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
							</div>
						</div>
						<div class="row">
							<div class="form-group col-sm-12 col-md-8 col-xs-12 col-lg-8" style="margin-bottom: 0px;">
								<span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.Comprador}}</span>
								<div class="col-sm-7">
									<DxTextBox
                    v-model="txtNombreComprador"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
							</div>
							<div class="form-group col-sm-12 col-md-4 col-xs-12 col-lg-4" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.Impuestos}}</span>
								<div class="col-sm-8">
									<DxTextBox
                    class="align-right"
                    v-model="txtImpuestos"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
							</div>
						</div>
						<div class="row">
							<div class="form-group col-sm-12 col-md-8 col-xs-12 col-lg-8" style="margin-bottom: 0px;">
								<span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.Activador}}</span>
								<div class="col-sm-7">
									<DxTextBox
                    v-model="txtActivador"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
							</div>
							<div class="form-group col-sm-12 col-md-4 col-xs-12 col-lg-4" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.Retenidos}}</span>
								<div class="col-sm-8">
                  <DxNumberBox
                    class="align-right"
                    v-model="txtRetenidos"
                    format="$ #,##0.##"
                    :disabled="true"
                    :min="0"
                    :show-spin-buttons="false"
                    :show-clear-button="false"
                  />
								</div>
							</div>
						</div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-8 col-xs-12 col-lg-8" style="margin-bottom: 0px;">
								<span class="col-sm-12 span-label" style="padding-top: 0px;">&nbsp;</span>
							</div>
							<div class="form-group col-sm-12 col-md-4 col-xs-12 col-lg-4" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.Total}}</span>
								<div class="col-sm-8">
                  <DxNumberBox
                    class="align-right"
                    v-model="txtTotal"
                    format="$ #,##0.##"
                    :disabled="true"
                    :min="0"
                    :show-spin-buttons="false"
                    :show-clear-button="false"
                  />
								</div>
							</div>
            </div>
            <div class="row" style="margin-top:10px;">
							<div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <DxDataGrid
                  id="gridContainer"
                  :data-source="EnvioFacturas"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  key-expr="Id"
                >
                  <DxColumnChooser :enabled="false"/>
                  <DxColumnFixing :enabled="true"/>
                  <DxFilterRow :visible="false"/>
                  <!--<DxPaging :page-size="6"/>-->
                  <!--<DxPager
                    :show-page-size-selector="true"
                    :allowed-page-sizes="[6, 10, 20]"
                  />-->
                  <DxColumn
                    :caption="LangSelected.Interno.OCDocPendiente.Concepto"
                    data-field="HitoDePago"
                    alignment="left"
                    :allow-editing="false"
                  />
                  <DxColumn
                    caption="%"
                    data-field="Porcentaje"
                    data-type="number"
                    alignment="center"
                    :allow-editing="false"
                    :width="40"
                  />
                  <DxColumn
                    :caption="LangSelected.Interno.OCDocPendiente.MontoConImpuestos"
                    header-cell-template="title-header"
                    data-field="MontoHito"
                    data-type="number"
                    format="currency"
                    alignment="right"
                    :width="100"
                    :allow-editing="false"
                  />
                  
                  <!--<DxColumn
                    caption="Folio Recepción"
                    data-field="FolioRecepcion"
                    data-type="text"
                    alignment="center"
                    :width="150"
                    :allow-editing="false"
                  />
                  <DxColumn
                    caption="Fecha"
                    data-field="FechaRecepcion"
                    data-type="text"
                    alignment="center"
                    :width="100"
                    :allow-editing="false"
                  />-->
                  <!--<DxColumn
                    caption="Recibido"
                    data-field="Recibido"
                    data-type="number"
                    format="currency"
                    alignment="right"
                    :width="100"
                    :allow-editing="false"
                  />
                  <DxColumn
                    caption="Remisión sin Factura"
                    data-field="Remision"
                    data-type="number"
                    format="currency"
                    alignment="right"
                    :width="100"
                    :allow-editing="false"
                  />-->
                  <DxColumn
                    :caption="LangSelected.Interno.OCDocPendiente.TotalRemision"
                    header-cell-template="title-header"
                    data-field="Remision"
                    data-type="number"
                    format="currency"
                    alignment="right"
                    :width="100"
                    :allow-editing="false"
                  />
                  <DxColumn
                    :caption="LangSelected.Interno.OCDocPendiente.Facturado"
                    data-field="Facturado"
                    data-type="number"
                    format="currency"
                    alignment="right"
                    :width="100"
                    :allow-editing="false"
                  />
                  <DxColumn
                    :caption="LangSelected.Interno.OCDocPendiente.PorFacturar"
                    data-field="PorFacturar"
                    data-type="number"
                    format="currency"
                    alignment="right"
                    :width="100"
                    :allow-editing="false"
                  />
                  <DxColumn
                    :caption="LangSelected.Interno.OCDocPendiente.Factura"
                    data-field="BotonVisible"
                    alignment="center"
                    :width="100"
                    :allow-filtering="false"
                    cell-template="cellTemplate"
                  />
                  <template #title-header="{ data }">
                      <span v-html="data.column.caption"></span>
                  </template>
                  <template #cellTemplate={data}>
                    <span class="button-span-subir" v-if="data.data.PorFacturarNumerico!=0 || (data.data.MensajeErrorSubir||'').trim()!=''" @click="onSubirClick(data)">{{ LangSelected.Interno.OCDocPendiente.Subir }}</span>
                    <span class="button-span-subir" v-else style="opacity: .5;pointer-events: none;">{{ LangSelected.Interno.OCDocPendiente.Subir }}</span>
                  </template>
                </DxDataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="">
        <b-button size="sm" variant="secondary" @click="RefreshFirstList()">
          Cerrar
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-2" ref="modal-2" :title=HeaderFacturasModal size="xl" button-size="sm" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
							<div class="form-group col-sm-12 col-md-4 col-xs-12 col-lg-4" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;padding-right: 0px;">Total OC:</span>
								<div class="col-sm-7">
                  <div class="value">
                    <DxTextBox
                      class="align-right"
                      v-model="Totaltxt"
                      :max-length="40"
                      value-change-event="keyup"
                      :disabled="true"
                      alignment="right"
                    />
                  </div>
								</div>
							</div>
							<div class="form-group col-sm-12 col-md-8 col-xs-12 col-lg-8" style="margin-bottom: 0px;">
								<span class="col-sm-2 span-label" style="padding-top: 0px;">Hito:</span>
								<div class="col-sm-3" style="padding:0px;">
                  <DxTextBox
                    v-model="Hitotxt"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
                <div class="col-sm-2">
                  <DxTextBox
                    class="align-right"
                    v-model="Porcentajetxt"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
                <div class="col-sm-2">
                  <span>&nbsp;</span>
                </div>
                <div class="col-sm-3" style="padding-left:0px">
                  <DxNumberBox
                    :disabled="true"
                    v-model="TotalPorcentajetxt"
                    class="align-right"
                    :max-length="40"
                    value-change-event="keyup"
                    format="$ #,##0.##"
                  />
								</div>
							</div>
						</div>
            <div class="row" v-show="EsLlegadaASitio==1"><!-- && TotalesConImpuesto[0].RemisionNumerico==0-->
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <p style="margin: 0px auto; padding: 3px 0px; text-align: center; background: transparent; width: 99.9%; font-size: 14px; font-weight: bold; color: red;font-family: 'Helvetica Neue','Segoe UI',Helvetica,Verdana,sans-serif;">
                  FAVOR DE SELECCIONAR LAS ENTRADAS QUE AMPARAN EL MONTO EXACTO DE LA FACTURA
                </p>
              </div>
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <p style="margin: 0px auto;padding: 3px 0px 3px 0px;text-align: center;background: #e6e6e6;border: solid thin #aaa;border-bottom: none;width: 99.9%;font-size: 12px;font-family: 'Helvetica Neue','Segoe UI',Helvetica,Verdana,sans-serif;font-weight: bold;color: #555;">
                  ENTRADAS DE MATERIALES Y/O SERVICIOS <!-- {{EsLlegadaASitio}} -->
                </p>
              </div>
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <DxDataGrid
                  id="gridPopUpContainer_Entradas"
                  :ref="dataGridRefEntradas"
                  :selected-row-keys="selectedRowKeysEntradas"
                  :data-source="EntradasFactura"
                  :allow-column-resizing="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  key-expr="ID"
                  @selection-changed="onSelectionChangedEntradas"
                  @row-prepared="onRowPreparedEntradas"
                >
                  <!--<DxEditing
                    caption="Recibido"
                    :allow-updating="true"
                    mode="cell"
                    on
                  />-->
                  <DxSelection :deferred="true" mode="multiple" width="10px" />
                  <!--<DxColumn 
                    caption="Fecha<br>Recibido"
                    header-cell-template="title-header-html"
                    data-field="FechaRecibido"
                    alignment="center"
                    :width="90"
                  />-->
                  <DxColumn 
                    caption="Num. Doc.<br>Entrada"
                    header-cell-template="title-header-html"
                    data-field="NumDocEntrada"
                    alignment="center"
                    :width="80"
                  />
                  <DxColumn 
                    caption="Pos.<br>OC"
                    header-cell-template="title-header-html"
                    data-field="Posicion"
                    alignment="center"
                    data-type="number"
                    :width="35"
                  />
                  <DxColumn 
                    caption="Codigo<br>SAP"
                    header-cell-template="title-header-html"
                    data-field="CodigoSAP"
                    alignment="center"
                    :width="90"
                  />
                  <DxColumn 
                    caption="Descripción"
                    header-cell-template="title-header-html"
                    data-field="Descripcion"
                    alignment="left"
                  />
                  <DxColumn 
                    caption="Unidad"
                    header-cell-template="title-header-html"
                    data-field="Unidad"
                    alignment="center"
                    :width="50"
                  />
                  <!--<DxColumn 
                    caption="Cant.<br>Pedido"
                    header-cell-template="title-header-html"
                    data-field="CantidadPedido"
                    alignment="right"
                    :width="50"
                  />-->
                  <DxColumn
                    caption="Cant.<br>Recibida"
                    header-cell-template="title-header-html"
                    data-field="CantRecibida"
                    alignment="right"
                    :width="58"
                    :format="{ type: 'fixedPoint', precision: 2 }"
                  />
                  <DxColumn
                    caption="Importe<br>Sin Imp."
                    header-cell-template="title-header-html"
                    data-field="FmtImporteSinImpuestos"
                    alignment="right"
                    :width="90"
                    cell-template="cellTemplate"
                  />
                  <DxColumn
                    caption="Amort.<br>Anticipo"
                    header-cell-template="title-header-html"
                    data-field="FmtAmortizacionAnticipo"
                    alignment="right"
                    :width="90"
                    cell-template="cellTemplate"
                  />
                  <DxColumn
                    caption="Retenciones"
                    header-cell-template="title-header-html"
                    data-field="FmtRetenciones"
                    alignment="right"
                    format="currency"
                    :width="88"
                    cell-template="cellTemplate"
                  />
                  <DxColumn
                    caption="Subtotal"
                    header-cell-template="title-header-html"
                    data-field="FmtSubtotalAFacturar"
                    alignment="right"
                    :width="88"
                    cell-template="cellTemplate"
                  />
                  <DxColumn
                    caption="Impuestos"
                    header-cell-template="title-header-html"
                    :calculate-cell-value="calcImpuesto"
                    alignment="right"
                    :width="88"
                    cell-template="cellTemplate"
                  />
                  <!--<DxColumn
                    caption="Import<br>Con Imp."
                    header-cell-template="title-header-html"
                    data-field="FmtImporteConImpuestos"
                    alignment="right"
                    :width="88"
                    cell-template="cellTemplate"
                  />-->
                  <DxColumn
                    caption="Total a<br>Facturar"
                    header-cell-template="title-header-html"
                    data-field="FmtTotalAFacturar"
                    alignment="right"
                    :width="88"
                    cell-template="cellTemplate"
                  />
                  <template #cellTemplate={data}>
                    <span v-show="visibleEntradasIDs.includes(data.data.ID)">{{data.value}}</span>
                  </template>
                  <DxSelection
                      :select-all-mode="allMode"
                      :show-check-boxes-mode="checkBoxesMode"
                      mode="multiple"
                    />
                  <template #title-header-html="{ data }">
                    <span v-html="data.column.caption"></span>
                  </template>
                </DxDataGrid>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
              <!--<DxDataGrid
                id="gridPopUpContainer_TotalesConImpuesto"
                :data-source="TotalesConImpuesto"
                :allow-column-resizing="true"
                :column-auto-width="true"
                :show-borders="true"
                key-expr="ID"
              >
                <DxColumn 
                  caption="Totales Con Impuesto"
                  data-field="TotalesImpuesto"
                  :width="130"
                  alignment="left"
                />
                <DxColumn
                  caption="Monto con Impuestos"
                  data-field="Monto"
                  data-type="number"
                  :width="130"
                  format="currency"
                  alignment="right"
                />-->
                <!--<DxColumn
                  caption="Recibido"
                  data-field="Recibido"
                  data-type="number"
                  format="currency"
                  alignment="right"
                />
                <DxColumn
                  caption="Remisión sin facturar"
                  data-field="Remision"
                  data-type="number"
                  :width="150"
                  format="currency"
                  alignment="right"
                />-->
                <!--<DxColumn
                  caption="Folio Recepcion"
                  data-field="FolioRecepcion"
                  data-type="string"
                  alignment="right"
                />
                <DxColumn
                  caption="Fecha"
                  data-field="FechaRecepcion"
                  data-type="string"
                  alignment="right"
                />
                <DxColumn
                  caption="Facturado"
                  data-field="Facturado"
                  data-type="number"
                  format="currency"
                  alignment="right"
                />
                <DxColumn
                  caption="Por Facturar"
                  data-field="PorFacturar"
                  data-type="number"
                  format="currency"
                  alignment="right"
                />
                <DxColumn 
                  caption="Moneda"
                  data-field="Moneda"
                  alignment="left"
                />
              </DxDataGrid>-->
             </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-4" :class="{ 'col-lg-4' : ActFacRem == 0, 'col-lg-4' : ActFacRem == 1 }" style="margin-bottom: 0px; text-align:left;">
                <div class="col-sm-4" v-if="ActFacRem==1" style="vertical-align:top;">
                  <DxRadioGroup
                    class="FacRem"
                    :items="FacRem"
                    :value="FacRem[0]"
                    @valueChanged="changeSelectionFacRem"
                  />
                </div>
                <span class="col-sm-4 span-label" style="padding-top: 0px;" v-show="ActFacRem==0">Moneda</span>
                <div class="col-sm-7" style="vertical-align:top;">
                  <DxSelectBox
                      class="selector_action"
                      :data-source="JSONMonedaPago"
                      value-expr="Id_PagoSAP"
                      display-expr="Moneda"
                      :value="selMonedaPago"
                      :disabled="selMonedaPagoDisabled"
                       @value-changed="depTiposMonedaPago($event)"
                  />
                </div>
              </div>
              <!--<div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-2" style="margin-bottom: 0px; text-align:center;" v-if="ActFacRem==0">
                <div class="col-sm-12" style="padding:0px;">
                    <div class="value">
                      <DxSelectBox
                        class="selector_action"
                        :data-source="JSONMonedaPago"
                        value-expr="Id_PagoSAP"
                        display-expr="Moneda"
                        :value="selMonedaPago"
                        :disabled="selMonedaPagoDisabled"

                      /> @value-changed="depTiposCertificado($event)"
                    </div>
                  </div>
              </div>-->
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-4" :class="{ 'col-lg-4' : ActFacRem == 0 }" style="margin-bottom: 0px; text-align:center;">
                <!--<span class="col-sm-4 span-label" style="padding-top: 0px;">Archivo XML</span>-->
                <div class="col-sm-12">
                  <div class="fileuploader-container">
                    <DxFileUploader
                      class="xmlUploader"
                      id="fileUploaderContainerXML"
                      :allowed-file-extensions="['.xml']"
                      select-button-text="Archivo XML"
                      label-text=""
                      upload-mode="uploadMode"
                      :ref="refXMLUploader"
                      :disabled=xmlDisabled
                      :onValueChanged="onBeforeSend"
                      @value-changed="e => xmlfiles = e.value"
                      style="text-align:center;"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-4" :class="{ 'col-lg-4' : ActFacRem == 0 }" style="margin-bottom: 0px; text-align:center;">
                <!--<span class="col-sm-4 span-label" style="padding-top: 0px;">Archivo PDF</span>-->
                <div class="col-sm-12">
                  <div class="fileuploader-container">
                    <DxFileUploader
                      :allowed-file-extensions="['.pdf']"
                      select-button-text="Archivo PDF"
                      label-text=""
                      upload-mode="uploadMode"
                      :disabled=pdfDisabled
                      :onValueChanged="onBeforeSendPDF"
                      @value-changed="e => pdffiles = e.value"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-8 col-xs-12 col-lg-8" style="margin-bottom: 0px;">
                <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                  <span class="col-sm-4 span-label" style="padding-top: 0px; padding-left:0px;" v-if="selFacturaRemision==0">Num. Factura</span>
                  <span class="col-sm-4 span-label" style="padding-top: 0px; padding-left:0px;" v-else>Num. Remision</span>
                  <div class="col-sm-7" style="padding-left:5px;">
                    <div class="value">
                      <DxTextBox
                        v-model="selNumFactura"
                        :disabled="selNumFacturaDisabled"
                        :max-length="40"
                        value-change-event="keyup"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                  <span class="col-sm-4 span-label" style="padding-top: 0px;">F. Factura</span>
                  <div class="col-sm-8">
                    <div class="value">
                      <date-picker v-model="selFechaFacturaStr" :format="dateFormat" :disabled="selFechaFacturaDisable">{{selFechaFacturaStr}}</date-picker>
                    </div>
                  </div>
                </div>
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <span class="col-sm-2 span-label" style="padding-top: 0px; padding-right:0px; padding-left:0px;">Estado CFDI </span>
                  <span class="col-sm-10 span-label" v-if="EstatusCFDI=='Vigente'" style="padding-left: 40px; padding-top: 0px; font-weight: normal; color: green">Vigente</span>
                  <span class="col-sm-10 span-label" v-else-if="EstatusCFDI=='Temporalmente Vigente'" style="padding-left: 40px; padding-top: 0px; font-weight: normal; color: green">Temporalmente Vigente</span>
                  <span class="col-sm-10 span-label" v-else style="padding-left: 40px; padding-top: 0px; font-weight: normal; color: red">{{EstatusCFDI}}</span>
                </div>
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <span class="col-sm-2 span-label" style="padding-top: 0px; padding-left:0px;">Comentarios</span>
                  <div class="col-sm-10" style="padding-left: 0px;">
                    <div class="value">
                      <DxTextArea
                        :height="105"
                        :max-length="maxLength"
                        v-model="selComentarios"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-4 col-xs-12 col-lg-4" style="margin-bottom: 0px;">
                <!--<div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <span class="col-sm-5 span-label" style="padding-top: 0px;">Moneda</span>
                  <div class="col-sm-7">
                    <div class="value">
                      <DxSelectBox
                        class="selector_action"
                        :data-source="JSONMonedaPago"
                        value-expr="Id_PagoSAP"
                        display-expr="Moneda"
                        :value="selMonedaPago"
                        :disabled="selMonedaPagoDisabled"

                      />@value-changed="depTiposCertificado($event)"
                    </div>
                  </div>
                </div>-->
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;" v-if="PEI==1">
                  <span class="col-sm-5 span-label" style="padding-top: 0px; padding-right:0px;">Referencia</span>
                  <div class="col-sm-7"  style="padding-top: 0px; padding-right:0px;">
                    <div class="value">
                      <DxTextBox
                        v-model="selReferenciaBancaria"
                        :max-length="40"
                        value-change-event="keyup"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <span class="col-sm-5 span-label" style="padding-top: 0px; padding-right:0px;">Subtotal</span>
                  <div class="col-sm-7" style="padding-top: 0px; padding-right:0px;" v-if="selOriginalFields==false">
                    <DxNumberBox
                      class="align-right"
                      v-model="selSubtotal"
                      :onValueChanged="keyUpSubtotal"
                      format="$ #,##0.##"
                      :max="maxSub+1"
                      :min="0"
                      :disabled="selSubtotalDisabled"
                      :show-spin-buttons="false"
                      :show-clear-button="false"
                    />
                  </div>
                  <div class="col-sm-7" style="padding-top: 0px; padding-right:0px;" v-else><!-- -->
                    <DxNumberBox
                      class="align-right"
                      v-model="selSubtotalOriginal"
                      format="$ #,##0.##"
                      :min="0"
                      :disabled="selSubtotalDisabled"
                      :show-spin-buttons="false"
                      :show-clear-button="false"
                    />
                  </div>
                </div>
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <span class="col-sm-5 span-label" style="padding-top: 0px; padding-right:0px;">Descuento <sup v-show="!selDescuentoDisabled" title="El descuento debe ser un valor positivo." style="background: #d7d7d7; padding: 0px 5px 0px 5px; border-radius: 50%; color: #FFF; cursor: pointer;">?</sup></span>
                  <div class="col-sm-7" style="padding-top: 0px; padding-right:0px;" v-if="selOriginalFields==false">
                    <DxNumberBox
                      class="align-right"
                      v-model="selDescuento"
                      format="$ #,##0.##"
                      :onValueChanged="keyUpDescuento"
                      value-change-event="keyup"
                      :onChange="changeDescuento"
                      :disabled="selDescuentoDisabled"
                      :min="minDesc"
                      :max="maxDesc"
                      :show-spin-buttons="false"
                      :show-clear-button="false"
                    />
                  </div>
                  <div class="col-sm-7" style="padding-top: 0px; padding-right:0px;" v-else><!-- -->
                    <DxNumberBox
                      class="align-right"
                      v-model="selDescuentoOriginal"
                      format="$ #,##0.##"
                      :onValueChanged="keyUpDescuento"
                      value-change-event="keyup"
                      :onChange="changeDescuento"
                      :disabled="selDescuentoDisabled"
                      :min="minDesc"
                      :max="maxDesc"
                      :show-spin-buttons="false"
                      :show-clear-button="false"
                    />
                  </div>
                </div>
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <span class="col-sm-5 span-label" style="padding-top: 0px; padding-right:0px;">Impuesto</span>
                  <div class="col-sm-7" style="padding-top: 0px; padding-right:0px;" v-if="selOriginalFields==false">
                    <DxNumberBox
                      class="align-right"
                      v-model="selImpuestos"
                      format="$ #,##0.##"
                      :disabled="selImpuestosDisabled"
                      :min="0"
                      :show-spin-buttons="false"
                      :show-clear-button="false"
                    />
                  </div>
                  <div class="col-sm-7" style="padding-top: 0px; padding-right:0px;" v-else><!-- -->
                    <DxNumberBox
                      class="align-right"
                      v-model="selImpuestosOriginal"
                      format="$ #,##0.##"
                      :disabled="selImpuestosDisabled"
                      :min="0"
                      :show-spin-buttons="false"
                      :show-clear-button="false"
                    />
                  </div>
                </div>
                
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;" v-if="selISH">
                  <span class="col-sm-5 span-label" style="padding-top: 0px; padding-right:0px;">IEPS/ISH</span>
                  <div class="col-sm-7" style="padding-top: 0px; padding-right:0px;" v-if="selOriginalFields==false">
                    <DxNumberBox
                      class="align-right"
                      v-model="selISH"
                      format="$ #,##0.##"
                      :disabled="selISHDisabled"
                      :min="0"
                      :show-spin-buttons="false"
                      :show-clear-button="false"
                    />
                  </div>
                  <div class="col-sm-7" style="padding-top: 0px; padding-right:0px;" v-else><!-- -->
                    <DxNumberBox
                      class="align-right"
                      v-model="selISHOriginal"
                      format="$ #,##0.##"
                      :disabled="selISHDisabled"
                      :min="0"
                      :show-spin-buttons="false"
                      :show-clear-button="false"
                    />
                  </div>
                </div>

                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <span class="col-sm-5 span-label" style="padding-top: 0px; padding-right:0px;">Imp. Retenido<!--<sup title="Impuestos Retenidos" style="background: #d7d7d7; padding: 0px 5px 0px 5px; border-radius: 50%; color: #FFF; cursor: pointer;">?</sup>--></span>
                  <div class="col-sm-7" style="padding-top: 0px; padding-right:0px;" v-if="selOriginalFields==false">
                    <DxNumberBox
                      class="align-right"
                      v-model="selImpuestosRetenidos"
                      format="$ #,##0.##"
                      :onValueChanged="keyUpImpuestosRetenidos"
                      value-change-event="keyup"
                      :onChange="changeImpuestosRetenidos"
                      :disabled="selDescuentoDisabled"
                      :min="minImpRet"
                      :max="maxImpRet"
                      :show-spin-buttons="false"
                      :show-clear-button="false"
                    />
                  </div>
                  <div class="col-sm-7" style="padding-top: 0px; padding-right:0px;" v-else><!-- -->
                    <DxNumberBox
                      class="align-right"
                      v-model="selImpuestosRetenidosOriginal"
                      format="$ #,##0.##"
                      :onValueChanged="keyUpImpuestosRetenidos"
                      value-change-event="keyup"
                      :onChange="changeImpuestosRetenidos"
                      :disabled="selDescuentoDisabled"
                      :min="minImpRet"
                      :max="maxImpRet"
                      :show-spin-buttons="false"
                      :show-clear-button="false"
                    />
                    <!---->
                  </div>
                </div>
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <span class="col-sm-5 span-label" style="padding-top: 0px; padding-right: 0px;">Total Factura <sup v-show="!selTotalDisabled" title="El total de la factura debe ser un valor positivo." style="background: #d7d7d7; padding: 0px 5px 0px 5px; border-radius: 50%; color: #FFF; cursor: pointer;">?</sup></span>
                  <div class="col-sm-7" style="padding-top: 0px; padding-right:0px;" v-if="selOriginalFields==false">
                    <DxNumberBox
                      class="align-right"
                      v-model="selTotal"
                      format="$ #,##0.##"
                      :onValueChanged="keyUpTotal"
                      value-change-event="keyup"
                      :onChange="changeTotal"
                      :disabled="selTotalDisabled"
                      :min="minTotal"
                      :max="maxTotal"
                      :show-spin-buttons="false"
                      :show-clear-button="false"
                    />
                  </div>
                  <div class="col-sm-7" style="padding-top: 0px; padding-right:0px;" v-else><!-- -->
                    <DxNumberBox
                      class="align-right"
                      v-model="selTotalOriginal"
                      format="$ #,##0.##"
                      :onValueChanged="keyUpTotal"
                      value-change-event="keyup"
                      :onChange="changeTotal"
                      :disabled="selTotalDisabled"
                      :min="minTotal"
                      :max="maxTotal"
                      :show-spin-buttons="false"
                      :show-clear-button="false"
                    />
                  </div>
                </div>
                <!--<div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <span class="col-sm-7 span-label" style="padding-top: 0px;">Moneda</span>
                  <div class="col-sm-5">
                    <div class="value">
                      <DxTextBox
                        v-model="selId_Moneda"
                        :max-length="40"
                        value-change-event="keyup"
                        :disabled="true"
                        class="align-center"
                      />
                    </div>
                  </div>
                </div>-->
              </div>
            </div>
            <!--<div class="row">Error: El número de factura: Remision ya se había registrado con anterioridad en la orden de compra: 4500042221, hito: Aprob. OC.
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">Referencia</span>
                <div class="col-sm-8">
                  <div class="value">
                    <DxTextBox
                      v-model="selReferencia"
                      :max-length="40"
                      value-change-event="keyup"
                    />
                  </div>
                </div>
              </div>
            </div>-->
          </div>
        </div>
        <div class="textFormatingGral" style="color:red; font-size:1rem;" v-show="selFacturaRemision">
          NOTA: El envío de la nota de remisión es sólo para pago.<br>
          Sigue pendiente el envío de la factura, la cual se deberá enviar por este mismo medio. 
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <label v-show="showMensajeNoEnviar" style="display: block;width: 100%;color: red;text-align: center;">El envio de facturas está desabilitado ya que este proveedor no tiene pagos referenciados, solo el proveedor puede subir sus facturas.</label>
        <b-button size="sm" variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
        <b-button size="sm" variant="primary" :disabled="sendDisabled"  @click="enviar()">
          Enviar
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-3" ref="modal-3" :title=HeaderPopUpCertificados size="xl" button-size="sm" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 5px;">
                <div class="col-sm-4">
                  <b-button variant="primary" size="sm" @click="modalAltaCertificado()" v-b-modal.modal-3-2>Agregar certificado</b-button>
                </div>
                <div class="col-sm-8" style="text-align:right;">
                  <span style="margin-bottom: 5px; font-weight: 400;font-size: 12px;font-family: 'Helvetica Neue','Segoe UI',Helvetica,Verdana,sans-serif;"><span style="background-color: rgb(199, 199, 199);padding: 1px 5px;">{{PosicionesAsociadas}}</span> Posiciones de la OC asociadas certificados</span>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 5px;">
                <span style="font-weight: 400;font-size: 12px;font-family: 'Helvetica Neue','Segoe UI',Helvetica,Verdana,sans-serif;">SI EL CERTIFICADO / CARTA YA ESTÁ REGISTRADO, FAVOR DE ASOCIAR A LAS POSICIONES DE LA ORDEN DE COMPRA QUE APLIQUEN</span>
              </div>
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <DxDataGrid
                    id="gridPopUpContainer_PosicionesCertificados"
                    :data-source="CertificadosProveedor"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    key-expr="Id_Certificado"
                  >
                    <DxColumn 
                      caption="Certificado"
                      data-field="Certificado"
                      data-type="text"
                      alignment="left"
                      :width="140"
                    />
                    <DxColumn 
                      caption="Documento"
                      data-field="NombreArchivo"
                      data-type="text"
                      alignment="left"
                      :width="225"
                    />
                    <DxColumn 
                      caption="Estatus Documento"
                      data-field="Estatus"
                      data-type="text"
                      alignment="center"
                      :width="125"
                    />
                    <DxColumn caption="Estatus Coladas" alignment="center">
                      <DxColumn 
                        caption="Aprobadas"
                        data-field="Aprobadas"
                        data-type="text"
                        alignment="center"
                        :width="90"
                      />
                      <DxColumn 
                        caption="No Aprobadas"
                        data-field="NoAprobadas"
                        data-type="text"
                        alignment="center"
                        :width="90"
                      />
                      <DxColumn 
                        caption="Autorización"
                        data-field="Autorizacion"
                        data-type="text"
                        alignment="center"
                        :width="90"
                      />
                    </DxColumn>
                    <DxColumn 
                      caption="Tipo Certificado"
                      data-field="TipoCertificado"
                      data-type="text"
                      alignment="center"
                      :width="140"
                    />
                    <DxColumn
                      caption="Relacionar OC"
                      alignment="center"
                      width="100px"
                      :allow-filtering="false"
                      cell-template="cellTemplate"
                    />
                    <template #cellTemplate={data}>
                      <span class="button-span-subir" v-if="data.data.PermitirRelacionar!=0" style="padding: 3px 15% 3px 15% !important;" @click="AsociarOC(data)">Asociar a OC</span>
                      <span class="button-span-subir" v-else style="opacity: .5;pointer-events: none;padding: 3px 15% 3px 15% !important;">Asociar a OC</span>
                    </template>

                    <!--<DxColumn 
                      caption="Por Enviar"
                      data-field="Certificado"
                      data-type="text"
                      alignment="left"
                      cell-template="cellUp"
                    />
                    <template #cellUp={data}>
                      <span v-if="data.value">v-html="data.value"
                        <span v-if="data.value.certificado.length>=2">
                          <li v-for="item in data.value.certificado" :key="item.Id_Certificado">
                            {{item}}
                            <i class="fa fa-trash" @click="delDoc(item.Id_Certificado,item.Id_OrdenCompraSAP)" title="Eliminar" style="color:#ff0000a6; cursor:pointer;"></i> {{ item.Certificado }}
                          </li>
                        </span>
                        <span v-else>
                          <li v-for="item in data.value" :key="item.Id_Certificado">
                            {{item}}
                            <i class="fa fa-trash" @click="delDoc(item.Id_Certificado,item.Id_OrdenCompraSAP)" title="Eliminar" style="color:#ff0000a6; cursor:pointer;"></i> {{ item.Certificado }}
                          </li>
                        </span>
                      </span>
                      <div v-else style="text-align:center;">
                        <span style="text-align:center; cursor:pointer; color:blue;text-align: center; cursor: pointer; color: #007bff;font-weight: bold;"></span>
                      </div>
                    </template>
                    <DxColumn 
                      caption="Enviados"
                      data-field="CertificadosEnviados"
                      data-type="text"
                      alignment="left"
                      cell-template="cellUpliad"
                    />
                    <template #cellUpliad={data}>
                      <span v-if="data.value" v-html="data.value"></span>
                      <div v-else style="text-align:center;">
                        <span style="text-align:center; cursor:pointer; color:blue;text-align: center; cursor: pointer; color: #007bff;font-weight: bold;"></span>
                      </div>
                    </template>
                    <DxColumn 
                      caption="Pos"
                      data-field="Posicion"
                      data-type="number"
                      alignment="center"
                      width="50"
                    />
                    <DxColumn
                      caption="Código"
                      data-field="Codigo"
                      data-type="number"
                      alignment="center"
                    />
                    <DxColumn
                      caption="Descripción"
                      data-field="Descripcion"
                      data-type="text"
                      alignment="left"
                    />-->
                  </DxDataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="">
        <!-- Cerrar solo refresca la lista, como en los otros dos modales de esta
             vista. Llamaba a SendCertificate(0), que pega a
             updOC_EnviarPosicionesCertificado con Enviar=0: la rama que BORRA
             CertificadosOC, OrdenesCompraSAPCertificados y Certificados. Hoy no
             borra nada solo porque el SP filtra por un Id_Usuario que nunca
             coincide; en cuanto se arregle ese filtro, cerrar el modal se
             llevaria los certificados del proveedor. -->
        <b-button size="sm" variant="secondary" @click="RefreshFirstList()">
          Cerrar
        </b-button>
        <!--<b-button size="sm" variant="primary" @click="SendCertificate(1)">
          Enviar certificados
        </b-button>-->
      </template>
    </b-modal>
    <b-modal id="modal-3-1" ref="modal-3-1" size="xl" button-size="sm" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
      <div slot="modal-title">
        <div class="row">
          <div class="form-group col-sm-12 col-md-4 col-xs-12 col-lg-4" style="margin-bottom: 0px;">
            <span class="col-sm-12" style="padding-top: 0px; text-align:center;">OC: {{txtOC}}</span>
          </div>
          <div class="form-group col-sm-12 col-md-8 col-xs-12 col-lg-8" style="margin-bottom: 0px;">
            <span class="col-sm-12" style="padding-top: 0px;">Certificado: {{txtCertificado}}</span>
            <span class="col-sm-12" style="padding-top: 0px;">Documento: {{txtNombreArchivo}}</span>
          </div>
        </div>
      </div>
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <div class="row">
              <!--<div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <div class="col-sm-12" style="text-align:left;">
                  <div class="fileuploader-container">
                    <DxFileUploader
                      :allowed-file-extensions="['.pdf']"
                      select-button-text="Agregar certificado"
                      upload-mode="uploadMode"
                      @value-changed="e => certificadosfiles = e.value"
                    />
                  </div>
                </div>
              </div>-->
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <DxDataGrid
                    id="gridPopUpContainer_PosicionesCertificadosPendientes"
                    :ref="dataGridRefName"
                    :selected-row-keys="selectedRowKeys"
                    :data-source="PosicionesCertificados"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    key-expr="Id_OrdenCompraSAP"
                    @selection-changed="onSelectionChanged"
                    @editing-start="onEditingStart"
                    @row-prepared="onRowPrepared"
                  >
                    <DxEditing
                      :allow-updating="true"
                      mode="cell"
                      on
                    />
                    <DxSelection :deferred="true" mode="multiple" />
                    <!--<DxColumn 
                      caption="Checked"
                      data-field="Checked"
                      data-type="number"
                      alignment="center"
                      :allow-editing="false"
                    />
                    <DxColumn 
                      caption="EnabledRow"
                      data-field="EnabledRow"
                      data-type="number"
                      alignment="center"
                      :allow-editing="false"
                    />-->
                    <DxColumn
                      caption="Coladas Autorizadas"
                      data-field="Colada"
                      data-type="text"
                      alignment="center"
                      :allow-editing="false"
                    />
                    <DxColumn
                      caption="Coladas por Autorizar"
                      data-field="ColadaPorAutorizar"
                      data-type="text"
                      alignment="center"
                    />
                    <DxColumn 
                      caption="Pos"
                      data-field="Posicion"
                      data-type="number"
                      alignment="center"
                      :allow-editing="false"
                    />
                    <DxColumn
                      caption="Código"
                      data-field="CodigoSAP"
                      data-type="number"
                      alignment="center"
                      :allow-editing="false"
                    />
                    <DxColumn
                      caption="Descripción"
                      data-field="TextoBreve"
                      data-type="text"
                      alignment="left"
                      :allow-editing="false"
                    />
                    <DxSelection
                      :select-all-mode="allMode"
                      :show-check-boxes-mode="checkBoxesMode"
                      mode="multiple"
                    />
                  </DxDataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="secondary" @click="cancel()">
          Cerrar
        </b-button>
        <b-button size="sm" variant="primary" @click="enviarCertificado()">
          Guardar y enviar
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-3-2" ref="modal-3-2" :title=HeaderPopUpCertificados32 width="40%" button-size="sm" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-6 span-label" style="padding-top: 0px;">Tipo Certificado:</span>
                <div class="col-sm-6">
                  <div class="value">
                    <DxSelectBox
                      class="selector_action"
                      :data-source="JSONTiposCertificado"
                      value-expr="Id_TipoCertificado"
                      display-expr="TipoCertificado"
                      :value="selTiposCertificado"
                      @value-changed="depTiposCertificado($event)"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <!-- 01-Sep-2026: AM. Revision del 1-Sep-2026 con Blas: las Cartas de cumplimiento ya no
                     se cargan por el portal, asi que se quita "Carta" de las etiquetas para no ofrecer
                     algo que no existe. Tambien se quitaron del catalogo en sp_prv_getTiposCertificado_XML. -->
                <span class="col-sm-6 span-label" style="padding-top: 0px;">Num. Certificado:</span>
                <div class="col-sm-6">
                  <div class="value">
                    <DxTextBox
                      v-model="NoCertificadoCarta"
                      :max-length="40"
                      value-change-event="keyup"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px; text-align:center;">
                <div class="col-sm-10" style="text-align:center;">
                  <div class="fileuploader-container">
                    <!-- 01-Sep-2026: AM. Revision del 1-Sep-2026 con Blas: el certificado solo se
                         acepta en PDF. allowed-file-extensions ya estaba, pero solo marca el archivo
                         como invalido: el @value-changed lo dejaba igual en certificadosfiles y de ahi
                         se subia. Se agrega accept para que el dialogo del sistema ya filtre, y la
                         extension se vuelve a comprobar en onBeforeSendCertificado. -->
                    <DxFileUploader
                      class="certificadoUploader"
                      style="text-align:center;"
                      :allowed-file-extensions="['.pdf']"
                      accept="application/pdf,.pdf"
                      select-button-text="Agregar certificado"
                      upload-mode="uploadMode"
                      :onValueChanged="onBeforeSendCertificado"
                      @value-changed="e => certificadosfiles = e.value"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
        <b-button size="sm" variant="primary" @click="altaCertificado()">
          Asociar posiciones
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-4" ref="modal-4" :title=HeaderPopUpSoportes size="xl" button-size="sm" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <div class="row" style="margin-top:10px;">
							<div v-if="tableSoportes" class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <DxDataGrid
                  id="gridPopUpContainer_tableSoportes"
                  :data-source="tableSoportes"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  key-expr="Id_TipoFechaMaterial"
                >
                  <DxColumnChooser :enabled="false"/>
                  <DxColumnFixing :enabled="true"/>
                  <DxFilterRow :visible="true"/>
                  <!--<DxPaging :page-size="6"/>-->
                  <DxPager
                    :show-page-size-selector="true"
                    :allowed-page-sizes="[]"
                  />
                  <DxColumn 
                    caption="Hito"
                    data-field="Hito"
                    data-type="string"
                    alignment="left"
                  />
                  <DxColumn 
                    caption="Documentación"
                    data-field="SubTipoDocumentacion"
                    data-type="string"
                    alignment="left"
                  />
                  <DxColumn 
                    caption="Evidencias en autorización"
                    data-field="EvidenciasEnAutorizacion"
                    data-type="string"
                    alignment="left"
                    width="50%"
                    cell-template="cellEvAut"
                  />
                  <template #cellEvAut={data}>
                    <span v-html="data.data.EvidenciasEnAutorizacion"></span>
                  </template>
                  <DxColumn 
                    caption="Evidencias recibidas"
                    data-field="EvidenciasRecibidas"
                    data-type="string"
                    alignment="left"
                    width="50%"
                    cell-template="cellEvRec"
                  />
                  <template #cellEvRec={data}>
                    <span v-html="data.data.EvidenciasRecibidas"></span>
                  </template>
                  <!--<DxColumn
                    caption="Archivo de Soporte"
                    data-field="NombreArchivo"
                    data-type="string"
                    alignment="center"
                    cell-template="cellFiles"
                  />-->
                  <template #cellFiles={data}>
                    <span v-if="data.value" v-html="data.value"></span>
                    <span v-else><i class="fas fa-times"></i></span>
                  </template>
                  <DxColumn
                    caption="Enviar"
                    alignment="center"
                    :width="125"
                    :allow-filtering="false"
                    cell-template="cellTemplate"
                  />
                  <template #cellTemplate={data}>
                    <span class="button-span-subir" @click="upSoporte(data)">Subir</span>
                  </template>
                </DxDataGrid>
              </div>
              <div v-else style="text-align:center;">No se encontraron certificados</div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="">
        <b-button size="sm" variant="secondary" @click="RefreshFirstList()">
          Cerrar
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-5" ref="modal-5" :title=HeaderPopUpSoportesFiles  button-size="sm" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">Fecha Envio</span>
                <div class="col-sm-8">
                  <div class="value">
                    <date-picker v-model="selFechaEnvioSoporte" :format="dateFormat" v-on:change="depFechaEnbioSoporte($event)" :disabled="FechaEnvioSoporteDisabled"></date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="DiasVigencia>=1">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">Vigencia Hasta</span>
                <div class="col-sm-8">
                  <div class="value">
                    <date-picker v-model="selFechaHastaSoporte" :format="dateFormat" :disabled="true"></date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top:10px;">
							<div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <div class="col-sm-12" style="text-align:center;">
                  <span style="font-size: .6em;color: gray;font-weight: bold; display:block;">Formatos Validos</span>
                  <span style="font-size: .6em;color: gray;font-weight: bold; display:block;">.pdf, .jpg, .jpeg, .gif, .svg, .png</span>
                  <div class="fileuploader-container">
                    <DxFileUploader
                      :allowed-file-extensions="['.pdf','.jpg','.jpeg','.gif','.svg','.png']"
                      select-button-text="Agregar archivo"
                      upload-mode="uploadMode"
                      placeholder="Formatos validos '.pdf','.jpg','.jpeg','.gif','.svg','.png'"
                      @value-changed="e => soportesfiles = e.value"
                    /><!--:multiple="multiple"-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel, data }">
        <b-button size="sm" variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
        <b-button size="sm" variant="primary" @click="enviarSoportes(data)">
          Guardar
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-6" ref="modal-6" :title="LangSelected.Interno.OCDocPendiente.HeaderFacturasTutorial" size="xl" button-size="sm" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">

                <a href="https://arendalgo.sharepoint.com/:v:/s/TI/EdP33IsXOQJFomPOcVvKpQwBLQhwxWq9v7KEF6lPuqAeQw" target="blank_" style="float: right;border: solid thin;padding: 1px 15px 4px 20px;color: white;background: #ffc107;">{{LangSelected.Interno.OCDocPendiente.Tutorial_BtnVideo}} <i class="fas fa-play"></i></a>

                <div style="border-bottom: solid thin rgb(79, 153, 196); margin-top:10px;">
                  <span style="color: white;height: 0px;border-right: 20px solid transparent;border-bottom: 20px solid rgb(79, 153, 196);display: inline-block;text-align: center;padding: 3px 0px;padding-bottom: 4px;padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.Tutorial_Paso1Titulo}}</span>
                </div>
                <div>
                  {{LangSelected.Interno.OCDocPendiente.Tutorial_Paso1Desc}}

                  <img src="@/assets/OrdenesCompra.png" alt="OrdenesCompra" style="width: 100%;"/>
                  <div style="border-bottom: solid thin rgb(79, 153, 196);">
                    <span style="color: white;height: 0px;border-right: 20px solid transparent;border-bottom: 20px solid rgb(79, 153, 196);display: inline-block;text-align: center;padding: 3px 0px;padding-bottom: 4px;padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.Tutorial_Paso2Titulo}}</span>
                  </div>
                  <div>
                    <p>{{LangSelected.Interno.OCDocPendiente.Tutorial_Paso2Desc}}</p>
                    <div style="text-align:center;">
                      <img src="@/assets/Conceptos.png" alt="Conceptos" style="width: 80%;"/>
                    </div>
                  </div>
                  <div style="border-bottom: solid thin rgb(79, 153, 196);">
                    <span style="color: white;height: 0px;border-right: 20px solid transparent;border-bottom: 20px solid rgb(79, 153, 196);display: inline-block;text-align: center;padding: 3px 0px;padding-bottom: 4px;padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.Tutorial_Paso3Titulo}}</span>
                  </div>
                  <div>
                    <p style="margin:0px;"><span style="background: #ff4e00;color: white;border-radius: 0px 20px 20px 0px;padding: 0px 5px 0px 1px;">1.-</span> {{LangSelected.Interno.OCDocPendiente.Tutorial_Step1}}</p>
                    <p style="margin:0px;"><span style="background: #3500b5;color: white;border-radius: 0px 20px 20px 0px;padding: 0px 10px 0px 1px;">2.-</span> {{LangSelected.Interno.OCDocPendiente.Tutorial_Step2}}</p>
                    <p style="margin:0px;"><span style="background: #008055;color: white;border-radius: 0px 20px 20px 0px;padding: 0px 15px 0px 1px;">3.-</span> {{LangSelected.Interno.OCDocPendiente.Tutorial_Step3}}</p>
                    <p style="margin:0px;"><span style="background: gray;color: white;border-radius: 0px 20px 20px 0px;padding: 0px 20px 0px 1px;">4.-</span> {{LangSelected.Interno.OCDocPendiente.Tutorial_Step4}}</p>
                    <p style="margin:0px;"><span style="background: #4f99c4;color: white;border-radius: 0px 20px 20px 0px;padding: 0px 25px 0px 1px;">5.-</span> {{LangSelected.Interno.OCDocPendiente.Tutorial_Step5}}</p>
                    <div style="text-align:center;">
                      <img src="@/assets/CargaFactura.png" alt="CargaFactura" style="width: 90%;"/>
                    </div>
                  </div>
                  <br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="">
        <b-button size="sm" variant="secondary" @click="CloseModal()">
          {{LangSelected.Interno.OCDocPendiente.Tutorial_BtnCerrar}}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-7" ref="modal-7" :title="LangSelected.Interno.OCDocPendiente.HeaderBuscarOC" size="lg" button-size="sm" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <span class="col-sm-12 span-label" style="padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.BuscarOCInstruccion}}</span>
            </div>
            <div class="row" style="margin-bottom: 10px;">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
								<span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.OCDocPendiente.BuscarOCLabel}}</span>
								<div class="col-sm-7">
                  <div class="value">
                    <DxTextBox
                      v-model="OrdenCompraBusqueda"
                      :max-length="10"
                    />
                  </div>
								</div>
                <div class="col-sm-2">
                  <b-button variant="primary" size="sm" @click="modalBuscarOC()">{{LangSelected.Interno.OCDocPendiente.BuscarOCBtn}}</b-button><!--@click="modalAltaCertificado()"-->
                </div>
							</div>
            </div>
            <div class="row" style="margin-bottom: 10px;" v-if="MostrarMotivo">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <div v-if="MotivoOCStyle" style="background: rgb(255, 255, 100); padding: 0px 10px 2px 10px; border: thin solid gray;">
                  {{MotivoOC}}
                </div>
                <div v-else style="background: rgb(20, 255, 100); padding: 0px 10px 2px 10px; border: thin solid gray;">
                  {{MotivoOC}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="">
        <b-button size="sm" variant="secondary" @click="CloseModal()">
          {{LangSelected.Interno.OCDocPendiente.Tutorial_BtnCerrar}}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_API;

/*function getPosSelected(selectedRowsData, type) {
  if(type=='arr'){
    const getPos = row => `${row.Id_OrdenCompraSAP}`;
    return selectedRowsData.length ? selectedRowsData.map(getPos) : [];
  }
  if(type=='txt'){
    const getPos = row => `${row.Id_OrdenCompraSAP}`;
    return selectedRowsData.length ? selectedRowsData.map(getPos).join(',') : 'Posiciones sin seleccionar';
  }
}*/

//* D A T A   G R I D *//
import { DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxPager, DxFilterRow, DxPaging, DxEditing, DxSelection } from 'devextreme-vue/data-grid';
import DxButton from 'devextreme-vue/button';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxNumberBox from 'devextreme-vue/number-box';
import DxTextArea from 'devextreme-vue/text-area';
import DxRadioGroup from 'devextreme-vue/radio-group';
import DatePicker from 'vue2-datepicker';
import axios from 'axios';
import apiClient from '@/services/apiClient';
import notify from 'devextreme/ui/notify';
import { DxFileUploader } from 'devextreme-vue/file-uploader';
import { DxLoadPanel } from 'devextreme-vue/load-panel';

function escapeURI(value,EncodeDecode="e"){
  value=value.toString();
  if(EncodeDecode=="e"){
    value=value.replace(/'/g,"''");
    return window.encodeURIComponent(value);
  }else if(EncodeDecode=="d"){
    value=value.replace("%40","@");
    return window.decodeURI(value);
  }else{
    return "";
  }
}

function EntradasSeleccionadasCalculo(seleccionados, TipoCambio = 1){
  var valores = {SubtotalEntradas:0.00,ImpuestosEntradas:0.00,TotalEntradas:0.00,Retenciones:0.00};
  seleccionados.forEach(function callback(currentValue, index, array) {
      console.log({currentValue,index,array})
      valores.ImpuestosEntradas=parseFloat(valores.ImpuestosEntradas)+parseFloat(currentValue.ImpuestosAFacturar);
      valores.SubtotalEntradas=parseFloat(valores.SubtotalEntradas)+parseFloat(currentValue.SubtotalAFacturar);
      valores.Retenciones=parseFloat(valores.Retenciones)+parseFloat(currentValue.Retenciones);
      valores.TotalEntradas=parseFloat(valores.TotalEntradas)+(parseFloat(currentValue.TotalAFacturar)-parseFloat(currentValue.Retenciones));
  });
  valores.ImpuestosEntradas=valores.ImpuestosEntradas*TipoCambio;
  valores.SubtotalEntradas=valores.SubtotalEntradas*TipoCambio;
  valores.Retenciones=valores.Retenciones*TipoCambio;
  valores.TotalEntradas=valores.TotalEntradas*TipoCambio;
  return valores;
}

let MoneyFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

function BeetweenTotal(AComparar,Desde,Asta,LlegadaSitio){
  /*
  Comprobante.SubTotal-that.selDescuento,
  that.selSubtotal-MontoMargen,
  that.selSubtotal+MontoMargen,
  that.EsLlegadaASitio
  */
  console.log(AComparar + ">=" + Desde + "&&" + AComparar + "<=" + Asta)
  console.log(LlegadaSitio)
  if(LlegadaSitio==1){
        //100         100     100          110
    if (AComparar >= Desde && AComparar <= Asta) {
      return false;
    }else{
      return true;
    }
  }else{
    console.log(AComparar + ">=" + Asta )
    //   100          110
    if (AComparar >= Asta) {
      return true;
    }else{
      return false;
    }
  }
}

let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

function HabilitarDeshabilitar(PAISP, EsLlegadaASitio,FactRemi,RemisionNumerico){
  if(PAISP=="MX"){//!Proveedor Nacional
    if(EsLlegadaASitio==1){//!Es llegada a sitio
      return true;
    }else{//!Factura Normal
      if(FactRemi==0){//!Si es Factura
        return true;
      }else{
        return false;
      }
    }
  }else{//*Proveedor Internacional
    if(EsLlegadaASitio==1){//!Es llegada a sitio
      return true;
    }else{//!Factura Normal
      if(FactRemi==0){//!Si es Factura
        if(RemisionNumerico==0){//!Si no existe remision //that.TotalesConImpuesto[0].RemisionNumerico
          return false;
        }else{
          return true;
        }
      }else{
        return false;
      }
    }
  }
}

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

export default {
  components: { DxButton, DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxPager, DxFilterRow, DxPaging, DxEditing, DxSelectBox, DxTextBox, DxNumberBox, DxTextArea, DxRadioGroup, DatePicker, DxFileUploader, DxSelection, DxLoadPanel },
  data() {
    return {
      LangSelected: JSON.parse(localStorage.getItem('languageInfo')),
      //* G E N E R A L     V A R I A B L E S *//
      IDPU: localStorage.getItem('IDPU'),
      IDUS: localStorage.getItem('IDUS'),
      RFCP: localStorage.getItem('RFCP'),
      PAISP: localStorage.getItem('PAISP'),
      nombreUS: localStorage.getItem('NomUs'),
      apellidoUS: localStorage.getItem('ApeUs'),
      mail: localStorage.getItem('mail'),
      USERSIGA: localStorage.getItem('IDUSiga'),
      PEI: localStorage.getItem('PEI'),
      multiple:true,//Configuración de DxFileUploader multiple
      showUploadProgress:false,
      uploadProgress:0,
      uploadBytes:{},
      Biblioteca:null,
      Carpeta:null,
      SitioSharepoint:null,
      loadingVisible: false,//Configuracion de loader
      showIndicator: true,
      shading: true,
      showPane: true,
      closeOnOutsideClick: false,
      
      //* O R D E N E S     V A R I A B L E S *//
      OrdenesCompra: [],//Tabla de ordenes de compra
      Acciones:[],//Selector de acciones
      Id_OrdenCompra:null,
      txtOC: "",
      RFCS: "",

      //* F A C T U R A S   V A R I A B L E S *//
      HeaderFacturasModal: "",
      txtFechaReqEnSitio: "",
      txtNombreComprador: "",
      txtId_Moneda: "",
      txtSubtotal: "",
      txtImpuestos: "",
      txtRetenidos: null,
      txtTotal: null,
      TotalOcNum:null,

      txtActivador: "",
      xmlDisabled: false,
      sendDisabled: true,
      showMensajeNoEnviar: false,
      pdfDisabled: true,
      EnvioFacturas:[],//Tabla de Conceptos en modal-1
      Id_OrdenCompraFecha:null,
      TotalesConImpuesto:[
        { ID : null, TotalesImpuesto : null, Monto : null, Recibido : null, RemisionNumerico: null, Remision:null, RemisionNumericoOriginal:null, Descuento:null, DescuentoNumerico:null, Fecha:null, FolioRecepcion:null, Facturado : null, PorFacturar : null, PorFacturarNumerico:null, SubtotalHito:null, SubtotalHitoNumerico:null, Moneda: null}
      ],
      maxLength: 500,
      ActFacRem: localStorage.getItem('PRem'),//Activacion de FacturasRemisiones
      FacRem: [{id:0, text:'Factura'}, {id:1, text:'Remisión'}],
      showNote:false,
      selFacturaRemision:0,
      
      selMonedaPago:0,
      selMonedaPagoDisabled:false,
      JSONMonedaPago:[],
      selOriginalFields:false,

      selReferenciaBancaria:null,
      Total_XML:0,

      selSubtotal:null,
      selSubtotalOriginal:null,
      selSubtotalDisabled:true,
      maxSub:0,
      selNumFactura:null,
      selNumFacturaDisabled: false,
      selImpuestos:null,
      selImpuestosOriginal:null,
      selImpuestosRetenidos:null,
      selImpuestosRetenidosOriginal:null,
      selISH:null,
      selISHOriginal:null,
      selISHDisabled:true,
      selImpuestosDisabled:true,
      selFechaFacturaStr:new Date(),
      selFechaFacturaDisable: false,
      dateFormat:"DD-MMM-YY",
      selDescuento:null,
      selDescuentoOriginal:null,
      selDescuentoDisabled:false,
      minTotal:1,
      maxTotal:9999999999,
      minDesc:0,
      maxDesc:9999999999,
      minImpRet:0,
      maxImpRet:9999999999,
      selTotal:null,
      selTotalOriginal:null,
      selTotalDisabled:false,
      selReferencia:null,
      selId_Moneda:null,
      selComentarios:null,
      xmlfiles: [],
      pdffiles: [],
      selSerie:null,
      selVersionCFDI:null,
      selRFC_Emisor:null,
      selRFC_Receptor:null,
      selUUID:null,
      selSello:null,
      EstatusCFDI:null,
      Id_RecepcionMaterial:null,
      EntradasFactura:[
        //{ID:null,Id_MaterialesEntradasSalidas:null,FechaRecibido:null,NumDocEntrada:null,Posicion:null,CodigoSAP:null,Descripcion:null,Unidad:null,CantRecibida:null,fmtImporteSinImpuestos:null,fmtImpuestos:null,fmtImporteConImpuestos:null,fmtTotalAFacturar:null,SubtotalAFacturar:null,ImpuestosAFacturar:null,TotalAFacturar:null}
      ],
      selectedRowKeysEntradas:[],
      selectedRowKeystxtEntradas:[],
      selectedEntradasArray:[],
      visibleEntradasIDs:[],
      dataGridRefEntradas: 'dataGride',
      selectionChangedBySelectBoxEntradas: false,
      Totaltxt:null,
      Hitotxt:null,
      PorcentajeNumerico:null,
      Porcentajetxt:null,
      TotalPorcentajetxt:null,
      EsLlegadaASitio:0,
      refXMLUploader: 'refXMLUploader',
      //txtFechaAprobacionOC: "",

      //* S O P O R T E S   V A R I A B L E S *//
      HeaderPopUpSoportes: "Soportes: OC",//Titulo de modal-4
      HeaderPopUpSoportesFiles: "Soportes: OC | Hito: ",//Titulo de modal-5
      tableSoportes:[],//Tabla de soportes
      Id_TipoFechaMaterial:null,//Id de row seleccionado
      Id_TipoDocumentacion:null,//Id de tipo de documentación
      Id_SubTipoDocumentacion:null,//Id de Subtipo de documentación
      soportesfiles:[],//Array de archivos cargados
      FechaEnvioSoporteDisabled:false,
      selFechaEnvioSoporte:new Date(),
      selFechaHastaSoporte:new Date(),
      DiasVigencia:0,

      //* C E R T I F I C A D O S   V A R I A B L E S *//
      HeaderPopUpCertificados: "",//Asociar Certificados a OC 4500012345
      HeaderPopUpCertificados31: "",
      HeaderPopUpCertificados32: "Alta de Certificado",
      Contrato: null,
      Proyecto: null,
      certificadosfiles:[],
      items:[],
      HeaderPopUpCertificadosModal: "CERTIFICADO: ",
      IdCertificado:null,
      TipoCertificado:null,
      txtCertificado:null,
      txtNombreArchivo:null,
      CertificadosProveedorOCposAsociadas: [],
      PosicionesAsociadas:'',
      NoCertificadoCarta:null,
      JSONTiposCertificado:[],
      selTiposCertificado:null,
      CertificadosProveedor: [],
      PosicionesCertificados:[
        /*{ID:1, Pos:10, Certificado:"Certificado 1234.pdf", Codigo: 1000000379, Descripcion: "BRIDA CODO 90° COD.62 2\" 6000 PSI"},
        {ID:2, Pos:20, Certificado:null, Codigo: null, Descripcion: null},
        {ID:3, Pos:30, Certificado:null, Codigo: null, Descripcion: null},
        {ID:4, Pos:40, Certificado:null, Codigo: null, Descripcion: null},
        {ID:5, Pos:50, Certificado:null, Codigo: null, Descripcion: null},
        {ID:6, Pos:60, Certificado:null, Codigo: null, Descripcion: null},
        {ID:7, Pos:70, Certificado:null, Codigo: null, Descripcion: null},
        {ID:8, Pos:80, Certificado:null, Codigo: null, Descripcion: null},
        {ID:9, Pos:90, Certificado:null, Codigo: null, Descripcion: null}*/
      ],
      PosicionesCertificadosPendientes:[
        {ID:1, Pos:10, Codigo: 1000000379, Descripcion: "BRIDA CODO 90° COD.62 2\" 6000 PSI"},
        {ID:2, Pos:20, Codigo: null, Descripcion: null},
        {ID:3, Pos:30, Codigo: null, Descripcion: null},
        {ID:4, Pos:40, Codigo: null, Descripcion: null},
        {ID:5, Pos:50, Codigo: null, Descripcion: null},
        {ID:6, Pos:60, Codigo: null, Descripcion: null},
        {ID:7, Pos:70, Codigo: null, Descripcion: null},
        {ID:8, Pos:80, Codigo: null, Descripcion: null},
        {ID:9, Pos:90, Codigo: null, Descripcion: null}
      ],
      selectedRowKeys:[],
      selectedRowKeystxt:[],
      dataGridRefName: 'dataGrid',
      selectionChangedBySelectBox: false,
      allMode: 'allPages',
      checkBoxesMode: 'always',
      tableCertificados:[
        {ID:1, Certificado:'Certificado 1234.PDF'},
        {ID:2, Certificado:'Certificado 4567.PDF'},
        {ID:3, Certificado:'Certificado 8999.PDF'}
      ],

      //*Busqueda OC
      OrdenCompraBusqueda: "",
      MostrarMotivo:false,
      MotivoOC:null,
      MotivoOCStyle: false
    };
  },
  created: function(){
    var that = this;
    if(that.$route.params.message){
      notify('Favor seleccionar una orden de compra valida', 'error', 10000);
    }
    //console.log(localStorage.getItem('token'))
    apiClient.get('/api/Proveedores/TiposDocumentacion', {
      params: { Todos: -1, FormatoXML: false },
      withLenguaje: true
    })
    .then(function (response) {
      if(that.PAISP=="MX"){
        that.xmlDisabled=false;
      }else{
        that.xmlDisabled=true;
      }
      that.Acciones = [];
      for (let value of response.data) {
        that.Acciones.push({
          Id_ClasificacionTipoDocumentacion: parseInt(value.Id_ClasificacionTipoDocumentacion),
          ClasificacionTipoDocumentacion: value.ClasificacionTipoDocumentacion,
          disabled: (value.Disabled == 'true'),
          selected: (value.Selected == 'true')
        });
      }
    })
    .catch(function (error) {
      console.log('Error: ' + error);
    });
    console.log(that.IDPU);
    console.log(that.IDUS);
    console.warn(localStorage.getItem('PEI'));
    console.warn(localStorage.getItem('FSF'));
    console.warn(localStorage.getItem('token'));
    that.loadingVisible = true;
    apiClient.get('/api/Proveedores/OCDocumentacionPendiente', {
      params: { FormatoXML: false }
    })
    .then(function (response) {
      that.OrdenesCompra = response.data;
      that.loadingVisible = false;
    })
    .catch(function (error) {
      that.loadingVisible = false;
      console.log('Error: ' + error);
    });
  },
  methods: {
    calcImpuesto(row) {
      const imp = parseFloat(row.TotalAFacturar || 0) - parseFloat(row.SubtotalAFacturar || 0);
      return '$' + imp.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    sayHelloWorld() {
        alert('Hello world!')
    },
    calculateCellValue(data) {
      return [data.Title, data.FirstName, data.LastName].join(' ');
    },
    actionSelected(data){
      if(data==0){
        return "Enviar...";
      }else if(data==1){
        return "Certificados";
      }else if(data==2){
        return "Soportes";
      }else if(data==3){
        return "Facturas";
      }else {
        return "Enviar...";
      }
    },
    onChange(registro, e){
      var that = this;
      const newValue = e.value;
      that.loadingVisible = true;
      console.log(registro);
      switch(newValue){
        case 1: //! C E R T I F I C A D O S
          that.Contrato = registro.data.Id_Contrato;
          that.Proyecto = registro.data.Id_Proyecto;
          that.Id_OrdenCompra = registro.data.Id_OrdenCompra;
          apiClient.get('/api/Certificados/getCertificadosProveedorOCposAsociadas', {
            params: { Id_Contrato: registro.data.Id_Contrato, Id_OrdenCompra: registro.data.Id_OrdenCompra, FormatoXML: false }
          })
          .then(function (response) {
            that.CertificadosProveedorOCposAsociadas = response.data;
            that.PosicionesAsociadas = response.data[0].PosicionesAsociadas;
            apiClient.get('/api/Certificados/getCertificadosProveedorOC', {
              params: { Id_Contrato: registro.data.Id_Contrato, Id_OrdenCompra: registro.data.Id_OrdenCompra, FormatoXML: false }
            })
            .then(function (response) {
              if(response.data[0].Estatus!='Error'){
                that.CertificadosProveedor = response.data;
                that.txtOC = registro.data.OC;
                that.HeaderPopUpCertificados = "Asociar Certificados a OC " + that.txtOC;
              }
              that.$refs['modal-3'].show();
              that.loadingVisible = false;
            })
            .catch(function (error) {
              that.CertificadosProveedor = [];
              console.log('Error: ' + error);
              that.loadingVisible = false;
            });
          })
          .catch(function (error) {
            console.log('Error: ' + error);
            that.loadingVisible = false;
          });




          break;
        case 2:
          //! S O P O R T E
          apiClient.get('/api/Facturas/getOC_HitosSoportes', {
            params: { Id_OrdenCompra: registro.data.Id_OrdenCompra, FormatoXML: false }
          })
          .then(function (response) {
            that.tableSoportes = response.data;
            that.txtOC = registro.data.OC;
            that.Id_OrdenCompra = registro.data.Id_OrdenCompra;
            that.loadingVisible = false;
          })
          .catch(function (error) {
            console.log('Error: ' + error);
            that.tableSoportes = [];
            that.loadingVisible = false;
          });
          that.$refs['modal-4'].show();
          that.HeaderPopUpSoportes = "SOPORTES: OC " + registro.data.OC;
          break;
        case 3:
          //! F A C T U R A S
          that.$refs['modal-1'].show();
          that.Id_OrdenCompra = registro.data.Id_OrdenCompra;
          apiClient.get('/api/Facturas/getOC_DatosGenerales', {
            params: { Id_OrdenCompra: registro.data.Id_OrdenCompra, FormatoXML: false }
          })
          .then(function (response) {
            that.Contrato = registro.data.Id_Contrato;
            var contratotxt = (registro.data.Contrato)?registro.data.Contrato:'Sin especificar';
            that.HeaderFacturasModal = "OC: " + response.data[0].OC + " / Contrato: " + contratotxt;
            that.txtId_Moneda = response.data[0].Id_Moneda;
            that.txtNombreComprador = response.data[0].NombreComprador;
            that.RFCS = registro.data.RFC_Arendal;
            that.txtFechaReqEnSitio = response.data[0].FechaReqEnSitio;
            that.txtOC = response.data[0].OC;
            that.txtSubtotal = response.data[0].Subtotal;
            that.txtImpuestos = response.data[0].Impuestos;
            that.txtRetenidos = parseFloat(response.data[0].Subtotal.replaceAll("$","").replaceAll(",","")).toFixed(2) * response.data[0].PorcentajeRetencion;
            that.txtTotal = parseFloat((parseFloat(response.data[0].Total.replaceAll("$","").replaceAll(",",""))-that.txtRetenidos).toFixed(2));
            that.TotalOcNum = (response.data[0].TotalNumerico-that.txtRetenidos).toFixed(2);
            that.txtActivador = response.data[0].Activador;
            apiClient.get('/api/Facturas/getOC_HitosFacturas', {
              params: { Id_OrdenCompra: registro.data.Id_OrdenCompra, FormatoXML: false },
              withLenguaje: true
            })
            .then(function (response) {
              if(response.data[0].Estatus!="OK"){
                that.EnvioFacturas = that.EnvioFacturas.length ? response.data : [];
                notify(response.data[0].Mensaje, 'warning', 10000);
              }else{
                that.EnvioFacturas = response.data;
              }
              that.loadingVisible = false;
            })
            .catch(function (error) {
              console.log('Error: ' + error);
              that.loadingVisible = false;
            });
          })
          .catch(function (error) {
            console.log('Error: ' + error);
            that.loadingVisible = false;
          });
          break;
      }
      //e.reset();  
      ///console.log(that.valueDefaultAccion[registro.data.Id_OrdenCompra]);
      ///that.valueDefaultAccion[registro.data.Id_OrdenCompra] = 0;
      //e.event.target.textContent='Enviar...';
      //e.previousValue = null;
      //e.value = null;
      //console.log(e.text);
    },
    onSubirClick:function(registro) {
      var that = this;
      //*Si el SP regresa un MensajeErrorSubir con texto, el boton se ve habilitado
      //*pero no abre la modal: solo muestra el mensaje de advertencia.
      var mensajeError = (registro.data.MensajeErrorSubir || '').trim();
      if(mensajeError != ''){
        notify(mensajeError, 'warning', 30000);
        return;
      }
      that.upFile(registro);
      that.$refs['modal-2'].show();
    },
    upFile:function(registro) {
      var that = this;
      console.log(registro);
      that.selFacturaRemision=0;
      that.EsLlegadaASitio = registro.data.FlagRecepcionMaterial;
      if(that.PAISP=="MX"){//!Proveedor Nacional
        if(that.EsLlegadaASitio==1){//!Es llegada a sitio
          that.xmlDisabled=(registro.data.RemisionNumerico==0)?true:false;
          that.sendDisabled = (registro.data.RemisionNumerico==0)?true:false;//Remision en boton
          that.pdfDisabled = (registro.data.RemisionNumerico==0)?true:false;//Remision en boton
          that.selDescuentoDisabled = true;
          that.selTotalDisabled = true;
        }else{//!Factura Normal
          that.xmlDisabled=false;
          that.sendDisabled = false;
          that.pdfDisabled = false;
          if(that.selFacturaRemision==0){//!Si es Factura
            that.selDescuentoDisabled = true;
            that.selTotalDisabled = true;
          }else{
            that.selDescuentoDisabled = false;
            that.selTotalDisabled = false;
          }
        }
      }else{//*Proveedor Internacional
        if(that.EsLlegadaASitio==1){//!Es llegada a sitio
          that.sendDisabled = true;
          that.pdfDisabled = true;
          that.xmlDisabled=true;
          that.selDescuentoDisabled = true;
          that.selTotalDisabled = true;
        }else{//!Factura Normal
          that.xmlDisabled=true;
          that.sendDisabled = false;
          that.pdfDisabled = false;
          if(that.selFacturaRemision==0){//!Si es Factura
            if(registro.data.RemisionNumerico==0){//!Si no existe remision //that.TotalesConImpuesto[0].RemisionNumerico
              that.selDescuentoDisabled = false;
              that.selTotalDisabled = false;
            }else{
              that.selDescuentoDisabled = true;
              that.selTotalDisabled = true;
            }
          }else{
            that.selDescuentoDisabled = false;
            that.selTotalDisabled = false;
          }
        }
      }
      that.selectedRowKeysEntradas = [];
      that.visibleEntradasIDs = [];
      that.pdffiles=[];
      that.xmlfiles=[];
      that.EstatusCFDI=null;
      that.Id_RecepcionMaterial = (registro.data.Id_RecepcionMaterial)?registro.data.Id_RecepcionMaterial:0;
      that.TotalesConImpuesto[0].TotalesImpuesto = registro.data.HitoDePago;
      that.TotalesConImpuesto[0].Monto = registro.data.MontoHito;
      that.TotalesConImpuesto[0].Recibido = registro.data.Recibido;
      that.TotalesConImpuesto[0].Facturado = registro.data.Facturado;
      that.TotalesConImpuesto[0].PorFacturar = registro.data.PorFacturar;
      that.TotalesConImpuesto[0].SubtotalHito = registro.data.SubtotalHito; console.log(registro.data.SubtotalHito)
      that.TotalesConImpuesto[0].SubtotalHitoNumerico = registro.data.SubtotalHitoNumerico; console.log(registro.data.SubtotalHitoNumerico)
      that.TotalesConImpuesto[0].Moneda = that.txtId_Moneda;
      that.TotalesConImpuesto[0].ID = registro.data.Id;
      that.TotalesConImpuesto[0].PorFacturarNumerico = (registro.data.RemisionNumerico==0)?registro.data.PorFacturarNumerico:registro.data.RemisionNumerico;
      that.TotalesConImpuesto[0].RemisionNumerico = registro.data.RemisionNumerico;
      that.TotalesConImpuesto[0].Remision = registro.data.Remision;
      that.TotalesConImpuesto[0].RemisionNumericoOriginal = registro.data.RemisionNumerico;
      that.TotalesConImpuesto[0].DescuentoNumerico = registro.data.DescuentoNumerico;
      that.TotalesConImpuesto[0].Descuento = registro.data.Descuento;
      that.TotalesConImpuesto[0].ImpuestosRetenidos = registro.data.RetencionesNumerico;
      that.TotalesConImpuesto[0].FechaRecepcion = registro.data.FechaRecepcion;
      that.TotalesConImpuesto[0].FolioRecepcion = registro.data.FolioRecepcion;

      //* Limites del Total Factura segun escenario:
      //*  - Llegada a sitio (FlagRecepcionMaterial==1): sin restriccion (se calcula por entradas).
      //*  - Remision ya cargada (RemisionNumerico!=0): la factura debe ser por el TOTAL exacto de la remision -> bloqueado (min=max).
      //*  - Factura normal / seleccion de partidas (sin remision): parcial permitido, piso 1, tope = monto por facturar.
      if(registro.data.FlagRecepcionMaterial==1){
        that.minTotal=0;
        that.maxTotal=9999999999;
      }else if(registro.data.RemisionNumerico!=0){
        that.minTotal=parseFloat(registro.data.RemisionNumerico);
        that.maxTotal=parseFloat(registro.data.RemisionNumerico);
      }else{
        that.minTotal=1;
        that.maxTotal=parseFloat(registro.data.PorFacturarNumerico);
      }

      that.Hitotxt = registro.data.HitoDePago;
      that.PorcentajeNumerico = registro.data.PorcentajeNumerico;
      that.Porcentajetxt = registro.data.Porcentaje;
      that.Totaltxt = USDollar.format(that.txtTotal) + ' ' + that.txtId_Moneda;
      that.TotalPorcentajetxt = parseFloat(parseFloat(that.TotalOcNum).toFixed(2) * parseFloat(that.PorcentajeNumerico));

      that.Id_OrdenCompraFecha = (registro.data.Id)?registro.data.Id:null;
      that.selId_Moneda = that.txtId_Moneda;
      ///that.HeaderPopUp = "Orden Compra " + that.txtOC;
      that.Biblioteca=registro.data.Biblioteca;
      that.Carpeta=registro.data.PathSharepointPaso;
      that.SitioSharepoint=registro.data.SitioSharepoint;
      console.log(that.Carpeta);

      /*that.EntradasFactura=[
        {ID:1,Id_MaterialesEntradasSalidas:1,FechaRecibido:'15-SEP-21',NumDocEntrada:'500001234',Posicion:10,CodigoSAP:'10001212',Descripcion:'TUBO 2” ',Unidad:'PZA',CantRecibida:3.00,fmtImporteSinImpuestos:'$1,160.00',fmtImpuestos:"$1000.00",fmtImporteConImpuestos:"$0.00",fmtTotalAFacturar:'$10000.00',SubtotalAFacturar:9000.00,ImpuestosAFacturar:1000.00,TotalAFacturar:10000.00},
        {ID:2,Id_MaterialesEntradasSalidas:2,FechaRecibido:'15-SEP-21',NumDocEntrada:'500001234',Posicion:20,CodigoSAP:'10005342',Descripcion:'CODO 2” ',Unidad:'PZA',CantRecibida:5.00,fmtImporteSinImpuestos:'$290.00'  ,fmtImpuestos:"$1600.00",fmtImporteConImpuestos:"$0.00",fmtTotalAFacturar:'$10100.00',SubtotalAFacturar:8500.00,ImpuestosAFacturar:1600.00,TotalAFacturar:10100.00},
        {ID:3,Id_MaterialesEntradasSalidas:3,FechaRecibido:'15-SEP-21',NumDocEntrada:'500001234',Posicion:30,CodigoSAP:'10005342',Descripcion:'COPLE 2“',Unidad:'PZA',CantRecibida:1.00,fmtImporteSinImpuestos:'$200.00'  ,fmtImpuestos:"$1165.00",fmtImporteConImpuestos:"$0.00",fmtTotalAFacturar:'$10097.50',SubtotalAFacturar:8932.33,ImpuestosAFacturar:1165.17,TotalAFacturar:10097.50},
        {ID:4,Id_MaterialesEntradasSalidas:4,FechaRecibido:'29-SEP-21',NumDocEntrada:'500004423',Posicion:10,CodigoSAP:'10001212',Descripcion:'TUBO 2” ',Unidad:'PZA',CantRecibida:3.00,fmtImporteSinImpuestos:'$1,160.00',fmtImpuestos:"$10.00",fmtImporteConImpuestos:"$0.00",fmtTotalAFacturar:'$812.00',SubtotalAFacturar:802.00,ImpuestosAFacturar:10.00,TotalAFacturar:812.00},
        {ID:5,Id_MaterialesEntradasSalidas:5,FechaRecibido:'29-SEP-21',NumDocEntrada:'500004423',Posicion:20,CodigoSAP:'10005342',Descripcion:'CODO 2“ ',Unidad:'PZA',CantRecibida:5.00,fmtImporteSinImpuestos:'$290.00'  ,fmtImpuestos:"$10.00",fmtImporteConImpuestos:"$0.00",fmtTotalAFacturar:'$203.00',SubtotalAFacturar:193.00,ImpuestosAFacturar:10.00,TotalAFacturar:203.00},
        {ID:6,Id_MaterialesEntradasSalidas:6,FechaRecibido:'29-SEP-21',NumDocEntrada:'500004423',Posicion:30,CodigoSAP:'10005342',Descripcion:'COPLE 2“',Unidad:'PZA',CantRecibida:1.00,fmtImporteSinImpuestos:'$200.00'  ,fmtImpuestos:"$10.00",fmtImporteConImpuestos:"$0.00",fmtTotalAFacturar:'$140.00',SubtotalAFacturar:130.00,ImpuestosAFacturar:10.00,TotalAFacturar:140.00}
      ]*/

      //Inputs
      that.selSubtotal = (registro.data.FlagRecepcionMaterial==1)?0.00:parseFloat(parseFloat(registro.data.SubtotalHitoNumerico).toFixed(2))-parseFloat(parseFloat(registro.data.FacturadoSinIVANumerico).toFixed(2));
      that.selSubtotalOriginal = (registro.data.FlagRecepcionMaterial==1)?0.00:parseFloat(parseFloat(registro.data.SubtotalHitoNumerico).toFixed(2)-parseFloat(parseFloat(registro.data.FacturadoSinIVANumerico).toFixed(2)));
      that.maxSub = (registro.data.FlagRecepcionMaterial==1)?0.00:parseFloat(parseFloat(registro.data.SubtotalHitoNumerico).toFixed(2))-parseFloat(parseFloat(registro.data.FacturadoSinIVANumerico).toFixed(2));
      that.selDescuento=parseFloat(registro.data.DescuentoNumerico);
      that.selDescuentoOriginal=parseFloat(registro.data.DescuentoNumerico);
      var tottem = (registro.data.RemisionNumerico==0)?registro.data.PorFacturarNumerico:registro.data.RemisionNumerico;
      var imprettem = (parseFloat(registro.data.RetencionesNumerico))?parseFloat(registro.data.RetencionesNumerico):0.00;
      that.selTotal=(registro.data.FlagRecepcionMaterial==1)?0.00:parseFloat(parseFloat(tottem).toFixed(2));
      that.selTotalOriginal=(registro.data.FlagRecepcionMaterial==1)?0.00:parseFloat(parseFloat(tottem).toFixed(2));
      that.selImpuestosRetenidos=(parseFloat(registro.data.RetencionesNumerico))?parseFloat(registro.data.RetencionesNumerico):0.00;
      that.selImpuestosRetenidosOriginal=(parseFloat(registro.data.RetencionesNumerico))?parseFloat(registro.data.RetencionesNumerico):0.00;
      that.maxImpRet = (registro.data.FlagRecepcionMaterial==1)?0.00:parseFloat(parseFloat(parseFloat(tottem)-(parseFloat(registro.data.SubtotalHitoNumerico)-parseFloat(registro.data.DescuentoNumerico))).toFixed(2));//that.selDescuento=parseFloat(registro.data.DescuentoNumerico);
      that.selImpuestos=(registro.data.FlagRecepcionMaterial==1)?0.00:parseFloat(parseFloat(parseFloat(tottem)-parseFloat(imprettem)-(parseFloat(registro.data.SubtotalHitoNumerico)-parseFloat(registro.data.DescuentoNumerico)-parseFloat(registro.data.FacturadoSinIVANumerico))).toFixed(2));//that.selDescuento=parseFloat(registro.data.DescuentoNumerico);
      console.error(that.selImpuestos);
      console.error(tottem+'-'+imprettem+'-'+registro.data.SubtotalHitoNumerico+'-'+registro.data.DescuentoNumerico);
      that.selImpuestosOriginal=(registro.data.FlagRecepcionMaterial==1)?0.00:parseFloat(parseFloat(parseFloat(tottem)-parseFloat(imprettem)-(parseFloat(registro.data.SubtotalHitoNumerico)-parseFloat(registro.data.DescuentoNumerico)-parseFloat(registro.data.FacturadoSinIVANumerico))).toFixed(2));//that.selDescuento=parseFloat(registro.data.DescuentoNumerico);
      that.selISH=0;
      that.selNumFactura=null;
      //that.selFechaFacturaStr='';
      that.selReferencia='';
      that.selComentarios='';
      that.selFechaFacturaStr = new Date();
      that.selFechaFacturaDisable = false;
      that.selSubtotalDisabled = true; //(registro.data.FlagRecepcionMaterial==1)?true:
      that.selImpuestosDisabled = true;//(registro.data.FlagRecepcionMaterial==1)?
      that.selISHDisabled = true;//(registro.data.FlagRecepcionMaterial==1)?
      that.selNumFacturaDisabled = false;
      //that.FacRem[1].disabled = (that.TotalesConImpuesto[0].RemisionNumerico!=0 || that.EsLlegadaASitio==1)?true:false;
      console.log(that.TotalesConImpuesto[0].RemisionNumerico+"!="+0+"||"+that.EsLlegadaASitio+"=="+1);
      that.FacRem[1].disabled = (that.TotalesConImpuesto[0].RemisionNumerico!=0)?true:false;
      console.log(registro);

      apiClient.post('/api/Facturas/OCEntradasSinFactura', {
        Id_Contrato: that.Contrato,
        OC: that.txtOC,
        PorcentajeHito: parseFloat(that.PorcentajeNumerico),
        FormatoXML: false
      })
      .then(function (response) {
        that.EntradasFactura = response.data;
      })
      .catch(function () {
        that.EntradasFactura = [];
      });

      apiClient.get('/api/Proveedores/MonedasPagoOC', {
        params: { OC: that.txtOC, Subtotal: that.selTotal, FormatoXML: false }
      })
      .then(function (response) {
        that.JSONMonedaPago = response.data;
        that.selMonedaPago = response.data[0].Id_PagoSAP;
      })
      .catch(function (error) {
        console.log('Error: ' + error);
      });
      console.log(that.Id_OrdenCompra);
      console.log(that.txtOC);

      if(localStorage.getItem('PEI')==0 && localStorage.getItem('FSF')==0){
        that.sendDisabled = true;
        that.showMensajeNoEnviar = true;
      }else{
        that.showMensajeNoEnviar = false;
      }
     // that.MonedasPago();
    },
    enviar:function(){
      var that = this;
      console.log(that.Id_RecepcionMaterial);
      console.log(that.pdffiles);
      //?SI LA ES UNA REMISION SE TOMARAN LOS VALORES SIN "Original"
      if(that.selFacturaRemision){
        var selSubtotal = that.selSubtotal;
        var selDescuento = that.selDescuento;
        var selImpuestos = that.selImpuestos;
        var selImpuestosRetenidos = that.selImpuestosRetenidos;
        var selISH = that.selISH;
        var selTotal = that.selTotal;
      }else{
        if(that.selMonedaPago==0){
          var selSubtotal = that.selSubtotal;
          var selDescuento = (that.selDescuento)?that.selDescuento:0;
          var selImpuestos = that.selImpuestos;
          var selImpuestosRetenidos = that.selImpuestosRetenidos;
          var selISH = (that.selISH)?that.selISH:0;
          var selTotal = that.selTotal;
        }else{
          var selSubtotal = that.selSubtotalOriginal;
          var selDescuento = (that.selDescuentoOriginal)?that.selDescuentoOriginal:0;
          var selImpuestos = that.selImpuestosOriginal;
          var selImpuestosRetenidos = that.selImpuestosRetenidosOriginal;
          var selISH = (that.selISHOriginal)?that.selISHOriginal:0;
          var selTotal = that.selTotalOriginal;
        }
      }
      console.log({
        selSubtotal:selSubtotal,
        selDescuento:selDescuento,
        selImpuestos:selImpuestos,
        selImpuestosRetenidos:selImpuestosRetenidos,
        selISH:selISH,
        selTotal:selTotal,
        selMonedaPago:that.selMonedaPago
      });
      var IEPSorISH = (isNaN(selISH)||parseFloat(selISH)==0)?0:selISH;
  
      var ReferenciaBancaria = (that.selReferenciaBancaria)?that.selReferenciaBancaria:'';

      var parametros = [{
        /*1 */"@Id_OrdenCompraFecha":that.Id_OrdenCompraFecha,
        /*2 */"@Id_OrdenCompra":that.Id_OrdenCompra,
        /*3 *///"@NumFactura":numeroFactura,
        /*4 *///"@FechaFacturaStr":newFechaFactura,
        /*5 */"@Subtotal":(parseFloat(selSubtotal)+parseFloat(IEPSorISH)),
        /*6 */"@Descuento":selDescuento.toFixed(2),
        /*7 */"@Impuestos":selImpuestos,
        /*  */"Retenciones":selImpuestosRetenidos,
        /*8 */"@Total":selTotal,
        /*9 */"@Id_Moneda":that.selId_Moneda,
        /*10 */"@Referencia":that.selReferencia,
        /*11*///"@Comentarios":Comentarios,
        /*12*///"@NombreDocumentoPDF":newNamepdf,
        /*13*///"@NombreDocumentoXML":newNamexml,
        /*14*/"@Id_ProveedorUsuario":that.IDPU,
        /*15*///"@Serie":serie,
        /*16*/"@VersionCFDI":that.selVersionCFDI,
        /*17*/"@RFC_Emisor":that.selRFC_Emisor,
        /*18*/"@RFC_Receptor":that.selRFC_Receptor,
        /*19*/"@UUID":that.selUUID,
        /*20*/"@Sello":that.selSello,
        /*21*/"@Remision":that.selFacturaRemision,
        /*22*///"@EstadoCFDI":EstatusCFDI,
        /*23*/"@Id_RecepcionMaterial":that.Id_RecepcionMaterial,
        /*24*/"@Id_PagoSAP":that.selMonedaPago,
        /*25*/"@ReferenciaBancaria":ReferenciaBancaria,
        /*26*/"@Total_XML":that.Total_XML
      }];
      console.log(parametros);


      //var MontoFactura = that.TotalesConImpuesto[0].PorFacturar.replace('$', '');
      //MontoFactura = MontoFactura.replace(',', '');
      if(that.PAISP!="MX" || that.selFacturaRemision){
        that.xmlfiles.push({name:'4rch1v0n03nc0ntr4d0.xml'});
      }
      console.log(that.pdffiles);
      console.log(that.pdffiles[0]);
      console.log(that.pdffiles.length);
      console.log('XML');
      console.log(that.xmlfiles);
      console.log(that.xmlfiles[0]);
      console.log(that.xmlfiles.length);
      console.log(that.Carpeta);
      console.log(that.Total_XML);
      //* READING XML FILE BEFORE UPLOAD*//
      
      if(that.xmlfiles.length){
        var extensionxml = that.xmlfiles[0].name.substr( (that.xmlfiles[0].name.lastIndexOf('.') +1) );
        if(extensionxml.toUpperCase()=='XML'){
          if(that.pdffiles.length){
            var extensionpdf = that.pdffiles[0].name.substr( (that.pdffiles[0].name.lastIndexOf('.') +1) );
            if(extensionpdf.toUpperCase()=='PDF'){
              if(that.selNumFactura && !that.selNumFactura.includes("undefined")){
                ///that.selNumFactura = that.selNumFactura.replace(/[^a-zA-Z0-9]/g, "");
                if(that.selFechaFacturaStr){
                  console.log(`${localStorage.getItem('PEI')}==0 (${localStorage.getItem('PEI')} == 1 && ${this.selReferenciaBancaria} != '')`)
                  if (localStorage.getItem('PEI') == 0 || (localStorage.getItem('PEI') == 1 && this.selReferenciaBancaria != '')){
                    if(selSubtotal>=1){
                      if(selImpuestos>=0 || that.EstatusCFDI.includes("Vigente")){//=='Vigente'
                        if(selTotal>=1){
                          that.loadingVisible = true;
                          var formData;
                          var pair;
                          var newNamexml=null;
                          if(that.xmlfiles[0].name!='4rch1v0n03nc0ntr4d0.xml'){
                            //: G U A R D A D O   D E   X M L   E N   S H A R E P O I N T
                            var selectedFilexml = that.xmlfiles[0];
                            var extensionxml = selectedFilexml.name.substr( (selectedFilexml.name.lastIndexOf('.') +1) );
                            newNamexml = selectedFilexml.name.split('.').slice(0, -1).join('.');
                            newNamexml = newNamexml.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(/[^\w\s]/gi,"");
                            newNamexml=newNamexml+'.'+extensionxml;
                            console.log(newNamexml); 

                            formData = new FormData();
                            formData.append('NombreArchivo', newNamexml);
                            formData.append('BibliotecaSharepoint', that.Biblioteca);
                            formData.append('PathSharepoint', that.Carpeta);
                            formData.append('SitioSharepoint', that.SitioSharepoint);
                            formData.append("ReemplazarArchivo", "true");
                            formData.append('file', that.xmlfiles[0]);
                            for (pair of formData.entries()) {
                                console.log(pair[0]+ ', ' + pair[1]);
                            }
                            console.log(that.xmlfiles[0]);
                            console.log(formData);
                            apiClient.post('/api/SharePoint/subir-archivo-t', formData, {
                              headers: { 'Content-Type': undefined },
                              onUploadProgress: function(e){ that.showUploadProgress = true; if(e.total){ that.uploadProgress = Math.round((e.loaded/e.total)*100); if(that.uploadProgress>=100){ setTimeout(function(){ that.showUploadProgress=false; },800); } } }
                            })
                            .then(function (response) {
                                console.log(response);
                                var isSuccess = (typeof response.data === 'string' && response.data.toLowerCase().includes('exitosamente')) || 
                                               (response.data && response.data.ERROR=="False");
                                if(isSuccess){
                                  console.log('Archivo xml guardado correctamente')
                                  //notify('Archivo xml guardado correctamente', 'success', 10000);   
                                }else{
                                  that.loadingVisible = false;
                                  var errorMsg = (response.data && response.data.ERROR) ? response.data.ERROR : 'Error desconocido';
                                  var msnMsg = (response.data && response.data.MSN) ? response.data.MSN : JSON.stringify(response.data);
                                  notify('Ocurrio un error inesperado contacte al administrador "'+errorMsg + ' ' + msnMsg+' Line:1221"', 'error', 15000);
                                }
                            })
                            .catch(function (response) {
                              //handle error
                                console.log(response);
                                notify('Error al guardar xml: msg->' + response.data.MSN, 'error', 10000);
                            });
                          }
                          //: G U A R D A D O   D E   P D F   E N   S H A R E P O I N T
                          var selectedFilepdf = that.pdffiles[0];
                          var extensionpdf = selectedFilepdf.name.substr( (selectedFilepdf.name.lastIndexOf('.') +1) );
                          var newNamepdf = selectedFilepdf.name.split('.').slice(0, -1).join('.');
                          newNamepdf = newNamepdf.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(/[^\w\s]/gi,"");
                          newNamepdf=newNamepdf+'.'+extensionpdf;

                          formData = new FormData();
                          formData.append('NombreArchivo', newNamepdf);//formData.append('NombreArchivo', that.pdffiles[0].name);
                          formData.append('BibliotecaSharepoint', that.Biblioteca);
                          formData.append('PathSharepoint', that.Carpeta);
                          formData.append('SitioSharepoint', that.SitioSharepoint);
                          formData.append("ReemplazarArchivo", "true");
                          formData.append('file', that.pdffiles[0]);
                          for (pair of formData.entries()) {
                              console.log(pair[0]+ ', ' + pair[1]); 
                          }
                          console.log(that.pdffiles[0]);
                          apiClient.post('/api/SharePoint/subir-archivo-t', formData, {
                            headers: { 'Content-Type': undefined },
                            onUploadProgress: function(e){ that.showUploadProgress = true; if(e.total){ that.uploadProgress = Math.round((e.loaded/e.total)*100); if(that.uploadProgress>=100){ setTimeout(function(){ that.showUploadProgress=false; },800); } } }
                          })
                          .then(function (response) {
                            //handle success
                            console.log(response);
                            var isSuccess = (typeof response.data === 'string' && response.data.toLowerCase().includes('exitosamente')) || 
                                           (response.data && response.data.ERROR=="False");
                            if(isSuccess){
                              //notify('MSN: '+response.data.MSN, 'error');
                              console.log('Archivo pdf guardado correctamente');
                              //notify('Archivo pdf guardado correctamente', 'success', 5000);
                              var newFechaFactura;
                              if(that.selFechaFacturaStr.length == 9){
                                newFechaFactura = that.selFechaFacturaStr;
                              }else{
                                const meses = {
                                  0: 'ENE',
                                  1: 'FEB',
                                  2: 'MAR',
                                  3: 'ABR',
                                  4: 'MAY',
                                  5: 'JUN',
                                  6: 'JUL',
                                  7: 'AGO',
                                  8: 'SEP',
                                  9: 'OCT',
                                  10: 'NOV',
                                  11: 'DIC'
                                }
                                newFechaFactura = that.selFechaFacturaStr.getDate()+"-"+meses[that.selFechaFacturaStr.getMonth()]+"-"+that.selFechaFacturaStr.getFullYear();
                              }
                              if(that.xmlfiles[0].name=='4rch1v0n03nc0ntr4d0.xml'){
                                that.xmlfiles[0].name='';
                                newNamexml='';
                              }
                              var serie = (that.selSerie)?""+that.selSerie+"":null;
                              var EstatusCFDI = (that.EstatusCFDI)?""+that.EstatusCFDI+"":null;
                              console.log(that.selFechaFacturaStr.length);

                              var data = [];
                              if(that.EsLlegadaASitio==1){
                                that.selectedEntradasArray.forEach(function callback(currentValue, index, array) {
                                  // tu iterador
                                  data.push({Id:currentValue.ID});
                                });
                              }else{
                                data=[{Id:0}];
                              }
                              console.log(data);
                              console.log(selISH);
                              var IEPSorISH = (isNaN(selISH)||parseFloat(selISH)==0)?0:selISH;
                              console.log(parseFloat(selSubtotal))
                              console.log(parseFloat(IEPSorISH))
                              console.log(isNaN(selISH)+"||"+parseFloat(selISH)+"=="+0);
                              var numeroFactura = that.selNumFactura.replaceAll('"', '&quot;');
                              numeroFactura = numeroFactura.replaceAll("'", "&#39;");
                              ///var numeroFactura = that.selNumFactura.replaceAll("'","");
                              ///numeroFactura = numeroFactura.replace(/[^a-zA-Z0-9 ]/g, "");
                              var Comentarios = that.selComentarios.replaceAll('"', '&quot;');
                              Comentarios = Comentarios.replaceAll("'", "&#39;");
                              ///var Comentarios = that.selComentarios.replaceAll("'","");
                              ///Comentarios = Comentarios.replace(/[^a-zA-Z0-9 ]/g, "");

                              var parametros = [{
                                                  /*1 */"@Id_OrdenCompraFecha":that.Id_OrdenCompraFecha,
                                                  /*2 */"@Id_OrdenCompra":that.Id_OrdenCompra,
                                                  /*3 */"@NumFactura":numeroFactura,
                                                  /*4 */"@FechaFacturaStr":newFechaFactura,
                                                  /*5 */"@Subtotal":(parseFloat(selSubtotal)+parseFloat(IEPSorISH)),
                                                  /*6 */"@Descuento":selDescuento.toFixed(2),
                                                  /*7 */"@Impuestos":selImpuestos,
                                                  /*  */"Retenciones":selImpuestosRetenidos,
                                                  /*8 */"@Total":selTotal,
                                                  /*9 */"@Id_Moneda":that.selId_Moneda,
                                                  /*10 */"@Referencia":that.selReferencia,
                                                  /*11*/"@Comentarios":Comentarios,
                                                  /*12*/"@NombreDocumentoPDF":newNamepdf,
                                                  /*13*/"@NombreDocumentoXML":newNamexml,
                                                  /*14*/"@Id_ProveedorUsuario":that.IDPU,
                                                  /*15*/"@Serie":serie,
                                                  /*16*/"@VersionCFDI":that.selVersionCFDI,
                                                  /*17*/"@RFC_Emisor":that.selRFC_Emisor,
                                                  /*18*/"@RFC_Receptor":that.selRFC_Receptor,
                                                  /*19*/"@UUID":that.selUUID,
                                                  /*20*/"@Sello":that.selSello,
                                                  /*21*/"@Remision":that.selFacturaRemision,
                                                  /*22*/"@EstadoCFDI":EstatusCFDI,
                                                  /*23*/"@Id_RecepcionMaterial":that.Id_RecepcionMaterial,
                                                  /*24*/"@Id_PagoSAP":that.selMonedaPago,
                                                  /*25*/"@ReferenciaBancaria":ReferenciaBancaria,
                                                  /*26*/"@Total_XML":that.Total_XML
                                                }];
                              console.log("{ 'stJson':'" + JSON.stringify(data) + "', 'parametros':'" + JSON.stringify(parametros) + "', 'sp':'sp_prv_updOC_EnviarFactura_XML', 'parametroTabla':'Ids_MaterialesEntradasSalidas'}");
                              var entr = "";
                              $.each(data, function( index, value ) {
                                entr += "Insert @Ids_MaterialesEntradasSalidas ([Id]) Values ("+value.Id+")\n";
                              });
                              console.log("Declare @Ids_MaterialesEntradasSalidas as ListaDeNumerosEnteros \n"+entr+"EXEC [sp_prv_updOC_EnviarFactura_XML] " 
                              + that.Id_OrdenCompraFecha + ", " 
                              + that.Id_OrdenCompra + ", '" 
                              + escapeURI(that.selNumFactura,"e") + "', '" 
                              + newFechaFactura + "', " 
                              + (parseFloat(selSubtotal)+parseFloat(IEPSorISH)) + ", " 
                              + selDescuento.toFixed(2) + ", " 
                              + selImpuestos + ", "
                              + selImpuestosRetenidos + ", " 
                              + selTotal + ", '" 
                              + that.selId_Moneda + "', '" 
                              + escapeURI(that.selReferencia,"e") + "', '" 
                              + escapeURI(that.selComentarios,"e") + "', '" 
                              + escapeURI(newNamepdf,"e") + "', '" 
                              + escapeURI(newNamexml,"e") + "', " 
                              + that.IDPU + ", '" 
                              + serie + "', '" 
                              + that.selVersionCFDI + "', '" 
                              + that.selRFC_Emisor + "', '" 
                              + that.selRFC_Receptor + "', '" 
                              + that.selUUID + "', '" 
                              + that.selSello + "', " 
                              + that.selFacturaRemision + ", '" 
                              + EstatusCFDI + "', " 
                              + that.Id_RecepcionMaterial + ", "
                              + that.selMonedaPago + ", '"
                              + ReferenciaBancaria + "', "
                              + that.Total_XML +", @Ids_MaterialesEntradasSalidas");
                              setTimeout(function(){
                                apiClient.put('/api/Facturas/updOC_EnviarFactura', {
                                  Id_OrdenCompraFecha: that.Id_OrdenCompraFecha,
                                  Id_OrdenCompra: that.Id_OrdenCompra,
                                  NumFactura: numeroFactura,
                                  FechaFacturaStr: newFechaFactura,
                                  Subtotal: parseFloat(selSubtotal)+parseFloat(IEPSorISH),
                                  Descuento: parseFloat(selDescuento.toFixed(2)),
                                  Impuestos: selImpuestos,
                                  Retenciones: selImpuestosRetenidos,
                                  Total: selTotal,
                                  Id_Moneda: that.selId_Moneda,
                                  Referencia: that.selReferencia,
                                  Comentarios: Comentarios,
                                  NombreDocumentoPDF: newNamepdf,
                                  NombreDocumentoXML: newNamexml,
                                  Serie: serie,
                                  VersionCFDI: that.selVersionCFDI,
                                  RFC_Emisor: that.selRFC_Emisor,
                                  RFC_Receptor: that.selRFC_Receptor,
                                  UUID: that.selUUID,
                                  Sello: that.selSello,
                                  Remision: that.selFacturaRemision,
                                  EstadoCFDI: EstatusCFDI,
                                  Id_RecepcionMaterial: that.Id_RecepcionMaterial,
                                  Id_PagoSAP: that.selMonedaPago,
                                  ReferenciaBancaria: ReferenciaBancaria,
                                  Total_XML: that.Total_XML,
                                  Ids_MaterialesEntradasSalidas: data.map(d => d.Id),
                                  FormatoXML: false,
                                  Debug: 0
                                }, { withLenguaje: true })
                                .then(function (response) {
                                  var obj = response.data;
                                  console.log(obj);
                                  if(that.PAISP=="MX"){
                                    that.xmlDisabled=false;
                                  }else{
                                    that.xmlDisabled=true;
                                  }
                                  if(obj[0].Estatus=="ERROR"){
                                    notify(obj[0].Mensaje, 'error', 15000);
                                  }else if(obj[0].Estatus=="OK"){
                                    notify(obj[0].Mensaje, 'success', 15000);
                                  }else{
                                    notify(obj[0].Mensaje, 'error', 15000);
                                  }
                                  apiClient.get('/api/Facturas/getOC_HitosFacturas', {
                                    params: { Id_OrdenCompra: that.Id_OrdenCompra, FormatoXML: false },
                                    withLenguaje: true
                                  })
                                  .then(function (response) {
                                    if(response.data[0].Estatus!="OK"){
                                      that.EnvioFacturas = that.EnvioFacturas.length ? response.data : [];
                                      notify(response.data[0].Mensaje, 'warning', 10000);
                                    }else{
                                      that.EnvioFacturas = response.data;
                                    }
                                  })
                                  .catch(function (error) {
                                    console.log('Error: ' + error);
                                  });
                                  that.$refs['modal-2'].hide();
                                  that.loadingVisible = false;
                                })
                                .catch(function (error) {
                                  console.log('Error: ' + error);
                                  that.$refs['modal-2'].hide();
                                  that.loadingVisible = false;
                                });
                              }, 1000);
                            }else{
                              that.$refs['modal-2'].hide();
                              that.loadingVisible = false;
                              var errorMsg = (response.data && response.data.ERROR) ? response.data.ERROR : 'Error desconocido';
                              var msnMsg = (response.data && response.data.MSN) ? response.data.MSN : JSON.stringify(response.data);
                              notify('Ocurrio un error inesperado contacte al administrador "'+errorMsg + ' ' + msnMsg+' Line:1325"', 'error', 15000);
                            }
                            apiClient.get('/api/Proveedores/OCDocumentacionPendiente', {
                              params: { FormatoXML: false }
                            })
                            .then(function (response) {
                              that.OrdenesCompra = response.data;
                            })
                            .catch(function (error) {
                              console.log('Error: ' + error);
                            });
                            apiClient.get('/api/Facturas/getOC_DatosGenerales', {
                              params: { Id_OrdenCompra: that.Id_OrdenCompra, FormatoXML: false }
                            })
                            .then(function (response) {
                              that.txtId_Moneda = response.data[0].Id_Moneda;
                              that.txtNombreComprador = response.data[0].NombreComprador;
                              that.txtFechaReqEnSitio = response.data[0].FechaReqEnSitio;
                              that.txtOC = response.data[0].OC;
                              that.txtSubtotal = response.data[0].Subtotal;
                              that.txtImpuestos = response.data[0].Impuestos;
                              that.txtTotal = parseFloat(response.data[0].Total);
                              that.txtActivador = response.data[0].Activador;
                              console.log('succes one');
                            })
                            .catch(function (error) {
                              console.log('Error: ' + error);
                            });
                            apiClient.get('/api/Facturas/getOC_HitosFacturas', {
                              params: { Id_OrdenCompra: that.Id_OrdenCompra, FormatoXML: false },
                              withLenguaje: true
                            })
                            .then(function (response) {
                              if(response.data[0].Estatus!="OK"){
                                that.EnvioFacturas = that.EnvioFacturas.length ? response.data : [];
                                notify(response.data[0].Mensaje, 'warning', 10000);
                              }else{
                                that.EnvioFacturas = response.data;
                              }
                              console.log('succes two');
                            })
                            .catch(function (error) {
                              console.log('Error: ' + error);
                            });
                          })
                          .catch(function (response) {
                            //handle error
                              console.log(response);
                              notify('Error al guardar pdf: msg->' + response.data.MSN, 'error', 10000);
                          });
                        }else{
                          notify('El total no puede ser menor a 0', 'error', 5000);
                        }
                      }else{
                        notify('El impuesto no puede ser menor a 0', 'error', 5000);
                      }
                    }else{
                      notify('El subtotal no puede ser menor a 0', 'error', 5000);
                    }
                  }else{
                    notify('Favor de introducir la referencia bancaria', 'error', 5000);
                  }
                }else{
                  notify('La fecha de factura no puede estar vacia', 'error', 5000);
                }
              }else{
                notify('El numero de factura no puede estar vacio o con valores indefinidos', 'error', 5000);
              }
            }else{
              notify('El archivo cargado en pdf no corresponde al formato pdf.', 'error', 5000);
            }
          }else{
              notify('No se ha detectado ningun pdf.', 'error', 5000);
          }
        }else{
          notify('El archivo cargado en xml no corresponde al formato xml.', 'error', 5000);
        }
      }else{
        notify('No se ha detectado ningun xml.', 'error', 5000);
      }      
    },
    onBeforeSendCertificado:function() {
      var that = this;
      if(that.certificadosfiles.length){
        var fCert = that.certificadosfiles[0];
        // 01-Sep-2026: AM. Revision del 1-Sep-2026 con Blas: solo PDF. Aqui se validaba el tamano pero
        // no la extension, asi que un archivo de otro tipo se subia igual aunque el uploader lo hubiera
        // marcado como invalido.
        if(!/\.pdf$/i.test(fCert.name || '')){
          notify('El certificado solo se puede cargar en PDF.', 'error', 7000);
          that.certificadosfiles=[];
          return false;
        }
        if(fCert.size === 0){
          notify('El archivo está vacío (0 bytes). Selecciona un archivo válido.', 'error', 7000);
          that.certificadosfiles=[];
          return false;
        }
        if(fCert.size > 10*1024*1024){
          notify('El archivo supera el tamaño máximo permitido de 10 MB.', 'error', 7000);
          that.certificadosfiles=[];
          return false;
        }
        console.log(that.certificadosfiles[0]);
        //jQuery('.certificadoUploader i.dx-icon.dx-icon-close').addClass('dx-icon-trash');
        //jQuery('.certificadoUploader i.dx-icon.dx-icon-close').removeClass('dx-icon-close');
      }
    },
    onBeforeSendPDF:function(){
      var that = this;
      if(that.pdffiles.length){
        that.loadingVisible = true;
        var selectedFile = that.pdffiles[0];
        if(selectedFile.size === 0){
          notify('El archivo está vacío (0 bytes). Selecciona un archivo válido.', 'error', 7000);
          that.pdffiles=[];
          that.loadingVisible = false;
          return false;
        }
        if(selectedFile.size > 10*1024*1024){
          notify('El archivo supera el tamaño máximo permitido de 10 MB.', 'error', 7000);
          that.pdffiles=[];
          that.loadingVisible = false;
          return false;
        }
        var extensionpdf = selectedFile.name.substr( (selectedFile.name.lastIndexOf('.') +1) );
        var newName = selectedFile.name.split('.').slice(0, -1).join('.');
        newName = newName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(/[^\w\s]/gi,"");
        newName=newName+'.'+extensionpdf;
        console.log(newName);
        apiClient.get('/api/Facturas/getExisteFacturaPDF', {
          params: { Id_OrdenCompra: that.Id_OrdenCompra, ArchivoPDF: escapeURI(newName, 'e'), FormatoXML: false },
          withLenguaje: true
        })
        .then(function (response) {
          //that.EnvioFacturas = response.data;
          that.loadingVisible = false;
          var data = response.data[0];
          console.log(data);
          if(data.Estatus=="Error"){
            notify(data.Mensaje+' Favor de reemplazar el pdf.','error',10000);
            that.pdffiles=[];
          }
          console.log(response);
        })
        .catch(function (error) {
          that.loadingVisible = false;
          notify('Ocurrió un error al verificar el pdf favor de reemplazarlo.','error',5000);
          that.pdffiles=[];
          console.log('Error: ' + error);
        });
      }
    },
    onBeforeSend:function(){
      console.log('Se resetea el xml');
      var that = this;
      // Si no hay XML seleccionado (ej. al cambiar a Remisión, que limpia el uploader),
      // no hay nada que procesar. Evita el crash por leer .size de undefined y que el
      // loading se quede prendido.
      if(!that.xmlfiles || !that.xmlfiles.length || !that.xmlfiles[0]){
        return;
      }
      const datosXMLFile = that.$refs[that.refXMLUploader].instance;
      that.loadingVisible = true;
      var MonedaData = this.JSONMonedaPago.filter(v => (v.Id_PagoSAP == that.selMonedaPago));
      //* READING XML FILE BEFORE UPLOAD*//
      var selectedFile = that.xmlfiles[0];
      if(selectedFile.size === 0){
        notify('El archivo XML está vacío (0 bytes). Selecciona un archivo válido.', 'error', 7000);
        that.xmlfiles=[];
        datosXMLFile.reset();
        that.loadingVisible = false;
        return false;
      }
      if(selectedFile.size > 10*1024*1024){
        notify('El archivo supera el tamaño máximo permitido de 10 MB.', 'error', 7000);
        that.xmlfiles=[];
        datosXMLFile.reset();
        that.loadingVisible = false;
        return false;
      }
      var reader = new FileReader();
      reader.onload = function(e) {
          const readXml = e.target.result;
          const XmlReader = require('xml-reader');
          const result = XmlReader.parseSync(readXml);
          //** GETTING COMPLEMENTOS **/
          console.log(result);
          var xmlValido = false;
          if(result){
            if(result.attributes){
              xmlValido = true;
            }else{
              xmlValido = false;
            }
          }else{
            xmlValido = false;
          }
          if(xmlValido==false){
            notify('No se pudo leer la estructura del archivo XML.', 'error', 5000);
            console.log('xml no valido sin informacion xml dentro');
            that.selISH=0;
            datosXMLFile.reset();
            that.loadingVisible = false;
            return false;
          }
          var Comprobante = result.attributes;
          var Complemento = result.children.filter(function (data) { return data.name == 'cfdi:Complemento'; });
          var ComplementoCFDI = [];
          var EstadoDeCuentaCombustible = [];
          var SubTotalSAT = Comprobante.SubTotal;
          var TotalSAT = Comprobante.Total;
          that.Total_XML = Comprobante.Total;
          console.log({SubTotalSAT:SubTotalSAT, TotalSAT:TotalSAT});
          console.log(Complemento);
          if(Complemento.length){
            if(Complemento[0].children.length>=1){
              console.log(Complemento[0].children);
              console.log(Complemento[0].children[1]);
              ComplementoCFDI = Complemento[0].children.filter(function(n) {
                return n.name=='registrofiscal:CFDIRegistroFiscal';
              });
              EstadoDeCuentaCombustible = Complemento[0].children.filter(function(n) {
                return n.name=='ecc12:EstadoDeCuentaCombustible';
              });
              console.log(EstadoDeCuentaCombustible);
              Complemento = Complemento[0].children.filter(function(n) {
                return n.name=='tfd:TimbreFiscalDigital';
              });
              Complemento=Complemento[0].attributes;
              ComplementoCFDI=(ComplementoCFDI.length)?ComplementoCFDI[0].attributes:[];
              EstadoDeCuentaCombustible=(EstadoDeCuentaCombustible.length)?EstadoDeCuentaCombustible[0].attributes:{Total:0, SubTotal:0};
              console.warn({SubTotalPrincipal:Comprobante.SubTotal, TotalPrincipal:Comprobante.Total, SubTotal:EstadoDeCuentaCombustible.SubTotal, Total:EstadoDeCuentaCombustible.Total})
              Comprobante.SubTotal = parseFloat(Comprobante.SubTotal) + parseFloat(EstadoDeCuentaCombustible.SubTotal);
              Comprobante.Total = parseFloat(Comprobante.Total) + parseFloat(EstadoDeCuentaCombustible.Total);
              console.log(Complemento);
              console.log(ComplementoCFDI);
              console.log(EstadoDeCuentaCombustible);
            }else{
              Complemento=null;
            }
            console.log(that.TipoCertificado);
            //Complemento = (Complemento[0].children.length>=1)?Complemento[0].children[0].attributes:null;
            var Emisor = result.children.filter(function (data) { return data.name == 'cfdi:Emisor'; });
            Emisor = (Emisor[0].attributes)?Emisor[0].attributes:null;
            var Receptor = result.children.filter(function (data) { return data.name == 'cfdi:Receptor'; });
            Receptor = (Receptor[0].attributes)?Receptor[0].attributes:null;
            var Conceptos = result.children.filter(function (data) { return data.name == 'cfdi:Conceptos'; });
            Conceptos = (Conceptos[0].children.length>=1)?Conceptos[0].children[0].attributes:null;
            var Impuestos = result.children.filter(function (data) { return data.name == 'cfdi:Impuestos'; });
            Impuestos = (Impuestos.length)?Impuestos:[{children:[{Impuesto:0}],attributes:{TotalImpuestosTrasladados:0,TotalImpuestosRetenidos:0}}];//!ADAM PUNTO CLAVE RETENIDOS
            Impuestos = (Impuestos[0].children.length>=1)?Impuestos[0].attributes:null;
            console.log(Impuestos);

            //:IMPUESTOS IEPS/ISH (START)
              console.log('start IEPS');
                var IEPS = 0;
                var ConceptosIEPS = result.children.filter(function (data) { return data.name == 'cfdi:Conceptos'; });
                ConceptosIEPS = (ConceptosIEPS[0].children.length>=1)?ConceptosIEPS[0].children:null;
                //c/onsole.log(ConceptosIEPS);
                $.each(ConceptosIEPS, function( index, value ) {
                  var element = value.children.filter(function (data) { return data.name == 'cfdi:Impuestos'; });
                  if(element.length){
                    element = (element[0].children.length>=1)?element[0].children:null;
                    element = element[0].children.filter(function (data) { return data.name == 'cfdi:Traslado' && data.attributes.Impuesto != "002" });
                    $.each(element, function( index, value ) {
                      ///console.log(value);
                      IEPS =+ (value.attributes.Importe)?parseFloat(value.attributes.Importe):0;
                    });
                  }else{
                    IEPS =+ 0;
                  }
                });
                console.log(IEPS);
                console.log('end IEPS');
                console.log('start ISH');
                var ISH = 0;
                var ComplementoISH = result.children.filter(function (data) { return data.name == 'cfdi:Complemento'; });
                ComplementoISH = (ComplementoISH[0].children)?ComplementoISH[0].children:null;
                ComplementoISH = ComplementoISH.filter(function (data) { return data.name == 'implocal:ImpuestosLocales'});
                ComplementoISH = (ComplementoISH.length)?ComplementoISH[0].attributes:null;
                ISH = (ComplementoISH)?parseFloat(ComplementoISH.TotaldeTraslados):0;
                console.log(ISH);
              console.log('end ISH');

              that.selISH = IEPS+ISH;
            //:IMPUESTOS IEPS/ISH (END)

            if(!Emisor.Rfc || !Receptor.Rfc || !Comprobante.Total || !Comprobante.SubTotal || !Complemento.UUID || !Comprobante.Version || !Comprobante.Sello){
              notify('No se pudo leer la estructura del archivo XML.', 'error', 5000);
              that.selNumFactura = "";
              that.xmlfiles=[];
              that.selSubtotal = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
              that.maxSub = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
              that.selDescuento=parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico);
              that.selImpuestosRetenidos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].ImpuestosRetenidos).toFixed(2));
              that.selTotal=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico).toFixed(2));
              console.error({"PorFacturarNumerico":that.TotalesConImpuesto[0].PorFacturarNumerico});
              console.error({"selImpuestosRetenidos":that.selImpuestosRetenidos});
              console.error({"SubtotalHitoNumerico":that.TotalesConImpuesto[0].SubtotalHitoNumerico});
              console.error({"DescuentoNumerico":that.TotalesConImpuesto[0].DescuentoNumerico});
              that.selImpuestos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat((parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico)+parseFloat(that.selImpuestosRetenidos))-(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico)-parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico))).toFixed(2));
              that.selFechaFacturaStr = new Date();
              that.selFechaFacturaDisable = false;
              //that.selSubtotalDisabled = true;
              that.selSubtotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
              console.log(HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico))
              that.selTotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
              that.selDescuentoDisabled = HabilitarDeshabilitar(that.PAISP,  that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
              that.selImpuestosDisabled = true;
              that.selNumFacturaDisabled = false;
              that.selISH=0;
              datosXMLFile.reset();
              that.loadingVisible = false;
              return false;
            }

            
            console.log(Complemento.UUID);
            that.selUUID = ""+Complemento.UUID+"";
            that.selSerie = (Comprobante.Serie)?Comprobante.Serie:"";
            that.selSerie = that.selSerie.replaceAll('&amp;','&');
            that.selDescuento = (parseFloat(Comprobante.Descuento))?parseFloat(Comprobante.Descuento):parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico);
            that.selImpuestosRetenidos = (parseFloat(Impuestos.TotalImpuestosRetenidos))?parseFloat(Impuestos.TotalImpuestosRetenidos):0.00;
            var MontoMargen = (that.PAISP=="MX")?1:20;//!ADAM PUNTO CLAVE MARGEN DE ERROR PARA VALIDAR EL TOTAL DE LA FACTURA CON EL POR FACTURAR, SE PUEDE AJUSTAR PARA PAÍSES CON OTRAS MONEDAS
            console.log(that.RFCP+" == "+Emisor.Rfc);
            console.log(that.RFCS+" == "+Receptor.Rfc);
            console.log(parseFloat(Comprobante.Total));
            console.log(parseFloat(that.selSubtotal));
            console.log(parseFloat(that.selSubtotal)+MontoMargen);
            console.error(parseFloat(that.selSubtotal)+MontoMargen+that.selISH);
            console.log(parseFloat(that.TotalesConImpuesto[0].RemisionNumerico)+"=="+0 +"||"+ !BeetweenTotal(parseFloat(Comprobante.Total),(parseFloat(that.TotalesConImpuesto[0].RemisionNumerico)-MontoMargen),(parseFloat(that.TotalesConImpuesto[0].RemisionNumerico)+MontoMargen),1));//parseFloat(that.TotalesConImpuesto[0].RemisionNumerico.replaceAll('$',''))+"=="+parseFloat(Comprobante.Total))
            console.log(parseFloat(Comprobante.SubTotal)+">="+parseFloat(that.selSubtotal)+"+"+MontoMargen);
            if(that.RFCP==Emisor.Rfc && (that.RFCS==Receptor.Rfc || that.RFCS=="")){
              if(parseFloat(that.TotalesConImpuesto[0].RemisionNumerico)==0 || !BeetweenTotal(parseFloat(Comprobante.Total),(parseFloat(that.TotalesConImpuesto[0].RemisionNumerico)-MontoMargen),(parseFloat(that.TotalesConImpuesto[0].RemisionNumerico)+MontoMargen),1)){//parseFloat(that.TotalesConImpuesto[0].RemisionNumerico)==parseFloat(Comprobante.Total)
                //if(parseFloat(Comprobante.Total)>=(parseFloat(that.selSubtotal)+MontoMargen)){
                console.warn("("+parseFloat(Comprobante.SubTotal)+"-"+parseFloat(that.selDescuento)+")","("+parseFloat(that.selSubtotal)+"-"+MontoMargen+")","("+parseFloat(that.selSubtotal)+"+"+MontoMargen+")",that.EsLlegadaASitio);//!Cambio de total por subtotal 
                console.warn((parseFloat(Comprobante.SubTotal)-parseFloat(that.selDescuento)),(parseFloat(that.selSubtotal)-MontoMargen),(parseFloat(that.selSubtotal)+MontoMargen),that.EsLlegadaASitio);//!Cambio de total por subtotal 
                //console.log(BeetweenTotal((parseFloat(Comprobante.SubTotal)-parseFloat(that.selDescuento)),(parseFloat(that.selSubtotal)-MontoMargen),(parseFloat(that.selSubtotal)+MontoMargen),that.EsLlegadaASitio));//!Cambio de total por subtotal 
                console.log(`
                    (${parseFloat(Comprobante.SubTotal)}-${parseFloat(that.selDescuento)}),
                    (${parseFloat(that.selSubtotal)}-${MontoMargen}),
                    (${parseFloat(that.selSubtotal)}+${MontoMargen}),
                    ${that.EsLlegadaASitio}`)//+${parseFloat(that.selISH)}
                if(BeetweenTotal(
                    (parseFloat(Comprobante.SubTotal)-parseFloat(that.selDescuento)),//+parseFloat(that.selISH)
                    (parseFloat(that.selSubtotal)-MontoMargen),
                    (parseFloat(that.selSubtotal)+MontoMargen),
                    that.EsLlegadaASitio)
                  ){//!Cambio de total por subtotal 
                  notify('El subtotal de la factura cargada es: '+MoneyFormat.format(Comprobante.SubTotal)+', no coincide con el subtotal del monto por facturar '+MoneyFormat.format(that.selSubtotal)+'.', 'error', 10000);
                  that.selNumFactura = "";
                  that.xmlfiles=[];
                  that.selFechaFacturaStr = new Date();
                  that.selFechaFacturaDisable = false;
                  that.selUUID = null;
                  that.selSerie= null;
                  that.selVersionCFDI= null;
                  that.selSello= null;
                  that.selRFC_Emisor = null;
                  that.selRFC_Receptor = null;
                  that.selNumFactura = null;

                  if(that.EsLlegadaASitio==1 && that.TotalesConImpuesto[0].RemisionNumerico==0){
                    console.log(that.selectedEntradasArray);
                    var EntrValores = EntradasSeleccionadasCalculo(that.selectedEntradasArray,parseFloat(MonedaData[0].TipoCambio));
                    console.log(EntrValores);
                    that.selSubtotal = parseFloat(EntrValores.SubtotalEntradas);
                    that.maxSub = parseFloat(EntrValores.SubtotalEntradas);
                    that.selTotal = parseFloat(EntrValores.TotalEntradas);
                    that.selImpuestosRetenidos = parseFloat(EntrValores.Retenciones);
                    console.error({"ImpuestosEntradas":EntrValores.ImpuestosEntradas});
                    that.selImpuestos = parseFloat(EntrValores.ImpuestosEntradas);
                  }else{
                    that.selSubtotal = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                    that.maxSub = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                    that.selDescuento=parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico);
                    that.selImpuestosRetenidos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].ImpuestosRetenidos).toFixed(2));
                    that.selTotal=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico).toFixed(2));
                    console.error({"PorFacturarNumerico":that.TotalesConImpuesto[0].PorFacturarNumerico});
                    console.error({"selImpuestosRetenidos":that.selImpuestosRetenidos});
                    console.error({"SubtotalHitoNumerico":that.TotalesConImpuesto[0].SubtotalHitoNumerico});
                    console.error({"DescuentoNumerico":that.TotalesConImpuesto[0].DescuentoNumerico});
                    that.selImpuestos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat((parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico)+parseFloat(that.selImpuestosRetenidos))-(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico)-parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico))).toFixed(2));
                  }

                  ///that.selectedRowKeysEntradas = [];
                  //that.selSubtotalDisabled = true;
                  that.selSubtotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                  console.log(HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico))
                  that.selTotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                  that.selDescuentoDisabled = HabilitarDeshabilitar(that.PAISP,  that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                  that.selImpuestosDisabled = true;
                  that.selNumFacturaDisabled = false;
                  that.selISH=0;
                  datosXMLFile.reset();
                  that.loadingVisible = false;
                }else{
                  apiClient.get('/api/Facturas/getExisteFactura', {
                    params: { UUID: that.selUUID, Serie: escapeURI(that.selSerie, 'e'), FormatoXML: false },
                    withLenguaje: true
                  })
                  .then(function (response) {
                    apiClient.get('/api/General/validarEstatusCFDI', {
                      params: { RfcEmisor: Emisor.Rfc, RfcReceptor: Receptor.Rfc, Total: TotalSAT, UUID: Complemento.UUID }
                    })
                    .then(function (respons) {
                      //!Vigente
                      //!No encontrado
                      console.log(respons);
                      var dato = respons.data[0];
                      //dato.Estado=(dato.CodigoEstatus=='Expresión impresa no válida. Expresión: 601')?"Vigente":dato.Estado;
                      that.EstatusCFDI=(dato.Estado.includes("Vigente")/*==Vigente*/)?dato.Estado:dato.Estado + dato.CodigoEstatus; 
                      console.log(dato.Estado, dato.EsCancelable);
                      console.log(dato.Estado.includes("Vigente") || dato.EsCancelable=="ValidacionOmitida")
                      if(dato.Estado.includes("Vigente") || dato.EsCancelable=="ValidacionOmitida"){//=="Vigente"
                        if(dato.EsCancelable=="ValidacionOmitida"){
                          notify('Por cuestiones mayores, la validación de la factura ante el SAT esta omitida temporalmente', 'warning', 5000);
                        }
                        console.log(response);//FacturasEncontradas
                        if(response.data[0].FacturasEncontradas<=0){
                          if(that.EsLlegadaASitio==1 && that.TotalesConImpuesto[0].RemisionNumerico==0){
                            console.log(that.selectedEntradasArray);
                            //var EntrValores = EntradasSeleccionadasCalculo(that.selectedEntradasArray);
                            //console.log(EntrValores);
                            /*that.selSubtotal = EntrValores.SubtotalEntradas;
                            that.selTotal = EntrValores.TotalEntradas;
                            that.selImpuestos = EntrValores.ImpuestosEntradas;*/
                            that.selSubtotal = parseFloat(Comprobante.SubTotal);
                            that.maxSub = parseFloat(Comprobante.SubTotal);
                            //that.selImpuestos = parseFloat(Impuestos.TotalImpuestosTrasladados);
                            console.warn({"Total":Comprobante.Total});
                            console.warn({"-selImpuestosRetenidos":that.selImpuestosRetenidos});
                            console.warn({"-SubTotal":Comprobante.SubTotal});
                            console.warn({"+selISH":that.selISH});
                            console.warn({"+selDescuento":that.selDescuento});
                            that.selImpuestos = (parseFloat(Comprobante.Total)+parseFloat(that.selImpuestosRetenidos))-(parseFloat(Comprobante.SubTotal)+parseFloat(that.selISH))+parseFloat(that.selDescuento);
                            that.selTotal = parseFloat(Comprobante.Total);
                          }else{
                            that.selSubtotal = parseFloat(Comprobante.SubTotal);
                            that.maxSub = parseFloat(Comprobante.SubTotal);
                            //that.selImpuestos = parseFloat(Impuestos.TotalImpuestosTrasladados);
                            console.warn(Comprobante.Total);
                            console.warn(that.selImpuestosRetenidos);
                            console.warn(Comprobante.SubTotal);
                            console.warn(that.selISH);
                            console.warn(that.selDescuento);
                            that.selImpuestos = (parseFloat(Comprobante.Total)+parseFloat(that.selImpuestosRetenidos))-(parseFloat(Comprobante.SubTotal)+parseFloat(that.selISH))+parseFloat(that.selDescuento);
                            that.selTotal = parseFloat(Comprobante.Total);
                          }

                          that.selVersionCFDI = ""+Comprobante.Version+"";
                          that.selSello = ""+Comprobante.Sello+"";
                          that.selRFC_Emisor = ""+Emisor.Rfc+"";
                          that.selRFC_Receptor = ""+Receptor.Rfc+"";
                          var comprobantefolio = (Comprobante.Folio)? " "+Comprobante.Folio:(ComplementoCFDI.Folio)? " "+ComplementoCFDI.Folio:"";
                          if(that.selSerie){
                            that.selNumFactura = that.selSerie+comprobantefolio;
                          }else{
                            that.selNumFactura = comprobantefolio;
                          }

                          if(!comprobantefolio){
                            that.selNumFacturaDisabled = false;
                          }else{
                            that.selNumFacturaDisabled = true;
                          }


                          var fechaString = Comprobante.Fecha.split('T');
                          fechaString = fechaString[0].split('-');
                          //console.log(Date(fechaString[0]+"/"+parseInt(fechaString[1])+"/"+parseInt(fechaString[2])));
                          that.selFechaFacturaStr = new Date(fechaString[0]+"/"+parseInt(fechaString[1])+"/"+parseInt(fechaString[2]));

                          if(!Comprobante.Fecha){
                            that.selFechaFacturaDisable = false;
                          }else{
                            that.selFechaFacturaDisable = true;
                          }
                          that.selSubtotalDisabled = true;
                          that.selTotalDisabled = true;
                          that.selImpuestosDisabled = true;
                          that.selDescuentoDisabled = true;
                          that.loadingVisible = false;
                        }else{
                          notify(response.data[0].Mensaje, 'error', 5000);
                          that.selNumFactura = "";
                          that.xmlfiles=[];
                          datosXMLFile.reset();
                          //that.selSubtotal = 0;
                          //that.selTotal = 0;
                          //that.selImpuestos = 0;
                          that.selFechaFacturaStr = new Date();
                          that.selFechaFacturaDisable = false;
                          that.selUUID = null;
                          that.selSerie= null;
                          that.selVersionCFDI= null;
                          that.selSello= null;
                          that.selRFC_Emisor = null;
                          that.selRFC_Receptor = null;
                          that.selNumFactura = null;
                          if(that.EsLlegadaASitio==1 && that.TotalesConImpuesto[0].RemisionNumerico==0){
                            console.log(that.selectedEntradasArray);
                            var EntrValores = EntradasSeleccionadasCalculo(that.selectedEntradasArray,parseFloat(MonedaData[0].TipoCambio));
                            console.log(EntrValores);
                            that.selImpuestosRetenidos = parseFloat(EntrValores.Retenciones);
                            that.selSubtotal = parseFloat(EntrValores.SubtotalEntradas);
                            that.maxSub = parseFloat(EntrValores.SubtotalEntradas);
                            that.selTotal = parseFloat(EntrValores.TotalEntradas);
                            console.error({"ImpuestosEntradas":EntrValores.ImpuestosEntradas});
                            that.selImpuestos = parseFloat(EntrValores.ImpuestosEntradas);
                          }else{
                            that.selSubtotal = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                            that.maxSub = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                            that.selDescuento=parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico);
                            that.selTotal=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico).toFixed(2));
                            that.selImpuestosRetenidos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].ImpuestosRetenidos).toFixed(2));
                            console.error({"PorFacturarNumerico":that.TotalesConImpuesto[0].PorFacturarNumerico});
                            console.error({"selImpuestosRetenidos":that.selImpuestosRetenidos});
                            console.error({"SubtotalHitoNumerico":that.TotalesConImpuesto[0].SubtotalHitoNumerico});
                            console.error({"DescuentoNumerico":that.TotalesConImpuesto[0].DescuentoNumerico});
                            that.selImpuestos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat((parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico)+parseFloat(that.selImpuestosRetenidos))-(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico)-parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico))).toFixed(2));
                          }
                          ///that.selectedRowKeysEntradas = [];
                          //that.selSubtotalDisabled = true;
                          that.selSubtotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                          console.log(HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico))
                          that.selTotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                          that.selDescuentoDisabled = HabilitarDeshabilitar(that.PAISP,  that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                          that.selImpuestosDisabled = true;
                          that.selNumFacturaDisabled = false;
                          that.selISH=0;
                          that.loadingVisible = false;
                        }
                      }else{
                        var estadoSAT = (dato.Estado)?dato.Estado:' no encontrado por falla del SAT.';
                        notify("Estatus de factura " + dato.Estado + ' ' +dato.CodigoEstatus, 'error', 5000);
                        that.xmlfiles=[];
                        datosXMLFile.reset();
                        that.EstatusCFDI=(dato.Estado.includes("Vigente")/*=="Vigente"*/)?dato.Estado:dato.Estado + " " + dato.CodigoEstatus;
                        //that.selSubtotal = 0;
                        //that.selTotal = 0;
                        //that.selImpuestos = 0;
                        that.selNumFactura = "";
                        that.selFechaFacturaStr = new Date();
                        that.selFechaFacturaDisable = false;
                        that.selUUID = null;
                        that.selSerie= null;
                        that.selVersionCFDI= null;
                        that.selSello= null;
                        that.selRFC_Emisor = null;
                        that.selRFC_Receptor = null;
                        that.selNumFactura = null;
                        if(that.EsLlegadaASitio==1 && that.TotalesConImpuesto[0].RemisionNumerico==0){
                          console.log(that.selectedEntradasArray);
                          var EntrValores = EntradasSeleccionadasCalculo(that.selectedEntradasArray,parseFloat(MonedaData[0].TipoCambio));
                          console.log(EntrValores);
                          that.selSubtotal = parseFloat(EntrValores.SubtotalEntradas);
                          that.maxSub = parseFloat(EntrValores.SubtotalEntradas);
                          that.selTotal = parseFloat(EntrValores.TotalEntradas);
                          that.selImpuestosRetenidos = parseFloat(EntrValores.Retenciones);
                          console.error({"ImpuestosEntradas":EntrValores.ImpuestosEntradas});
                          that.selImpuestos = parseFloat(EntrValores.ImpuestosEntradas);
                        }else{
                          that.selSubtotal = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                          that.maxSub = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                          that.selDescuento=parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico);
                          that.selTotal=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico).toFixed(2));
                          that.selImpuestosRetenidos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].ImpuestosRetenidos).toFixed(2));
                          console.error({"PorFacturarNumerico":that.TotalesConImpuesto[0].PorFacturarNumerico});
                          console.error({"selImpuestosRetenidos":that.selImpuestosRetenidos});
                          console.error({"SubtotalHitoNumerico":that.TotalesConImpuesto[0].SubtotalHitoNumerico});
                          console.error({"DescuentoNumerico":that.TotalesConImpuesto[0].DescuentoNumerico});
                          that.selImpuestos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat((parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico)+parseFloat(that.selImpuestosRetenidos))-(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico)-parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico))).toFixed(2));
                        }
                        ///that.selectedRowKeysEntradas = [];
                        //that.selSubtotalDisabled = true;
                        that.selSubtotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                        console.log(HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico))
                        that.selTotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                        that.selDescuentoDisabled = HabilitarDeshabilitar(that.PAISP,  that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                        that.selImpuestosDisabled = true;
                        that.selNumFacturaDisabled = false;
                        that.selISH=0;
                        that.loadingVisible = false;
                      }
                      console.log(response);
                    })
                    .catch(function (error) {
                      notify('Error al verificar la factura ante el SAT', 'error', 5000);
                      that.xmlfiles=[];
                      datosXMLFile.reset();
                      //that.selSubtotal = 0;
                      //that.selTotal = 0;
                      //that.selImpuestos = 0;
                      that.selNumFactura = "";
                      that.selFechaFacturaStr = new Date();
                      that.selFechaFacturaDisable = false;
                      that.selUUID = null;
                      that.selSerie= null;
                      that.selVersionCFDI= null;
                      that.selSello= null;
                      that.selRFC_Emisor = null;
                      that.selRFC_Receptor = null;
                      that.selNumFactura = null;
                      if(that.EsLlegadaASitio==1 && that.TotalesConImpuesto[0].RemisionNumerico==0){
                        console.log(that.selectedEntradasArray);
                        var EntrValores = EntradasSeleccionadasCalculo(that.selectedEntradasArray,parseFloat(MonedaData[0].TipoCambio));
                        console.log(EntrValores);
                        that.selSubtotal = parseFloat(EntrValores.SubtotalEntradas);
                        that.maxSub = parseFloat(EntrValores.SubtotalEntradas);
                        that.selTotal = parseFloat(EntrValores.TotalEntradas);
                        that.selImpuestosRetenidos = parseFloat(EntrValores.Retenciones);
                        console.error({"ImpuestosEntradas":EntrValores.ImpuestosEntradas});
                        that.selImpuestos = parseFloat(EntrValores.ImpuestosEntradas);
                      }else{
                        that.selSubtotal = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                        that.maxSub = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                        that.selDescuento=parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico);
                        that.selTotal=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico).toFixed(2));
                        that.selImpuestosRetenidos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].ImpuestosRetenidos).toFixed(2));
                        console.error({"PorFacturarNumerico":that.TotalesConImpuesto[0].PorFacturarNumerico});
                        console.error({"selImpuestosRetenidos":that.selImpuestosRetenidos});
                        console.error({"SubtotalHitoNumerico":that.TotalesConImpuesto[0].SubtotalHitoNumerico});
                        console.error({"DescuentoNumerico":that.TotalesConImpuesto[0].DescuentoNumerico});
                        that.selImpuestos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat((parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico)+parseFloat(that.selImpuestosRetenidos))-(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico)-parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico))).toFixed(2));
                      }
                      ///that.selectedRowKeysEntradas = [];
                      //that.selSubtotalDisabled = true;
                      that.selSubtotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                      console.log(HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico))
                      that.selTotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                      that.selDescuentoDisabled = HabilitarDeshabilitar(that.PAISP,  that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                      that.selImpuestosDisabled = true;
                      that.selNumFacturaDisabled = false;
                      that.selISH=0;
                      console.log(error);   
                      that.loadingVisible = false;
                    });
                  })
                  .catch(function (error) {
                    //that.selSubtotal = 0;
                    //that.selTotal = 0;
                    //that.selImpuestos = 0;
                    that.selNumFactura = "";
                    that.selFechaFacturaStr = new Date();
                    that.selFechaFacturaDisable = false;
                    that.selUUID = null;
                    that.selSerie= null;
                    that.selVersionCFDI= null;
                    that.selSello= null;
                    that.selRFC_Emisor = null;
                    that.selRFC_Receptor = null;
                    that.selNumFactura = null;
                    if(that.EsLlegadaASitio==1 && that.TotalesConImpuesto[0].RemisionNumerico==0){
                      console.log(that.selectedEntradasArray);
                      var EntrValores = EntradasSeleccionadasCalculo(that.selectedEntradasArray,parseFloat(MonedaData[0].TipoCambio));
                      console.log(EntrValores);
                      that.selSubtotal = parseFloat(EntrValores.SubtotalEntradas);
                      that.maxSub = parseFloat(EntrValores.SubtotalEntradas);
                      that.selTotal = parseFloat(EntrValores.TotalEntradas);
                      that.selImpuestosRetenidos = parseFloat(EntrValores.Retenciones);
                      console.error({"ImpuestosEntradas":EntrValores.ImpuestosEntradas});
                      that.selImpuestos = parseFloat(EntrValores.ImpuestosEntradas);
                    }else{
                      that.selSubtotal = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                      that.maxSub = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                      that.selDescuento=parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico);
                      that.selTotal=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico).toFixed(2));
                      that.selImpuestosRetenidos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].ImpuestosRetenidos).toFixed(2));
                      console.error({"PorFacturarNumerico":that.TotalesConImpuesto[0].PorFacturarNumerico});
                      console.error({"selImpuestosRetenidos":that.selImpuestosRetenidos});
                      console.error({"SubtotalHitoNumerico":that.TotalesConImpuesto[0].SubtotalHitoNumerico});
                      console.error({"DescuentoNumerico":that.TotalesConImpuesto[0].DescuentoNumerico});
                      that.selImpuestos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat((parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico)+parseFloat(that.selImpuestosRetenidos))-(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico)-parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico))).toFixed(2));
                    }
                    ///that.selectedRowKeysEntradas = [];
                    //that.selSubtotalDisabled = true;
                    that.selSubtotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                    console.log(HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico))
                    that.selTotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                    that.selDescuentoDisabled = HabilitarDeshabilitar(that.PAISP,  that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                    that.selImpuestosDisabled = true;
                    that.selNumFacturaDisabled = false;
                    notify('No se encontro identificador del xml (UUID),', 'error', 5000);
                    console.log('Error: ' + error);
                    that.loadingVisible = false;
                  });
                }
              }else{
                //that.selSubtotal = 0;
                //that.selTotal = 0;
                //that.selImpuestos = 0;
                that.xmlfiles=[];
                datosXMLFile.reset();
                that.selNumFactura = "";
                that.selFechaFacturaStr = new Date();
                that.selFechaFacturaDisable = false;
                that.selUUID = null;
                that.selSerie= null;
                that.selVersionCFDI= null;
                that.selSello= null;
                that.selRFC_Emisor = null;
                that.selRFC_Receptor = null;
                that.selNumFactura = null;
                if(that.EsLlegadaASitio==1 && that.TotalesConImpuesto[0].RemisionNumerico==0){
                  console.log(that.selectedEntradasArray);
                  var EntrValores = EntradasSeleccionadasCalculo(that.selectedEntradasArray,parseFloat(MonedaData[0].TipoCambio));
                  console.log(EntrValores);
                  that.selSubtotal = parseFloat(EntrValores.SubtotalEntradas);
                  that.maxSub = parseFloat(EntrValores.SubtotalEntradas);
                  that.selTotal = parseFloat(EntrValores.TotalEntradas);
                  that.selImpuestosRetenidos = parseFloat(EntrValores.Retenciones);
                  console.error({"ImpuestosEntradas":EntrValores.ImpuestosEntradas});
                  that.selImpuestos = parseFloat(EntrValores.ImpuestosEntradas);
                }else{
                  that.selSubtotal = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                  that.maxSub = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                  that.selDescuento=parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico);
                  that.selTotal=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico).toFixed(2));
                  that.selImpuestosRetenidos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].ImpuestosRetenidos).toFixed(2));
                  console.error({"PorFacturarNumerico":that.TotalesConImpuesto[0].PorFacturarNumerico});
                  console.error({"selImpuestosRetenidos":that.selImpuestosRetenidos});
                  console.error({"SubtotalHitoNumerico":that.TotalesConImpuesto[0].SubtotalHitoNumerico});
                  console.error({"DescuentoNumerico":that.TotalesConImpuesto[0].DescuentoNumerico});
                  that.selImpuestos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat((parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico)+parseFloat(that.selImpuestosRetenidos))-(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico)-parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico))).toFixed(2));
                }
                ///that.selectedRowKeysEntradas = [];
                //that.selSubtotalDisabled = true;
                that.selSubtotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                console.log(HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico))
                that.selTotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                that.selDescuentoDisabled = HabilitarDeshabilitar(that.PAISP,  that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
                that.selImpuestosDisabled = true;
                that.selNumFacturaDisabled = false;
                that.selISH=0;
                that.loadingVisible = false;
                notify('El monto de la remisión no es igual al monto de la factura', 'error', 7000);
              }
            }else{
              that.xmlfiles=[];
              datosXMLFile.reset();
              //that.selSubtotal = 0;
              //that.selTotal = 0;
              //that.selImpuestos = 0;
              that.selNumFactura = "";
              that.selFechaFacturaStr = new Date();
              that.selFechaFacturaDisable = false;
              that.selUUID = null;
              that.selSerie= null;
              that.selVersionCFDI= null;
              that.selSello= null;
              that.selRFC_Emisor = null;
              that.selRFC_Receptor = null;
              that.selNumFactura = null;
              if(that.EsLlegadaASitio==1 && that.TotalesConImpuesto[0].RemisionNumerico==0){
                console.log(that.selectedEntradasArray);
                var EntrValores = EntradasSeleccionadasCalculo(that.selectedEntradasArray,parseFloat(MonedaData[0].TipoCambio));
                console.log(EntrValores);
                that.selSubtotal = parseFloat(EntrValores.SubtotalEntradas);
                that.maxSub = parseFloat(EntrValores.SubtotalEntradas);
                that.selTotal = parseFloat(EntrValores.TotalEntradas);
                that.selImpuestosRetenidos = parseFloat(EntrValores.Retenciones);
                console.error({"ImpuestosEntradas":EntrValores.ImpuestosEntradas});
                that.selImpuestos = parseFloat(EntrValores.ImpuestosEntradas);
              }else{
                that.selSubtotal = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                that.maxSub = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
                that.selDescuento=parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico);
                that.selTotal=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico).toFixed(2));
                that.selImpuestosRetenidos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].ImpuestosRetenidos).toFixed(2));
                console.error({"PorFacturarNumerico":that.TotalesConImpuesto[0].PorFacturarNumerico});
                console.error({"selImpuestosRetenidos":that.selImpuestosRetenidos});
                console.error({"SubtotalHitoNumerico":that.TotalesConImpuesto[0].SubtotalHitoNumerico});
                console.error({"DescuentoNumerico":that.TotalesConImpuesto[0].DescuentoNumerico});
                that.selImpuestos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat((parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico)+parseFloat(that.selImpuestosRetenidos))-(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico)-parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico))).toFixed(2));
              }
              ///that.selectedRowKeysEntradas = [];
              //that.selSubtotalDisabled = true;
              that.selSubtotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
              console.log(HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico))
              that.selTotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
              that.selDescuentoDisabled = HabilitarDeshabilitar(that.PAISP,  that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
              that.selImpuestosDisabled = true;
              that.selNumFacturaDisabled = false;
              that.selISH=0;
              console.log(that.RFCP+"!="+Emisor.Rfc);
              if(that.RFCP!=Emisor.Rfc){
                notify('RFC Emisor ('+Emisor.Rfc+') no corresponde con el RFC del proveedor ('+that.RFCP+')', 'error', 10000);
              }
              if(that.RFCS!=Receptor.Rfc && that.RFCS!=""){
                notify('RFC Receptor ('+Receptor.Rfc+') no corresponde con el RFC de la sociedad ('+that.RFCS+')', 'error', 10000);
              }
              that.loadingVisible = false;
            }
            console.log(Emisor);
            console.log(Receptor);
            console.log(Conceptos);
            console.log(Impuestos);
            console.log(Complemento);
            console.log(result.children);
          }else{
            that.xmlfiles=[];
            datosXMLFile.reset();
            //that.selSubtotal = 0;
            //that.selTotal = 0;
            //that.selImpuestos = 0;
            that.selNumFactura = "";
            that.selFechaFacturaStr = new Date();
            that.selFechaFacturaDisable = false;
            that.EstatusCFDI=null;
            that.selUUID = null;
            that.selSerie= null;
            that.selVersionCFDI= null;
            that.selSello= null;
            that.selRFC_Emisor = null;
            that.selRFC_Receptor = null;
            that.selNumFactura = null;
            if(that.EsLlegadaASitio==1 && that.TotalesConImpuesto[0].RemisionNumerico==0){
              console.log(that.selectedEntradasArray);
              var EntrValores = EntradasSeleccionadasCalculo(that.selectedEntradasArray,parseFloat(MonedaData[0].TipoCambio));
              console.log(EntrValores);
              that.selSubtotal = parseFloat(EntrValores.SubtotalEntradas);
              that.maxSub = parseFloat(EntrValores.SubtotalEntradas);
              that.selTotal = parseFloat(EntrValores.TotalEntradas);
              that.selImpuestosRetenidos = parseFloat(EntrValores.Retenciones);
              console.error({"ImpuestosEntradas":EntrValores.ImpuestosEntradas});
              that.selImpuestos = parseFloat(EntrValores.ImpuestosEntradas);
            }else{
              that.selSubtotal = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
              that.maxSub = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
              that.selDescuento=parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico);
              that.selTotal=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico).toFixed(2));
              that.selImpuestosRetenidos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].ImpuestosRetenidos).toFixed(2));
              console.error({"PorFacturarNumerico":that.TotalesConImpuesto[0].PorFacturarNumerico});
              console.error({"selImpuestosRetenidos":that.selImpuestosRetenidos});
              console.error({"SubtotalHitoNumerico":that.TotalesConImpuesto[0].SubtotalHitoNumerico});
              console.error({"DescuentoNumerico":that.TotalesConImpuesto[0].DescuentoNumerico});
              that.selImpuestos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat((parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico)+parseFloat(that.selImpuestosRetenidos))-(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico)-parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico))).toFixed(2));
            }
            ///that.selectedRowKeysEntradas = [];
            //that.selSubtotalDisabled = true;
            that.selSubtotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
            console.log(HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico))
            that.selTotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
            that.selDescuentoDisabled = HabilitarDeshabilitar(that.PAISP,  that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
            that.selImpuestosDisabled = true;
            that.selNumFacturaDisabled = false;
            that.selISH=0;
            notify('Este XML no es valido favor de remplazarlo.', 'error', 5000);
            that.loadingVisible = false;
          }
          //Ickj49E5c8vVbTyES9zxHnpyfPPOBD+GVkCygcrvtotfYvJZ8lKoa++1MGYoBK4kzlJ/CGYXzs1hsN/GRbpzsY8Nq4YmDn2Sza7ocbPA2YWjECmjlLlU6bN5xGJ6LNXb3p3d0aVPMJlPPZsr2rsquyyP3ZaibOXN63R55tz4DpbIw3mLmCBAjm7KJ9EE4sVXQGAeMAFlp5Yfyr+zQBDICA+meGoF8XWb7SHdotxO6hplX+5upgUcmerm7OJEn4RLjzH5p/7IM+AtUuoo03JqARXD2f8vH5g7OIFZQ4aBT83T4TSjfSCOXB8f9Na/0eJ1juh8bI0nA7bSTngIN6dbBQ==
      }
      if(selectedFile){
        reader.readAsText(selectedFile);
      }else{
        //that.selSubtotal = 0;
        //that.selTotal = 0;
        //that.selImpuestos = 0;
        that.selNumFactura = "";
        that.EstatusCFDI=null;
        that.selFechaFacturaStr = new Date();
        that.selFechaFacturaDisable = false;
        that.EstatusCFDI=null;
        that.selUUID = null;
        that.selSerie= null;
        that.selVersionCFDI= null;
        that.selSello= null;
        that.selRFC_Emisor = null;
        that.selRFC_Receptor = null;
        that.selNumFactura = null;
        that.selISH=0;
        if(that.EsLlegadaASitio==1 && that.TotalesConImpuesto[0].RemisionNumerico==0){
          console.log(that.selectedEntradasArray);
          console.log(parseFloat(MonedaData[0].TipoCambio));
          var EntrValores = EntradasSeleccionadasCalculo(that.selectedEntradasArray,parseFloat(MonedaData[0].TipoCambio));
          console.log(EntrValores);
          that.selSubtotal = parseFloat(EntrValores.SubtotalEntradas);
          that.maxSub = parseFloat(EntrValores.SubtotalEntradas);
          that.selTotal = parseFloat(EntrValores.TotalEntradas);
          that.selImpuestosRetenidos = parseFloat(EntrValores.Retenciones);
          console.error({"ImpuestosEntradas":EntrValores.ImpuestosEntradas});
          that.selImpuestos = parseFloat(EntrValores.ImpuestosEntradas);
        }else{
          that.selSubtotal = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
          that.maxSub = (that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico).toFixed(2));
          that.selDescuento=parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico);
          that.selTotal=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico).toFixed(2));
          that.selImpuestosRetenidos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat(that.TotalesConImpuesto[0].ImpuestosRetenidos).toFixed(2));
          console.error({"PorFacturarNumerico":that.TotalesConImpuesto[0].PorFacturarNumerico});
          console.error({"selImpuestosRetenidos":that.selImpuestosRetenidos});
          console.error({"SubtotalHitoNumerico":that.TotalesConImpuesto[0].SubtotalHitoNumerico});
          console.error({"DescuentoNumerico":that.TotalesConImpuesto[0].DescuentoNumerico});
          that.selImpuestos=(that.EsLlegadaASitio==1)?0.00:parseFloat(parseFloat((parseFloat(that.TotalesConImpuesto[0].PorFacturarNumerico)+parseFloat(that.selImpuestosRetenidos))-(parseFloat(that.TotalesConImpuesto[0].SubtotalHitoNumerico)-parseFloat(that.TotalesConImpuesto[0].DescuentoNumerico))).toFixed(2));
          //that.selSubtotal = 0;
          //that.selTotal = 0;
          //that.selImpuestos = 0;
        }
        ///that.selectedRowKeysEntradas = [];
        //that.selSubtotalDisabled = true;
        that.selSubtotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
        console.log(HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico))
        that.selTotalDisabled = HabilitarDeshabilitar(that.PAISP, that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
        that.selDescuentoDisabled = HabilitarDeshabilitar(that.PAISP,  that.EsLlegadaASitio,that.selFacturaRemision,that.TotalesConImpuesto[0].RemisionNumerico);
        that.selImpuestosDisabled = true;
        that.selNumFacturaDisabled = false;
        that.loadingVisible = false;
      }
      //that.loadingVisible = false;
    },
    enviarSoportes:function(Registro){
      var that = this;
      var saveIt = true;
      that.loadingVisible = true;
      console.log(Registro);
      console.log(that.soportesfiles);
      console.log(that.soportesfiles[0]);
      console.log(that.soportesfiles.length);
      
      var cantidadFiles = that.soportesfiles.length;
      if(that.soportesfiles.length){
        for (let index of that.soportesfiles) {
          var extensionpdf = index.name.substr( (index.name.lastIndexOf('.') +1) );
          console.log(extensionpdf);
          if(extensionpdf.toUpperCase()!='PDF' && extensionpdf.toUpperCase()!='JPG' && extensionpdf.toUpperCase()!='JPEG' && extensionpdf.toUpperCase()!='GIF' && extensionpdf.toUpperCase()!='PNG'){
            saveIt = false;
            that.loadingVisible = false;
            notify('El archivo "'+index.name+'" no pertenece a ninguno de estos formatos (.pdf, .jpg, .jpeg, .gif, .png), favor de reemplazarlo.', 'error', 10000);
          }
        }
        if(saveIt){
          var count = 0;
          for (let index of that.soportesfiles) {
            count=count+1;
            console.log(cantidadFiles +"=="+ count);
            //?
            var FechaEnvioStr;
            if(that.selFechaEnvioSoporte.length == 9){
              FechaEnvioStr = that.selFechaEnvioSoporte;
            }else{
              const meses = {
                0: 'ENE',
                1: 'FEB',
                2: 'MAR',
                3: 'ABR',
                4: 'MAY',
                5: 'JUN',
                6: 'JUL',
                7: 'AGO',
                8: 'SEP',
                9: 'OCT',
                10: 'NOV',
                11: 'DIC'
              }
              FechaEnvioStr = that.selFechaEnvioSoporte.getDate()+"-"+meses[that.selFechaEnvioSoporte.getMonth()]+"-"+that.selFechaEnvioSoporte.getFullYear();
            }
            var FechaVigenciaStr;
            if(that.selFechaHastaSoporte.length == 9){
              FechaVigenciaStr = that.selFechaHastaSoporte;
            }else{
              const meses = {
                0: 'ENE',
                1: 'FEB',
                2: 'MAR',
                3: 'ABR',
                4: 'MAY',
                5: 'JUN',
                6: 'JUL',
                7: 'AGO',
                8: 'SEP',
                9: 'OCT',
                10: 'NOV',
                11: 'DIC'
              }
              FechaVigenciaStr = that.selFechaHastaSoporte.getDate()+"-"+meses[that.selFechaHastaSoporte.getMonth()]+"-"+that.selFechaHastaSoporte.getFullYear();
            }
            console.log(FechaEnvioStr);
            console.log(FechaVigenciaStr);
            apiClient.put('/api/Proveedores/updOC_HitosSoportes', {
              Id_OrdenCompra: that.Id_OrdenCompra,
              Id_TipoFechaMaterial: that.Id_TipoFechaMaterial,
              ArchivoOriginal: index.name,
              Extension: '.'+extensionpdf,
              Id_TipoDocumentacion: that.Id_TipoDocumentacion,
              Id_SubtipoDocumentacion: that.Id_SubTipoDocumentacion,
              FechaEnvioStr: FechaEnvioStr,
              FechaVigenciaStr: FechaVigenciaStr,
              FormatoXML: false
            })
            .then(function (response) {
              console.log(response)
              //return false;
              var formData = new FormData();
              //formData.append('NombreArchivo', index.name);
              formData.append('NombreArchivo', response.data[0].ArchivoFisico);
              formData.append('BibliotecaSharepoint', that.Biblioteca);
              formData.append('PathSharepoint', that.Carpeta);
              formData.append('SitioSharepoint', that.SitioSharepoint);
              formData.append('ReemplazarArchivo', 'true');
              formData.append('file', index);
              for (var pair of formData.entries()) {
                  console.log(pair[0]+ ', ' + pair[1]); 
              }
              apiClient.post('/api/SharePoint/subir-archivo-t', formData, { headers: { 'Content-Type': undefined }, onUploadProgress: function(e){ that.showUploadProgress = true; if(e.total){ that.uploadProgress = Math.round((e.loaded/e.total)*100); if(that.uploadProgress>=100){ setTimeout(function(){ that.showUploadProgress=false; },800); } } } }).then(function (response) {
                console.log(formData);
                console.log('exito');
                console.log(response);
                var isSuccess = (typeof response.data === 'string' && response.data.toLowerCase().includes('exitosamente')) || 
                               (response.data && response.data.ERROR=="False");
                if(isSuccess){
                  notify( index.name + " guardado correctamente.", 'success', 5000);
                }else{
                  notify( 'Error al guardar ' + index.name, 'error', 5000);
                }
                if(cantidadFiles == count){
                  apiClient.get('/api/Facturas/getOC_HitosSoportes', {
                    params: { Id_OrdenCompra: that.Id_OrdenCompra, FormatoXML: false }
                  })
                  .then(function (response) {
                    console.log(response.data);
                    that.tableSoportes = response.data;
                    that.loadingVisible = false;
                    that.$refs['modal-5'].hide();
                  })
                  .catch(function (error) {
                    console.log('Error: ' + error);
                    that.loadingVisible = false;
                    that.tableSoportes = [];
                    that.$refs['modal-5'].hide();
                  });
                }
              }).catch(function (response) {
                if(cantidadFiles == count){
                  apiClient.get('/api/Facturas/getOC_HitosSoportes', {
                    params: { Id_OrdenCompra: that.Id_OrdenCompra, FormatoXML: false }
                  })
                  .then(function (response) {
                    console.log(response.data);
                    that.tableSoportes = response.data;
                    that.loadingVisible = false;
                    that.$refs['modal-5'].hide();
                  })
                  .catch(function (error) {
                    console.log('Error: ' + error);
                    that.loadingVisible = false;
                    that.tableSoportes = [];
                    that.$refs['modal-5'].hide();
                  });
                }
                console.log(response);
                that.loadingVisible = false;
                notify('Error al guardar pdf: msg->' + response.data.MSN, 'error', 7000);
              });
            })
            .catch(function (response) {
              if(cantidadFiles == count){
                apiClient.get('/api/Facturas/getOC_HitosSoportes', {
                  params: { Id_OrdenCompra: that.Id_OrdenCompra, FormatoXML: false }
                })
                .then(function (response) {
                  console.log(response.data);
                  that.tableSoportes = response.data;
                  that.loadingVisible = false;
                  that.$refs['modal-5'].hide();
                })
                .catch(function (error) {
                  console.log('Error: ' + error);
                  that.loadingVisible = false;
                  that.tableSoportes = [];
                  that.$refs['modal-5'].hide();
                });
              }
              that.loadingVisible = false;
              notify( "Error al insertar registro.", 'error', 7000);
              console.log('Error: ' + response);
              console.log(response.data.MSN);
            });
            console.log('----------SALTO DE ARCHIVO--------------');
          }
          //that.loadingVisible = false;
        }
      }else{
        that.loadingVisible = false;
        notify('No se ha detectado ningun archivo.', 'error', 5000);
      }
    },
    depFechaEnbioSoporte:function(data){
      //console.log(this.selFechaEnvioSoporte)
      var that = this;
      console.log(data);
      console.log(data.addDays(that.DiasVigencia));
      var nuevaFecha = data.addDays(that.DiasVigencia);
      that.selFechaHastaSoporte = nuevaFecha;
    },
    upSoporte:function(registro) {
      var that = this;
      that.$refs['modal-5'].show();
      that.soportesfiles=[];
      that.HeaderPopUpSoportesFiles = "OC: " + that.txtOC + " | Hito: " + registro.data.Hito;
      that.Biblioteca = registro.data.Biblioteca;
      that.Carpeta = registro.data.Carpeta;
      that.SitioSharepoint = registro.data.SitioSharepoint;
      that.Id_TipoFechaMaterial = registro.data.Id_TipoFechaMaterial;
      that.Id_TipoDocumentacion = registro.data.Id_TipoDocumentacion;
      that.Id_SubTipoDocumentacion = registro.data.Id_SubTipoDocumentacion;
      that.DiasVigencia = (registro.data.DiasVigenciaDefault)?parseInt(registro.data.DiasVigenciaDefault):0;
      var fechaVigencia = new Date();
      console.log(fechaVigencia.addDays(that.DiasVigencia));
      that.selFechaHastaSoporte = fechaVigencia.addDays(that.DiasVigencia);
      that.FechaEnvioSoporteDisabled = (that.USERSIGA)?false:true;
      console.log(that.USERSIGA);
      console.log(that.DiasVigencia);
      console.log(that.Id_SubTipoDocumentacion);
      console.log(registro);
    },
    RefreshFirstList:function(){
      var that = this;
      that.loadingVisible = true;
      apiClient.get('/api/Proveedores/TiposDocumentacion', {
        params: { Todos: -1, FormatoXML: false },
        withLenguaje: true
      })
      .then(function (response) {
        that.Acciones = [];
        for (let value of response.data) {
          that.Acciones.push({
            Id_ClasificacionTipoDocumentacion:parseInt(value.Id_ClasificacionTipoDocumentacion),
            ClasificacionTipoDocumentacion:value.ClasificacionTipoDocumentacion,
            disabled:(value.Disabled == 'true'),
            selected:(value.Selected == 'true')
          });
        }
        apiClient.get('/api/Proveedores/OCDocumentacionPendiente', {
          params: { FormatoXML: false }
        })
        .then(function (response) {
          console.log(response.data);
          that.OrdenesCompra = response.data;
          that.loadingVisible = false;
        })
        .catch(function (error) {
          console.log('Error: ' + error);
          that.loadingVisible = false;
        });
      })
      .catch(function (error) {
        console.log('Error: ' + error);
      });
      that.$refs['modal-1'].hide();
      that.$refs['modal-2'].hide();
      that.$refs['modal-3'].hide();
      that.$refs['modal-4'].hide();
      that.$refs['modal-5'].hide();
    },
    modalAltaCertificado(){
      var that = this;
      that.NoCertificadoCarta = null;
      that.certificadosfiles = [];
      apiClient.get('/api/Certificados/getTiposCertificado', {
        params: { Todos: 1, FormatoXML: false }
      })
      .then(function (response) {
        console.log(response.data);
        that.JSONTiposCertificado = response.data;
        that.selTiposCertificado = response.data[0].Selected;
      })
      .catch(function (error) {
        console.log('Error: ' + error);
      });
      console.log('hola');
      console.log(that.Id_OrdenCompra);
      console.log(that.txtOC);
    },
    MonedasPago(){
      var that = this;
      apiClient.get('/api/Proveedores/MonedasPagoOC', {
        params: { OC: that.txtOC, Subtotal: that.Subtotal, FormatoXML: false }
      })
      .then(function (response) {
        console.log(response.data);
        that.JSONMonedaPago = response.data;
        that.selMonedaPago = response.data[0].Id_PagoSAP;
      })
      .catch(function (error) {
        console.log('Error: ' + error);
      });
      console.log(that.Id_OrdenCompra);
      console.log(that.txtOC);
    },
    altaCertificado(){
      var that = this;
      var saveIt = true;
      that.loadingVisible = true;
      //console.log(Registro);
      console.log(that.certificadosfiles);
      console.log(that.certificadosfiles[0]);
      console.log(that.certificadosfiles.length);
      //var cantidadFiles = that.certificadosfiles.length;
      if(that.certificadosfiles.length){
        for (let index of that.certificadosfiles) {
          var extensionpdf = index.name.substr( (index.name.lastIndexOf('.') +1) );
          if(extensionpdf.toUpperCase()!='PDF'){
            saveIt = false;
            that.loadingVisible = false;
            notify('No archivo "'+index.name+'" no es un archivo pdf, favor de reemplazarlo.', 'error', 10000);
          }
        }
        if(saveIt){
          if(that.NoCertificadoCarta){
            that.$refs['modal-3-1'].show();
            that.OC_PosicionesCertificadosyColadas(that.Contrato, that.Id_OrdenCompra, 0, that.NoCertificadoCarta, that.certificadosfiles[0].name);
            console.log(that.Proyecto);
            console.log(that.Contrato);
            console.log(that.IDUS);
            console.log(that.selTiposCertificado);
            console.log(that.NoCertificadoCarta);
            console.log(that.certificadosfiles[0].name);
            console.log(that.nombreUS+" "+that.apellidoUS);
            console.log(that.mail);
            console.log(that.Id_OrdenCompra);
          }else{
            that.loadingVisible = false;
            notify('No se especificó el Num. Certificado.', 'error', 5000);
          }
        }
      }else{
        that.loadingVisible = false;
        notify('No se ha cargado ningun archivo.', 'error', 5000);
      }
    },
    depTiposCertificado:function(e){
      this.selTiposCertificado = e.value;
    },
    depTiposMonedaPago:function(e){
      console.log(e.value);
      this.selMonedaPago = e.value;
			var MonedaData = this.JSONMonedaPago.filter(v => (v.Id_PagoSAP == e.value));
      console.log(MonedaData);
      if(e.value==0){
        //this.selOriginalFields = false;

        this.selSubtotal = (this.selSubtotalOriginal)?this.selSubtotalOriginal:0.00;
        this.selDescuento = (this.selDescuentoOriginal)?this.selDescuentoOriginal:0.00;
        this.selImpuestos = (this.selImpuestosOriginal)?this.selImpuestosOriginal:0.00;
        this.selImpuestosRetenidos = (this.selImpuestosRetenidosOriginal)?this.selImpuestosRetenidosOriginal:0.00;
        this.selISH = (this.selISHOriginal)?this.selISHOriginal:0.00;
        this.selTotal = (this.selTotalOriginal)?this.selTotalOriginal:0.00;
        this.TotalesConImpuesto[0].RemisionNumerico = this.TotalesConImpuesto[0].RemisionNumericoOriginal;
      }else{
        console.log("selSubtotalOriginal: " + this.selSubtotalOriginal);
        console.log("selDescuentoOriginal: " + this.selDescuentoOriginal);
        console.log("selImpuestosOriginal: " + this.selImpuestosOriginal);
        console.log("selImpuestosRetenidosOriginal: " + this.selImpuestosRetenidosOriginal);
        console.log("selISHOriginal: " + this.selISHOriginal);
        console.log("selTotalOriginal: " + this.selTotalOriginal);

        this.selSubtotal = parseFloat(this.selSubtotalOriginal)*parseFloat(MonedaData[0].TipoCambio);
        this.selDescuento = (parseFloat(this.selDescuentoOriginal)*parseFloat(MonedaData[0].TipoCambio))?parseFloat(this.selDescuentoOriginal)*parseFloat(MonedaData[0].TipoCambio):0;
        this.selImpuestos = parseFloat(this.selImpuestosOriginal)*parseFloat(MonedaData[0].TipoCambio);
        this.selISH = parseFloat(this.selISH)*parseFloat(MonedaData[0].TipoCambio);
        this.selImpuestosRetenidos = parseFloat(this.selImpuestosRetenidosOriginal)*parseFloat(MonedaData[0].TipoCambio);
        this.selTotal = parseFloat(this.selTotalOriginal)*parseFloat(MonedaData[0].TipoCambio);
        this.TotalesConImpuesto[0].RemisionNumerico = parseFloat(this.TotalesConImpuesto[0].RemisionNumericoOriginal)*parseFloat(MonedaData[0].TipoCambio);


        console.log("selSubtotal: " + this.selSubtotal);
        console.log("selDescuento: " + this.selDescuento);
        console.log("selImpuestos: " + this.selImpuestos);
        console.log("selImpuestosRetenidos: " + this.selImpuestosRetenidos);
        console.log("selISH: " + this.selISH);
        console.log("selTotal: " + this.selTotal);

        //this.selOriginalFields = true;
      }
      console.error(this.TotalesConImpuesto[0].Remision);
      console.error(this.TotalesConImpuesto[0].RemisionNumerico);
    },
    AsociarOC(data){
      var that = this;
      console.log(data);
      console.log(data.data.Id_Certificado);
      that.IdCertificado=data.data.Id_Certificado;
      that.TipoCertificado=data.data.Id_TipoCertificado;
      that.txtNombreArchivo = data.data.NombreArchivo;
      that.txtCertificado = data.data.Certificado;
      //that.HeaderPopUpCertificados31="OC: "+ that.txtOC +"        Certificado:"+ data.data.Certificado +"       Documento:"+data.data.NombreArchivo
      that.OC_PosicionesCertificadosyColadas(that.Contrato, that.Id_OrdenCompra, data.data.Id_Certificado);
    },
    OC_PosicionesCertificadosyColadas:function(Id_Contrato,Id_OrdenCompra, Id_Certificado, NombreCertificado=null, Documento=null){
      var that = this;
      if(!Id_Certificado){
        that.IdCertificado=0;
        //that.TipoCertificado=data.data.Id_TipoCertificado;
        that.txtNombreArchivo = Documento;
        that.txtCertificado = NombreCertificado;
      }


      apiClient.get('/api/Certificados/getOC_PosicionesCertificadosyColadas_XML', {
        params: { Id_Contrato: Id_Contrato, Id_OrdenCompra: Id_OrdenCompra, Id_Certificado: Id_Certificado, FormatoXML: false, Debug: 0 }
      })
      .then(function (response) {
        console.log(response.data);
        that.PosicionesCertificados = response.data;
        that.selectedRowKeys = that.PosicionesCertificados.filter(PosicionCertificado => PosicionCertificado.Checked === "1").map(PosicionCertificado => PosicionCertificado.Id_OrdenCompraSAP);
        that.$refs['modal-3-1'].show();
        that.loadingVisible = false;
      })
      .catch(function (error) {
        console.log('Error: ' + error);
      });
    },
    modalCertificadoPos(){
      var that = this;
      that.selectedRowKeys = [];
      console.log('hola');
      console.log(that.Id_OrdenCompra);
      console.log(that.txtOC);
    },
    onSelectionChanged({ selectedRowKeys, selectedRowsData, currentDeselectedRowKeys, currentSelectedRowKeys }) {//selectedRowKeys, selectedRowsData,
      var that = this;
      that.loadingVisible = true;
      console.log(selectedRowKeys);
      console.log(selectedRowsData);
      console.log(currentDeselectedRowKeys);
      console.log(currentSelectedRowKeys);
      if (!that.selectionChangedBySelectBox) {
        that.prefix = null;
      }

      if(currentDeselectedRowKeys.length){
          currentDeselectedRowKeys.forEach(element => that.PosicionesCertificados.filter(someobject => someobject.Id_OrdenCompraSAP == element && someobject.RowEnabled == 1).forEach(someobject => someobject.Checked = "0"));
          currentDeselectedRowKeys.forEach(element => that.PosicionesCertificados.filter(someobject => someobject.Id_OrdenCompraSAP == element && someobject.RowEnabled == 1).forEach(someobject => someobject.ColadaPorAutorizar = ""));
      }
      if(currentSelectedRowKeys.length){
          currentSelectedRowKeys.forEach(element => that.PosicionesCertificados.filter(someobject => someobject.Id_OrdenCompraSAP == element && someobject.RowEnabled == 1).forEach(someobject => someobject.Checked = "1"));
      }
      console.log(that.PosicionesCertificados)
      that.selectedRowKeys = this.PosicionesCertificados.filter(PosicionCertificado => PosicionCertificado.Checked === "1").map(PosicionCertificado => PosicionCertificado.Id_OrdenCompraSAP);
      that.loadingVisible = false;

      //console.log(getPosSelected(selectedRowsData,'arr'));
      //console.log(getPosSelected(selectedRowsData,'txt'));
      //that.selectedRowKeys = selectedRowKeys;
      //that.selectedRowKeystxt = getPosSelected(selectedRowsData,'txt');
    },
    onRowPrepared:function (info) {  
      if(info.rowType === 'data') {  
        if (info.data.RowEnabled == "0"){//  || this.TipoCertificado == 2 deshabilitar posiciones 
          info.rowElement.classList.add('nineteenthcentury');  
        }
      }
      //  console.log(info);
    },
    onEditingStart: function (info) {
      var that = this;
      //console.log(info);  
      //console.log(info.key);  
      if (info.data.RowEnabled == 0 || that.TipoCertificado == 2 ) {  
          info.cancel = true;  
      }
    },
    enviarCertificado(){
      var that = this;
      that.loadingVisible = true;
      setTimeout(function(){
        const datosGrid = that.$refs[that.dataGridRefName].instance;
        console.log(datosGrid.getDataSource());
        
        console.log(datosGrid.getDataSource()._store._array);
        var arr = jQuery.grep(datosGrid.getDataSource()._store._array, function( n, i ) {
          return ( n.Checked==1 && n.ColadaRequerida==1 && /*!n.ColadaPorAutorizar &&*/ n.RowEnabled!=0 );
        });
        console.log(arr);
        console.log(that.TipoCertificado);

        // 01-Sep-2026: AM (Claude). Reglas acordadas con Blas en la revision del 1-Sep-2026:
        //   1) no se puede enviar sin al menos una posicion seleccionada;
        //   2) TODA posicion seleccionada tiene que traer su colada — si son varias, separadas
        //      por coma. Textual: "todas las que tengan una selección, necesitas especificar la
        //      colada".
        // Antes esto no se validaba: la validacion vieja estaba comentada justo abajo (y su
        // filtro llevaba comentado tambien el !n.ColadaPorAutorizar, o sea que nunca miro la
        // colada), y la rama de asociar un certificado YA existente no validaba nada en absoluto,
        // asi que se podia amparar una posicion sin colada. Se valida aqui, antes de bifurcar,
        // para cubrir los dos caminos: alta nueva y asociacion de un certificado existente.
        var posicionesGrid = datosGrid.getDataSource()._store._array;
        var seleccionadas = jQuery.grep(posicionesGrid, function (n) {
          return (n.Checked == 1 || n.Checked == "1") && n.RowEnabled != 0;
        });
        if (seleccionadas.length === 0) {
          notify('Seleccione al menos una posición para asociarla al certificado.', 'warning', 10000);
          that.loadingVisible = false;
          return;
        }
        // Se respeta ColadaRequerida: si un material no la exige, no se pide. Hoy viene en 1 en
        // todas las posiciones de la OC, pero el campo existe y conviene no ignorarlo.
        var sinColada = jQuery.grep(seleccionadas, function (n) {
          if (n.ColadaRequerida != 1) { return false; }
          return !(n.ColadaPorAutorizar && String(n.ColadaPorAutorizar).trim() !== '');
        });
        if (sinColada.length > 0) {
          var posSinColada = jQuery.map(sinColada, function (n) { return n.Posicion; }).join(', ');
          notify('Falta la colada de la posición ' + posSinColada + '. Toda posición seleccionada debe indicar su colada; si son varias, sepárelas con coma.', 'warning', 15000);
          that.loadingVisible = false;
          return;
        }

        /*if(arr.length>=1 && that.TipoCertificado==1){
          notify('Favor de introducir la colada para cada elemento marcado haciendo click en la casilla de la colada/serie.', 'warning', 10000);
          that.loadingVisible = false;
        }else{*/
          if (that.IdCertificado==0) {
            var arrCompletados = jQuery.grep(datosGrid.getDataSource()._store._array, function( n, i ) {
              return ( n.Checked==1);
            });
            console.log(arrCompletados.length);
            if (arrCompletados.length==0) {
              notify('No se han seleccionado elementos para asignar al certificado cargado.', 'warning', 10000);
              that.loadingVisible = false;
            }else{
              apiClient.post('/api/Certificados/insCertificadoProveedor', {
                Id_Proyecto: that.Proyecto,
                Id_Contrato: that.Contrato,
                Id_TipoCertificado: that.selTiposCertificado,
                Certificado: escapeURI(that.NoCertificadoCarta, 'e'),
                NombreArchivo: escapeURI(that.certificadosfiles[0].name, 'e'),
                EnviadoPor: escapeURI(that.nombreUS+' '+that.apellidoUS, 'e'),
                CorreoRemitente: escapeURI(that.mail, 'e'),
                Id_OrdenCompra: that.Id_OrdenCompra,
                FormatoXML: false
              }, { withLenguaje: true })
              .then(function (response) {
                console.log(response.data);
                var moduloss = response.data;
                var typemsj = (moduloss[0].Estatus=='success' || moduloss[0].Estatus=='OK')?'success':'error';
                console.log(moduloss[0].Estatus);
                notify(moduloss[0].Mensaje, typemsj, 10000);
                if(moduloss[0].Estatus=='success' || moduloss[0].Estatus=='OK'){
                  var formData = new FormData();
                  formData.append('NombreArchivo', moduloss[0].NombreArchivo);
                  formData.append('BibliotecaSharepoint', moduloss[0].Biblioteca);
                  formData.append('PathSharepoint', moduloss[0].PathSharepoint);
                  formData.append('SitioSharepoint', moduloss[0].SitioSharepoint);
                  formData.append('ReemplazarArchivo', 'true');
                  formData.append('file', that.certificadosfiles[0]);
                  for (var pair of formData.entries()) {
                      console.log(pair[0]+ ', ' + pair[1]); 
                  }
                  console.log(formData);
                  apiClient.post('/api/SharePoint/subir-archivo-t', formData, { headers: { 'Content-Type': undefined }, onUploadProgress: function(e){ that.showUploadProgress = true; if(e.total){ that.uploadProgress = Math.round((e.loaded/e.total)*100); if(that.uploadProgress>=100){ setTimeout(function(){ that.showUploadProgress=false; },800); } } } }).then(function (response) {
                    console.log(formData);
                    console.log('exito');
                    console.log(response);
                    var isSuccess = (typeof response.data === 'string' && response.data.toLowerCase().includes('exitosamente')) || 
                                   (response.data && response.data.ERROR=="False");
                    if(isSuccess){
                      notify('Certificado guardado correctamente', 'success', 5000);
                    }else{
                      notify('Error al guardar certificado', 'error', 5000);
                    }
                    that.TipoCertificado=that.selTiposCertificado
                    that.txtNombreArchivo=moduloss[0].NombreArchivo;
                    that.txtCertificado=that.NoCertificadoCarta;
                    that.IdCertificado = moduloss[0].Id_Certificado;


                    var data = [];
                    datosGrid.getDataSource()._store._array.forEach(element => data.push({"Id_OrdenCompraSAP":element.Id_OrdenCompraSAP,"Selected":(element.Checked==1||element.Checked=="1")?1:0,"ColadaPorAutorizar":""+escapeURI(element.ColadaPorAutorizar.replaceAll("'",""),"e")+""}));
                    var EnviadoPor = ""+escapeURI(that.nombreUS+" "+that.apellidoUS,"e")+""
                    var CorreoRemitente = ""+escapeURI(that.mail,"e")+"";
                    that.updAsociarOC_Certificado(that.Proyecto, that.Contrato, that.IdCertificado, that.Id_OrdenCompra, EnviadoPor, CorreoRemitente, data);
                    
                    //that.$refs['modal-3-2'].hide();
                    //that.$refs['modal-3-1'].show();
                    //console.log(moduloss[0].Id_Certificado);
                    //that.OC_PosicionesCertificadosyColadas(that.Contrato, that.Id_OrdenCompra, moduloss[0].Id_Certificado);
                    //that.loadingVisible = false;
                  }).catch(function (response) {
                    console.log(response);
                    that.loadingVisible = false;
                    notify('Error al guardar pdf: msg->' + response.data.MSN, 'error', 10000);
                    that.loadingVisible = false;
                    //that.$refs['modal-3-2'].hide();
                    //that.$refs['modal-3-1'].show();
                  });
                }else{
                  that.loadingVisible = false;
                }
                //that.JSONTiposCertificado = response.data;
                //that.selTiposCertificado = response.data[0].Selected;
              })
              .catch(function (error) {
                console.log('Error: ' + error);
                that.loadingVisible = false;
              });
              /*console.log(that.Proyecto);
              console.log(that.Contrato);
              console.log(that.IDUS);
              console.log(that.selTiposCertificado);
              console.log(that.NoCertificadoCarta);
              console.log(that.certificadosfiles[0].name);
              console.log(that.nombreUS+" "+that.apellidoUS);
              console.log(that.mail);
              console.log(that.Id_OrdenCompra);*/
            }
          }else{
            var data = [];
            datosGrid.getDataSource()._store._array.forEach(element => data.push({"Id_OrdenCompraSAP":element.Id_OrdenCompraSAP,"Selected":(element.Checked==1||element.Checked=="1")?1:0,"ColadaPorAutorizar":""+escapeURI(element.ColadaPorAutorizar.replaceAll("'",""),"e")+""}));
            var EnviadoPor = ""+escapeURI(that.nombreUS+" "+that.apellidoUS,"e")+""
            var CorreoRemitente = ""+escapeURI(that.mail,"e")+"";
            that.updAsociarOC_Certificado(that.Proyecto, that.Contrato, that.IdCertificado, that.Id_OrdenCompra, EnviadoPor, CorreoRemitente, data);
            that.loadingVisible = false;
          }
        /*}*/
      }, 1000);
    },
    SendCertificate(Status){
      var that = this;
      apiClient.put('/api/Certificados/updOC_EnviarPosicionesCertificado', {
        Id_OrdenCompra: that.Id_OrdenCompra,
        Enviar: Status,
        FormatoXML: false
      }, { withLenguaje: true })
      .then(function (response) {
        console.log(response.data);
        that.RefreshFirstList();
      })
      .catch(function (error) {
        that.RefreshFirstList();
        notify(error.Mensaje , 'error', 10000);
        console.log(error);
      });
      console.log(Status);
      that.RefreshFirstList();
    },
    delDoc(val1,val2){
      var that = this;
      that.$bvModal.msgBoxConfirm('¿Desea eliminar este documento de la posición?', {
        title: 'Confirmación',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Eliminar',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          apiClient.delete('/api/Certificados/delOC_PosicionesCertificado', {
            data: { Id_Certificado: val1, Id_OrdenCompraSAP: val2, FormatoXML: false },
            withLenguaje: true
          })
          .then(function (response) {
            console.log(response.data);
            apiClient.get('/api/Certificados/getOC_PosicionesCertificadosyColadas_XML', {
              params: { Id_Contrato: that.Contrato, Id_OrdenCompra: that.Id_OrdenCompra, Id_Certificado: that.IdCertificado, FormatoXML: false, Debug: 0 }
            })
            .then(function (response) {
              console.log(response.data);
              that.PosicionesCertificados = response.data;
              that.selectedRowKeys = that.PosicionesCertificados.filter(p => p.Checked === "1").map(p => p.Id_OrdenCompraSAP);
              that.loadingVisible = false;
            })
            .catch(function (error) {
              console.log('Error: ' + error);
              that.loadingVisible = false;
            });
          })
          .catch(function (error) {
            notify(error.Mensaje , 'error', 10000);
            console.log(error);
          });
        }
        console.log(val1);
        console.log(val2);
      })
      .catch(err => {
        // An error occurred
        console.log('A ocurrido un error->');
        console.log(err);
      })
    },
    changeSelectionFacRem(e){//0Factura, 1Remision
      var that = this;
      const datosXMLFile = that.$refs[that.refXMLUploader].instance;
      that.selFacturaRemision = e.value.id;
      that.selISH=0;
      console.log(e.value.id);
      if(e.value.id==1){
        this.selMonedaPagoDisabled = true;
        this.selMonedaPago = "0";
        if(that.xmlfiles.length){
          //notify('Favor de eliminar el xml cargado para seleccionar Remisión', 'error', 7000);
          //that.selFacturaRemision = 0;
          this.xmlfiles=[];
          datosXMLFile.reset();
          this.xmlDisabled=true;
        }else{
          this.xmlfiles=[];
          datosXMLFile.reset();
          this.xmlDisabled=true;
        }
        if(that.PAISP=="MX"){//!Proveedor Nacional
          if(that.EsLlegadaASitio==1){//!Es llegada a sitio
            that.selDescuentoDisabled = true;
            that.selTotalDisabled = true;
          }else{//!Factura Normal
            if(e.value.id==0){//!Si es Factura
              that.selDescuentoDisabled = true;
              that.selTotalDisabled = true;
            }else{
              that.selDescuentoDisabled = false;
              that.selTotalDisabled = false;
            }
          }
        }else{//*Proveedor Internacional
          if(that.EsLlegadaASitio==1){//!Es llegada a sitio
            that.selDescuentoDisabled = true;
            that.selTotalDisabled = true;
          }else{//!Factura Normal
            if(e.value.id==0){//!Si es Factura
              if(that.TotalesConImpuesto[0].RemisionNumerico==0){//!Si no existe remision //that.TotalesConImpuesto[0].RemisionNumerico
                that.selDescuentoDisabled = false;
                that.selTotalDisabled = false;
              }else{
                that.selDescuentoDisabled = true;
                that.selTotalDisabled = true;
              }
            }else{
              that.selDescuentoDisabled = false;
              that.selTotalDisabled = false;
            }
          }
        }
      }else{
        this.xmlfiles=[];
        datosXMLFile.reset();
        this.selMonedaPagoDisabled = false;
        if(that.PAISP=="MX"){
          if(that.EsLlegadaASitio==1){
            const datosGrid = that.$refs[that.dataGridRefEntradas].instance;
            console.log(datosGrid.getDataSource());
            
            console.log(datosGrid.getDataSource()._store._array);
            that.xmlDisabled=(that.TotalesConImpuesto[0].RemisionNumerico==0)?false:true;
            that.selDescuentoDisabled = true;
            that.selTotalDisabled = true;
          }else{
            that.selDescuentoDisabled = (e.value.id==1)?false:true;
            that.selTotalDisabled = (e.value.id==1)?false:true;
            that.xmlDisabled=(that.TotalesConImpuesto[0].RemisionNumerico==0)?false:true;
          }
        }else{
          that.xmlDisabled=true;
          if(that.EsLlegadaASitio==1){//!Es llegada a sitio
            that.selDescuentoDisabled = true;
            that.selTotalDisabled = true;
          }else{//!Factura Normal
            if(e.value.id==0){//!Si es Factura
              if(that.TotalesConImpuesto[0].RemisionNumerico==0){//!Si no existe remision //that.TotalesConImpuesto[0].RemisionNumerico
                that.selDescuentoDisabled = false;
                that.selTotalDisabled = false;
              }else{
                that.selDescuentoDisabled = true;
                that.selTotalDisabled = true;
              }
              that.selDescuentoDisabled = true;
              that.selTotalDisabled = true;
            }else{
              that.selDescuentoDisabled = false;
              that.selTotalDisabled = false;
            }
          }
        }
      }
    },
    onShown() {
      console.log('Mostrando loader...');
    },
    onHidden() {
      console.log('Cerrando loader...');
    },
    modoDebug(){
        alert('Deveolp mode!');
    },
    updAsociarOC_Certificado:function(Id_Proyecto, Id_Contrato, Id_Certificado, Id_OrdenCompra, EnviadoPor, CorreoRemitente, data){
      var that = this;
      that.loadingVisible = true;
      var tblColadas = data.map(function(d) {
        return { Id_OrdenCompraSAP: d.Id_OrdenCompraSAP, Selected: d.Selected, Colada: d.ColadaPorAutorizar || '' };
      });
      apiClient.put('/api/Certificados/updAsociarOC_Certificado', {
        Id_Proyecto: Id_Proyecto,
        Id_Contrato: Id_Contrato,
        Id_Certificado: Id_Certificado,
        Id_OrdenCompra: Id_OrdenCompra,
        tblOrdenesCompraSAP_Coladas: tblColadas,
        EnviadoPor: EnviadoPor,
        CorreoRemitente: CorreoRemitente,
        Usuario: '',
        FormatoXML: false,
        Debug: 0
      }, { withLenguaje: true })
      .then(function (response) {
        var obj = response.data;
        console.log(obj);
        console.log(obj[0].Mensaje);
        if(obj[0].Estatus == "OK"){
          apiClient.get('/api/Certificados/getCertificadosProveedorOC', {
            params: { Id_Contrato: Id_Contrato, Id_OrdenCompra: Id_OrdenCompra, FormatoXML: false, Debug: 0 }
          })
          .then(function (response) {
            console.log(response.data);
            that.CertificadosProveedor = response.data;
            apiClient.get('/api/Certificados/getCertificadosProveedorOCposAsociadas', {
              params: { Id_Contrato: Id_Contrato, Id_OrdenCompra: Id_OrdenCompra, FormatoXML: false }
            })
            .then(function (respons) {
              console.log(respons.data);
              that.PosicionesAsociadas = respons.data[0].PosicionesAsociadas;
              that.loadingVisible = false;
              notify(obj[0].Mensaje, 'success', 10000);
            })
            .catch(function (error) {
              console.log('Error: ' + error);
              notify(obj[0].Mensaje, 'error', 10000);
              that.PosicionesAsociadas = "0 de 0";
              that.loadingVisible = false;
            });
          })
          .catch(function (error) {
            console.log('Error: ' + error);
            that.CertificadosProveedor = [];
            that.loadingVisible = false;
          });
          console.log('succes');
          that.$refs['modal-3-1'].hide();
          that.$refs['modal-3-2'].hide();
        }else{
          console.log(obj[0].Mensaje);
          notify(obj[0].Mensaje, 'error');
          console.log('error');
          that.loadingVisible = false;
        }
      })
      .catch(function (error) {
        console.log(error);
        that.loadingVisible = false;
      });
    },
    onSelectionChangedEntradas({ selectedRowKeys, selectedRowsData, currentDeselectedRowKeys, currentSelectedRowKeys }){
      var that = this;
      const datosXMLFile = that.$refs[that.refXMLUploader].instance;
      var TotalEntradas=0;
      var ImpuestosEntradas=0;
      var SubtotalEntradas=0;
      var Retenidos=0;
      that.selISH=0;
      that.selectedEntradasArray=[];
      that.selectedEntradasArray=selectedRowsData;
      that.visibleEntradasIDs = selectedRowKeys.slice();

      if(that.PAISP=="MX"){
        ///console.log(that.EsLlegadaASitio);
        if(that.EsLlegadaASitio==1){
          //that.xmlDisabled=(that.TotalesConImpuesto[0].RemisionNumerico==0 && selectedRowKeys.length && that.selFacturaRemision==0)?false:true;
          that.sendDisabled = (selectedRowKeys.length)?false:true;
          that.pdfDisabled = (selectedRowKeys.length)?false:true;
          that.xmlDisabled=(selectedRowKeys.length && that.selFacturaRemision==0)?false:true;
        }else{
          that.sendDisabled = false;
          that.pdfDisabled = false;
          that.xmlDisabled=false;
        }
      }else{
        that.sendDisabled = false;
        that.pdfDisabled = false;
        that.xmlDisabled=true;
      }
      selectedRowsData.forEach(function callback(currentValue, index, array) {
          console.log({currentValue,index,array})
          ImpuestosEntradas=parseFloat(ImpuestosEntradas)+parseFloat(currentValue.ImpuestosAFacturar);
          TotalEntradas=parseFloat(TotalEntradas)+parseFloat(currentValue.TotalAFacturar);
          SubtotalEntradas=parseFloat(SubtotalEntradas)+parseFloat(currentValue.SubtotalAFacturar);
          Retenidos=parseFloat(Retenidos)+parseFloat(currentValue.RetencionFondoGarantia)+parseFloat(currentValue.RetencionImpuesto);
      });

      if(that.xmlfiles.length){
        //that.xmlfiles=[];
        that.selNumFactura = "";
        that.selFechaFacturaStr = new Date();
        that.selFechaFacturaDisable = false;
        that.selUUID = null;
        that.selSerie= null;
        that.selVersionCFDI= null;
        that.selSello= null;
        that.selRFC_Emisor = null;
        that.selRFC_Receptor = null;
        that.selNumFactura = null;
        notify('Se ha modificado las entradas teniendo una factura cargada, favor de cargar el xml correspondiente a los nuevos valores.','error',8000);
        datosXMLFile.reset();
        that.selDescuento = 0.00;

      }

      console.log(TotalEntradas);
      that.TotalesConImpuesto[0].PorFacturarNumerico=(TotalEntradas>=0)?TotalEntradas:0.00;
      console.log(that.TotalesConImpuesto[0].PorFacturarNumerico);
      that.selImpuestos=(ImpuestosEntradas>=0)?ImpuestosEntradas:0.00;
      that.selSubtotal=(SubtotalEntradas>=0)?SubtotalEntradas:0.00;
      that.selImpuestosRetenidos=(Retenidos>=0)?Retenidos:0.00;
     // that.selTotal=(TotalEntradas>=0)?TotalEntradas:0.00;
      var TotalSinRetenidos = (TotalEntradas>=0)?TotalEntradas:0.00;
      that.selTotal=TotalSinRetenidos;
      //-that.selImpuestosRetenidos;


      var MonedaData = this.JSONMonedaPago.filter(v => (v.Id_PagoSAP == that.selMonedaPago));
      console.log(MonedaData);
      that.selImpuestosOriginal = (ImpuestosEntradas>=0)?ImpuestosEntradas:0.00;
      that.selSubtotalOriginal = (SubtotalEntradas>=0)?SubtotalEntradas:0.00;
      that.selImpuestosRetenidosOriginal = (Retenidos>=0)?Retenidos:0.00;
      that.selTotalOriginal = TotalSinRetenidos;//-that.selImpuestosRetenidos;
      if(that.selMonedaPago>=1){
        this.selSubtotal = (SubtotalEntradas>=0)?SubtotalEntradas*parseFloat(MonedaData[0].TipoCambio):0.00;
        this.selImpuestos = (ImpuestosEntradas>=0)?ImpuestosEntradas*parseFloat(MonedaData[0].TipoCambio):0.00;
        this.selImpuestosRetenidos = (Retenidos>=0)?Retenidos*parseFloat(MonedaData[0].TipoCambio):0.00;
        this.selTotal = (TotalSinRetenidos/*-that.selImpuestosRetenidos*/)*parseFloat(MonedaData[0].TipoCambio);
      }

      if(localStorage.getItem('PEI')==0 && localStorage.getItem('FSF')==0){
        that.sendDisabled = true;
        that.showMensajeNoEnviar = true;
      }else{
        that.showMensajeNoEnviar = false;
      }

      console.log(selectedRowKeys);
      console.log(selectedRowsData);
      console.log(currentDeselectedRowKeys);
      console.log(currentSelectedRowKeys);
    },
    onRowPreparedEntradas:function (info) {
      //console.log(info);  
      /*if(info.rowType === 'data') {  
        if (info.data.RowEnabled == "0"){//  || this.TipoCertificado == 2 deshabilitar posiciones 
          info.rowElement.classList.add('nineteenthcenturys');  
        }
      }*/
      //  console.log(info);
    },
    keyUpSubtotal: function(event){
      console.log(event);
      console.log('keyUpDescuento');
      var that = this;
      console.log(that.FacRem);
      console.log(
        {
          EsLlegadaASitio:that.EsLlegadaASitio,
          selSubtotal:that.selSubtotal,
          selDescuento:that.selDescuento,
          selTotal:that.selTotal,
          selImpuestosRetenidos:that.selImpuestosRetenidos
        }
      );
      if(that.EsLlegadaASitio!=1){
        if(that.selFacturaRemision==1){
          that.minTotal = (that.EsLlegadaASitio==1)?0:(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento));
          that.minDesc = (parseFloat(that.selSubtotal)-parseFloat(that.selTotal)<=0)?0:(parseFloat(that.selSubtotal)-parseFloat(that.selTotal));
          that.maxImpRet = parseFloat(parseFloat(parseFloat(that.selTotal)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2));
          that.selImpuestos = parseFloat(parseFloat(parseFloat(that.selTotal)-parseFloat(that.selImpuestosRetenidos)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2));
        }
      }
      console.log({minTotal:that.minTotal,minDesc:that.minDesc,maxImpRet:that.maxImpRet,selImpuestos:that.selImpuestos});
    },
    keyUpDescuento: function(event) {
      console.log('keyUpDescuento');
      var that = this;
      if(that.EsLlegadaASitio!=1){
        if(that.selFacturaRemision==1){
          that.maxImpRet = parseFloat(parseFloat(parseFloat(that.selTotal)-(parseFloat(that.selSubtotal)-parseFloat(event.value))).toFixed(2));
          that.selImpuestos = parseFloat(parseFloat(parseFloat(that.selTotal)-parseFloat(that.selImpuestosRetenidos)-(parseFloat(that.selSubtotal)-parseFloat(event.value))).toFixed(2));
          console.log({minTotal:that.minTotal,minDesc:that.minDesc,maxImpRet:that.maxImpRet,selImpuestos:that.selImpuestos});
        }
      }
    },
    changeDescuento: function(event) {
      console.log('changeDescuento');
      var that = this;
      if(that.EsLlegadaASitio!=1){
        that.maxImpRet = parseFloat(parseFloat(parseFloat(that.selTotal)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2));
        that.selImpuestos = parseFloat(parseFloat(parseFloat(that.selTotal)-parseFloat(that.selImpuestosRetenidos)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2));
        console.log({minTotal:that.minTotal,minDesc:that.minDesc,maxImpRet:that.maxImpRet,selImpuestos:that.selImpuestos});
        /*console.log(that.selDescuento);
        console.log(parseFloat(parseFloat(parseFloat(that.selTotal)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2)));
        console.log({
          Subtotal:that.selSubtotal,
          Descuento:that.selDescuento,
          Impuesto:that.selImpuestos,
          Total:that.selTotal
        })*/
      }
    },
    keyUpImpuestosRetenidos: function(event) {
      console.log('keyUpImpuestosRetenidos');
      var that = this;
      if(that.EsLlegadaASitio!=1){
        if(that.selFacturaRemision==1){
          that.selImpuestos = parseFloat(parseFloat(parseFloat(that.selTotal)-parseFloat(event.value)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2));
        }
        /*console.log(event.value);
        console.log(parseFloat(parseFloat(parseFloat(that.selTotal)-(parseFloat(that.selSubtotal)-parseFloat(event.value))).toFixed(2)));
        console.log({
          Subtotal:that.selSubtotal,
          Descuento:event.value,
          Impuesto:that.selImpuestos,
          Total:that.selTotal
        })*/
      }
    },
    changeImpuestosRetenidos: function(event) {
      console.log('changeImpuestosRetenidos');
      var that = this;
      if(that.EsLlegadaASitio!=1){
        that.selImpuestos = parseFloat(parseFloat(parseFloat(that.selTotal)-parseFloat(that.selImpuestosRetenidos)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2));
        /*console.log(that.selDescuento);
        console.log(parseFloat(parseFloat(parseFloat(that.selTotal)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2)));
        console.log({
          Subtotal:that.selSubtotal,
          Descuento:that.selDescuento,
          Impuesto:that.selImpuestos,
          Total:that.selTotal
        })*/
      }
    },
    keyUpTotal: function(event) {
      var that = this;
      console.log('keyUpTotal');
      //console.log(event);
      console.log(
        {
          EsLlegadaASitio:that.EsLlegadaASitio,
          selSubtotal:that.selSubtotal,
          selDescuento:that.selDescuento,
          selTotal:that.selTotal,
          selImpuestosRetenidos:that.selImpuestosRetenidos,
          keyupTotal:event.value
        }
      );
      if(that.EsLlegadaASitio!=1){
        if(that.selFacturaRemision==1){
          that.minTotal = (that.EsLlegadaASitio==1)?0:(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento));
          that.minDesc = (parseFloat(that.selSubtotal)-parseFloat(event.value)<=0)?0:(parseFloat(that.selSubtotal)-parseFloat(event.value));
          that.maxImpRet = parseFloat(parseFloat(parseFloat(event.value)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2));
          that.selImpuestos = parseFloat(parseFloat(parseFloat(event.value)-parseFloat(that.selImpuestosRetenidos)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2));
        }else{
          //* Factura normal / partidas: el Subtotal sigue al Total mientras se escribe. Sin descuento ni impuestos forzados.
          var vTotal = parseFloat(event.value);
          if(!isNaN(vTotal)){
            that.selSubtotal=vTotal;    that.maxSub=vTotal;
            that.selDescuento=0;    that.minDesc=0;   that.maxDesc=0;
            that.selImpuestos=0;
            that.selImpuestosRetenidos=0;    that.minImpRet=0;   that.maxImpRet=0;
          }
        }
        console.log({minTotal:that.minTotal,minDesc:that.minDesc,maxImpRet:that.maxImpRet,selImpuestos:that.selImpuestos});
        /*console.log(parseFloat(parseFloat(parseFloat(event.value)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2)));
        console.log({
          Subtotal:that.selSubtotal,
          Descuento:that.selDescuento,
          Impuesto:that.selImpuestos,
          Total:event.value
        });*/
      }
    },
    changeTotal: function(event) {
      console.log('changeTotal');
      var that = this;
      if(that.EsLlegadaASitio!=1){
        //console.log(that.selTotal);
        if(that.selFacturaRemision==1){
          //* Modo Remision: el Total debe ser >= subtotal-descuento; el descuento cuadra el desglose de la remision.
          that.minTotal=parseFloat(that.selSubtotal)-parseFloat(that.selDescuento);
          that.minDesc = (parseFloat(that.selSubtotal)-parseFloat(that.selTotal)<=0)?0:(parseFloat(that.selSubtotal)-parseFloat(that.selTotal));
          that.maxImpRet = parseFloat(parseFloat(parseFloat(that.selTotal)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2));
          that.selImpuestos = parseFloat(parseFloat(parseFloat(that.selTotal)-parseFloat(that.selImpuestosRetenidos)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2));
        }else{
          //* Factura normal / partidas (parcial permitido): el Subtotal sigue al Total. Sin relleno por descuento ni impuestos forzados.
          that.minTotal=1;
          that.selSubtotal=parseFloat(that.selTotal);
          that.maxSub=parseFloat(that.selTotal);
          that.selDescuento=0;    that.minDesc=0;   that.maxDesc=0;
          that.selImpuestos=0;
          that.selImpuestosRetenidos=0;    that.minImpRet=0;   that.maxImpRet=0;
        }
        console.log({minTotal:that.minTotal,minDesc:that.minDesc,maxImpRet:that.maxImpRet,selImpuestos:that.selImpuestos});
        /*console.log(parseFloat(parseFloat(parseFloat(that.selTotal)-(parseFloat(that.selSubtotal)-parseFloat(that.selDescuento))).toFixed(2)));
        console.log({
          Subtotal:that.selSubtotal,
          Descuento:that.selDescuento,
          Impuesto:that.selImpuestos,
          Total:that.selTotal
        })*/
      }
    },
    CloseModal: function(){
      var that=this;
      that.$refs['modal-6'].hide();
      that.$refs['modal-7'].hide();
    },
    modalBuscarOC(){
      var that = this;
      console.log(this.OrdenCompraBusqueda);
      if(that.OrdenCompraBusqueda){
        that.MostrarMotivo=false;
        that.MotivoOC=null;
        that.MotivoOCStyle=false;
        that.loadingVisible = true;
        apiClient.get('/api/General/getValidaExistenciaOC', {
          params: { OC: that.OrdenCompraBusqueda, FormatoXML: false },
          withLenguaje: true
        })
        .then(function (response) {
          console.log(response.data);
          console.log(response.data[0].Estatus);
          if(response.data[0].Estatus=="ERROR"){
            that.MotivoOCStyle = true;
          }else if(response.data[0].Estatus=="OK"){
            that.MotivoOCStyle = false;
          }
          that.MotivoOC = response.data[0].Mensaje;
          that.MostrarMotivo=true;
          that.loadingVisible = false;
        })
        .catch(function (error) {
          that.MotivoOC = "";
          that.MostrarMotivo=false;
          console.log('Error: ' + error);
          that.loadingVisible = false;
        });
      }else{
        notify("Favor de introducir la orden de compra para su busqueda.", 'warning', 10000);
      }
    }
  }/*,
  watch: {
    selDescuento(val) {
      console.log(val);
      //verifyPassword(val, this.selConfirmarContrasena);
      //this.answer = `Inputted: ${val}`;
    },
  }*/
}
</script>
<style scoped>
/* Overlay de progreso de carga (centrado) */
.cc-progress-overlay{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}
.cc-progress-card{
  background: #fff;
  border-radius: 14px;
  padding: 26px 34px;
  box-shadow: 0 10px 30px rgba(0,0,0,.25);
  min-width: 340px;
  max-width: 90%;
  text-align: center;
}
.cc-progress-label{
  margin: 0 0 14px;
  font-size: 15px;
  color: #333;
}
.cc-progress-track{
  height: 24px;
  border-radius: 50px;
  background: #e9ecef;
  overflow: hidden;
  border: 1px solid #d0d4d9;
}
.cc-progress-fill{
  height: 100%;
  border-radius: 50px;
  min-width: 6%;
  background-image: repeating-linear-gradient(45deg,#34c759 0,#34c759 12px,#2faa4d 12px,#2faa4d 24px);
  background-size: 48px 48px;
  animation: cc-stripes 1s linear infinite;
  transition: width .25s ease;
}
@keyframes cc-stripes{
  from{ background-position: 0 0; }
  to{ background-position: 48px 0; }
}

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl, .col-xl-auto{
  display: inline-block;
}
.span-label{
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: lighter;
  line-height: 1.5;
  color: #212529;
  text-align: left;
}
.dx-datagrid-headers{
  font-weight: bold;
}
.selector_action{
  height: 24px;
  padding: 0px 0px;
}
.list-certificados{
  padding-left: 25px;
  font-weight: lighter;
}
.list-certificados li{
  list-style: number;
}
.EntradaSalidaOculto{display: none;}
.EntradaSalidaMostrar{display: block !important;}
</style>
